webpackJsonp([0],{

/***/ 1033:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(134);
__webpack_require__(567);
var React = __webpack_require__(3);
var ReactDOM = __webpack_require__(24);
var AppContainer_1 = __webpack_require__(565);
__webpack_require__(566);
ReactDOM.render(React.createElement(AppContainer_1.default, null), document.getElementById('app'));


/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = __webpack_require__(52);
var hardwareDataService_1 = __webpack_require__(642);
exports.SERVER_GET_REQUEST = 'SERVER_GET_REQUEST';
exports.SERVER_GET_SUCCESS = 'SERVER_GET_SUCCESS';
exports.SERVER_GET_ERROR = 'SERVER_GET_ERROR';
exports.SERVER_ADD_REQUEST = 'SERVER_ADD_REQUEST';
exports.SERVER_EDIT_ROW = 'SERVER_EDIT_ROW';
exports.SERVER_UPDATE_REQUEST = 'SERVER_UPDATE_REQUEST';
exports.SERVER_UPDATE_SUCCESS = 'SERVER_UPDATE_SUCCESS';
exports.SERVER_UPDATE_ERROR = 'SERVER_UPDATE_ERROR';
exports.SERVER_DELETE_REQUEST = 'SERVER_DELETE_REQUEST';
exports.SERVER_DELETE_SUCCESS = 'SERVER_DELETE_SUCCESS';
exports.SERVER_DELETE_ERROR = 'SERVER_DELETE_ERROR';
exports.SERVER_DESCRIPTION_UPDATE = 'SERVER_DESCRIPTION_UPDATE';
exports.SERVER_SERVERID_UPDATE = 'SERVER_SERVERID_UPDATE';
exports.SERVER_OPERATIONAL_UPDATE = 'SERVER_OPERATIONAL_UPDATE';
exports.SERVER_RESET_CURRENTLY_EDITING = 'SERVER_RESET_CURRENTLY_EDITING';
exports.SERVER_CANCEL_EDITING = 'SERVER_CANCEL_EDITING';
exports.OPERATIONAL_USAGE_GET_REQUEST = 'OPERATIONAL_USAGE_GET_REQUEST';
exports.OPERATIONAL_USAGE_GET_SUCCESS = 'OPERATIONAL_USAGE_GET_SUCCESS';
exports.OPERATIONAL_USAGE_GET_ERROR = 'OPERATIONAL_USAGE_GET_ERROR';
exports.SERVER_CLEAR_ERROR = 'SERVER_CLEAR_ERROR';
function onServerGetRequest(siteId, accessToken) {
    return function (dispatch) {
        makeServerGetRequest(dispatch, siteId, accessToken);
    };
}
exports.onServerGetRequest = onServerGetRequest;
function onOperationalUsagesGetRequest(accessToken) {
    return function (dispatch) {
        makeOperationalUsagesGetRequest(dispatch, accessToken);
    };
}
exports.onOperationalUsagesGetRequest = onOperationalUsagesGetRequest;
function onServerResponseSuccess(site) {
    return {
        type: exports.SERVER_GET_SUCCESS,
        server: site.server,
        services: site.services
    };
}
exports.onServerResponseSuccess = onServerResponseSuccess;
function onOperationalUsagesResponseSuccess(operationalUsages) {
    return {
        type: exports.OPERATIONAL_USAGE_GET_SUCCESS,
        operationalUsages: operationalUsages
    };
}
exports.onOperationalUsagesResponseSuccess = onOperationalUsagesResponseSuccess;
function onServerResponseError() {
    return {
        type: exports.SERVER_GET_ERROR,
        text: 'Error receiving data'
    };
}
exports.onServerResponseError = onServerResponseError;
function onOperationalUsagesResponseError() {
    return {
        type: exports.OPERATIONAL_USAGE_GET_ERROR,
        text: 'Error receiving data'
    };
}
exports.onOperationalUsagesResponseError = onOperationalUsagesResponseError;
function onAddNewEditableRow(server, siteId) {
    return function (dispatch) {
        dispatch({
            type: exports.SERVER_RESET_CURRENTLY_EDITING,
            server: server
        });
        dispatch({
            type: exports.SERVER_ADD_REQUEST,
            server: server,
            newServer: new models_1.Server(siteId)
        });
    };
}
exports.onAddNewEditableRow = onAddNewEditableRow;
function onEditExistingRow(server) {
    return function (dispatch) {
        dispatch({
            type: exports.SERVER_RESET_CURRENTLY_EDITING,
            server: server
        });
        dispatch({
            type: exports.SERVER_EDIT_ROW,
            serverToEdit: server
        });
    };
}
exports.onEditExistingRow = onEditExistingRow;
function onUpdateServer(server, accessToken) {
    return function (dispatch) {
        dispatch({ type: exports.SERVER_UPDATE_REQUEST, serverToUpdate: server });
        makeServerPutRequest(dispatch, server, accessToken);
    };
}
exports.onUpdateServer = onUpdateServer;
function onUpdateServerResponseSuccess(siteId, accessToken) {
    return function (dispatch) {
        makeServerGetRequest(dispatch, siteId, accessToken);
    };
}
exports.onUpdateServerResponseSuccess = onUpdateServerResponseSuccess;
function onUpdateServerResponseError() {
    return {
        type: exports.SERVER_UPDATE_ERROR,
        text: 'Error receiving data'
    };
}
exports.onUpdateServerResponseError = onUpdateServerResponseError;
function onDeleteServer(server, accessToken) {
    return function (dispatch) {
        dispatch({ type: exports.SERVER_DELETE_REQUEST, serverToDelete: server });
        makeServerDeleteRequest(dispatch, server, accessToken);
    };
}
exports.onDeleteServer = onDeleteServer;
function onDeleteServerResponseSuccess(server) {
    return function (dispatch) {
        dispatch({
            type: exports.SERVER_DELETE_SUCCESS,
            server: server
        });
    };
}
exports.onDeleteServerResponseSuccess = onDeleteServerResponseSuccess;
function onDeleteServerResponseError() {
    return {
        type: exports.SERVER_DELETE_ERROR,
        text: 'Error receiving data'
    };
}
exports.onDeleteServerResponseError = onDeleteServerResponseError;
function makeServerGetRequest(dispatch, siteId, accessToken) {
    dispatch({ type: exports.SERVER_GET_REQUEST });
    return hardwareDataService_1.requestServerGet(siteId, accessToken).then(function (success) { return dispatch(onServerResponseSuccess(success)); }, function (error) { return dispatch(onServerResponseError()); });
}
exports.makeServerGetRequest = makeServerGetRequest;
function makeOperationalUsagesGetRequest(dispatch, accessToken) {
    dispatch({ type: exports.OPERATIONAL_USAGE_GET_REQUEST });
    return hardwareDataService_1.requestOperationalUsageGet(accessToken).then(function (success) { return dispatch(onOperationalUsagesResponseSuccess(success)); }, function (error) { return dispatch(onOperationalUsagesResponseError()); });
}
exports.makeOperationalUsagesGetRequest = makeOperationalUsagesGetRequest;
function makeServerPutRequest(dispatch, server, accessToken) {
    var serverUpdateOrAdd = server.id === -1 ? hardwareDataService_1.requestServerPost(server, accessToken) : hardwareDataService_1.requestServerPut(server, accessToken);
    return serverUpdateOrAdd.then(function (success) {
        return dispatch(onUpdateServerResponseSuccess(server.siteId, accessToken));
    }, function (error) {
        return dispatch(onUpdateServerResponseError());
    });
}
exports.makeServerPutRequest = makeServerPutRequest;
function onServerDescriptionEdit(newDescription) {
    return {
        type: exports.SERVER_DESCRIPTION_UPDATE,
        newDescription: newDescription
    };
}
exports.onServerDescriptionEdit = onServerDescriptionEdit;
function onServerServerIdEdit(newServerId) {
    return {
        type: exports.SERVER_SERVERID_UPDATE,
        newServerId: newServerId
    };
}
exports.onServerServerIdEdit = onServerServerIdEdit;
function onServerOperationalUseChange(value) {
    return {
        type: exports.SERVER_OPERATIONAL_UPDATE,
        value: value
    };
}
exports.onServerOperationalUseChange = onServerOperationalUseChange;
function makeServerDeleteRequest(dispatch, server, accessToken) {
    return hardwareDataService_1.requestServerDelete(server, accessToken).then(function (success) {
        return dispatch(onDeleteServerResponseSuccess(success));
    }, function (error) {
        return dispatch(onDeleteServerResponseError());
    });
}
exports.makeServerDeleteRequest = makeServerDeleteRequest;
function onServerCancelEdit(server) {
    return function (dispatch) {
        dispatch({
            type: exports.SERVER_CANCEL_EDITING,
            serverPreEdit: server
        });
    };
}
exports.onServerCancelEdit = onServerCancelEdit;
function clearErrorMessage() {
    return function (dispatch) {
        dispatch({ type: exports.SERVER_CLEAR_ERROR });
    };
}
exports.clearErrorMessage = clearErrorMessage;


/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = __webpack_require__(52);
var servicesDataService_1 = __webpack_require__(644);
var hardwareActionCreators = __webpack_require__(104);
exports.ALLOCATION_GET_REQUEST = 'SERVICE_GET_REQUEST';
exports.ALLOCATION_GET_SUCCESS = 'SERVICE_GET_SUCCESS';
exports.ALLOCATION_GET_ERROR = 'SERVICE_GET_ERROR';
exports.ALLOCATION_NEW_REQUEST = 'ALLOCATION_NEW_REQUEST';
exports.ALLOCATION_NEW_SUCCESS = 'ALLOCATION_NEW_SUCCESS';
exports.ALLOCATION_NEW_ERROR = 'ALLOCATION_NEW_ERROR';
exports.ALLOCATION_ADD_REQUEST = 'ALLOCATION_ADD_REQUEST';
exports.ALLOCATION_ADD_SUCCESS = 'ALLOCATION_ADD_SUCCESS';
exports.ALLOCATION_ADD_ERROR = 'ALLOCATION_ADD_ERROR';
exports.ALLOCATION_UPDATE_REQUEST = 'ALLOCATION_UPDATE_REQUEST';
exports.ALLOCATION_UPDATE_SUCCESS = 'ALLOCATION_UPDATE_SUCCESS';
exports.ALLOCATION_UPDATE_ERROR = 'ALLOCATION_UPDATE_ERROR';
exports.ALLOCATION_CANCEL_REQUEST = 'ALLOCATION_CANCEL_REQUEST';
exports.ALLOCATION_DELETE_REQUEST = 'ALLOCATION_DELETE_REQUEST';
exports.ALLOCATION_DELETE_SUCCESS = 'ALLOCATION_DELETE_SUCCESS';
exports.ALLOCATION_DELETE_ERROR = 'ALLOCATION_DELETE_ERROR';
exports.ALLOCATION_EDITABLE_ROW_ADD = 'ALLOCATION_EDITABLE_ROW_ADD';
exports.ALLOCATION_EDIT_ROW = 'ALLOCATION_EDIT_ROW';
exports.ALLOCATION_EDIT_ROW_SUCCESS = 'ALLOCATION_EDIT_ROW_SUCCESS';
exports.ALLOCATION_RESET_CURRENTLY_EDITING = 'ALLOCATION_RESET_CURRENTLY_EDITING';
exports.ALLOCATION_CANCEL_EDITING = 'ALLOCATION_CANCEL_EDITING';
exports.ALLOCATION_CLEAR_ERROR = 'ALLOCATION_CLEAR_ERROR';
function onAllocationGetRequest(siteId, accessToken) {
    return function (dispatch) {
        makeAllocationGetRequest(dispatch, siteId, accessToken);
    };
}
exports.onAllocationGetRequest = onAllocationGetRequest;
function makeAllocationGetRequest(dispatch, siteId, accessToken) {
    dispatch({ type: exports.ALLOCATION_GET_REQUEST });
    return servicesDataService_1.requestAllocationGet(siteId, accessToken).then(function (success) {
        dispatch(onAllocationGetResponseSuccess(success));
    }, function (error) {
        dispatch(onAllocationGetResponseError());
    });
}
exports.makeAllocationGetRequest = makeAllocationGetRequest;
function onAllocationGetResponseSuccess(siteInfo) {
    return {
        type: exports.ALLOCATION_GET_SUCCESS,
        siteInfo: siteInfo
    };
}
exports.onAllocationGetResponseSuccess = onAllocationGetResponseSuccess;
function onAllocationGetResponseError() {
    return {
        type: exports.ALLOCATION_GET_ERROR,
        text: 'Error receiving data'
    };
}
exports.onAllocationGetResponseError = onAllocationGetResponseError;
function onNewAllocationGetRequest(siteId, accessToken) {
    return function (dispatch) {
        makeNewAllocationGetRequest(dispatch, siteId, accessToken);
    };
}
exports.onNewAllocationGetRequest = onNewAllocationGetRequest;
function makeNewAllocationGetRequest(dispatch, siteId, accessToken) {
    dispatch({ type: exports.ALLOCATION_NEW_REQUEST });
    return servicesDataService_1.requestNewAllocationGet(siteId, accessToken).then(function (success) {
        dispatch(onNewAllocationGetResponseSuccess(success));
    }, function (error) {
        dispatch(onNewAllocationGetResponseError());
    });
}
exports.makeNewAllocationGetRequest = makeNewAllocationGetRequest;
function onNewAllocationGetResponseSuccess(serviceOptions) {
    return {
        type: exports.ALLOCATION_NEW_SUCCESS,
        serviceOptions: serviceOptions
    };
}
exports.onNewAllocationGetResponseSuccess = onNewAllocationGetResponseSuccess;
function onNewAllocationGetResponseError() {
    return {
        type: exports.ALLOCATION_NEW_ERROR,
        text: 'Error receiving data'
    };
}
exports.onNewAllocationGetResponseError = onNewAllocationGetResponseError;
function onAddAllocation(allocation, accessToken) {
    return function (dispatch) {
        makeAllocationPostRequest(dispatch, allocation, accessToken);
    };
}
exports.onAddAllocation = onAddAllocation;
function makeAllocationPostRequest(dispatch, allocation, accessToken) {
    dispatch({ type: exports.ALLOCATION_ADD_REQUEST, allocation: allocation });
    return servicesDataService_1.requestAllocationPost(allocation, accessToken).then(function (success) {
        dispatch({
            type: exports.ALLOCATION_RESET_CURRENTLY_EDITING,
            success: success
        });
        dispatch(onAddAllocationResponseSuccess(success));
    }, function (error) {
        return dispatch(onAddAllocationResponseError());
    });
}
exports.makeAllocationPostRequest = makeAllocationPostRequest;
function onAddAllocationResponseSuccess(allocation) {
    return {
        type: exports.ALLOCATION_ADD_SUCCESS,
        allocation: allocation
    };
}
exports.onAddAllocationResponseSuccess = onAddAllocationResponseSuccess;
function onAddAllocationResponseError() {
    return {
        type: exports.ALLOCATION_ADD_ERROR,
        text: 'Error receiving data'
    };
}
exports.onAddAllocationResponseError = onAddAllocationResponseError;
function onAddNewEditableRow(allocations, siteId, accessToken) {
    return function (dispatch) {
        dispatch({
            type: exports.ALLOCATION_RESET_CURRENTLY_EDITING,
            allocations: allocations
        });
        dispatch({
            type: exports.ALLOCATION_EDITABLE_ROW_ADD,
            newAllocation: new models_1.Allocation(siteId)
        });
    };
}
exports.onAddNewEditableRow = onAddNewEditableRow;
function onCancelAllocationEdit(allocation) {
    return function (dispatch) {
        dispatch({
            type: exports.ALLOCATION_RESET_CURRENTLY_EDITING,
            allocation: allocation
        });
        dispatch({
            type: exports.ALLOCATION_CANCEL_EDITING,
            allocation: allocation
        });
    };
}
exports.onCancelAllocationEdit = onCancelAllocationEdit;
function onEditExistingRow(allocation, siteId, accessToken) {
    return function (dispatch) {
        dispatch({
            type: exports.ALLOCATION_RESET_CURRENTLY_EDITING,
            allocation: allocation
        });
        dispatch({ type: exports.ALLOCATION_EDIT_ROW, allocationToEdit: allocation });
        makeAllocationEditRequest(dispatch, siteId, accessToken);
    };
}
exports.onEditExistingRow = onEditExistingRow;
function onAllocationEditResponseSuccess(licenseAllowances) {
    return {
        type: exports.ALLOCATION_EDIT_ROW_SUCCESS,
        licenseAllowances: licenseAllowances
    };
}
exports.onAllocationEditResponseSuccess = onAllocationEditResponseSuccess;
function onAllocationEditResponseError() {
    return {
        type: exports.ALLOCATION_GET_ERROR,
        text: 'Error receiving data'
    };
}
exports.onAllocationEditResponseError = onAllocationEditResponseError;
function makeAllocationEditRequest(dispatch, siteId, accessToken) {
    dispatch({ type: exports.ALLOCATION_GET_REQUEST });
    return servicesDataService_1.requestAllocationGet(siteId, accessToken).then(function (success) { return dispatch(onAllocationEditResponseSuccess(success)); }, function (error) { return dispatch(onAllocationEditResponseError()); });
}
exports.makeAllocationEditRequest = makeAllocationEditRequest;
function onCancelAddAllocation() {
    return function (dispatch) {
        dispatch({ type: exports.ALLOCATION_CANCEL_REQUEST });
    };
}
exports.onCancelAddAllocation = onCancelAddAllocation;
function onUpdateAllocation(allocation, accessToken) {
    return function (dispatch) {
        dispatch({ type: exports.ALLOCATION_UPDATE_REQUEST, allocationToUpdate: allocation });
        makeAllocationPutRequest(dispatch, allocation, accessToken);
    };
}
exports.onUpdateAllocation = onUpdateAllocation;
function makeAllocationPutRequest(dispatch, allocation, accessToken) {
    return servicesDataService_1.requestAllocationPut(allocation, accessToken).then(function (success) {
        return dispatch(onUpdateAllocationResponseSuccess(success, allocation));
    }, function (error) {
        return dispatch(onUpdateAllocationResponseError());
    });
}
exports.makeAllocationPutRequest = makeAllocationPutRequest;
function onUpdateAllocationResponseSuccess(allocation, allocationToUpdate) {
    return {
        type: exports.ALLOCATION_UPDATE_SUCCESS,
        allocation: allocation,
        allocationToUpdate: allocationToUpdate
    };
}
exports.onUpdateAllocationResponseSuccess = onUpdateAllocationResponseSuccess;
function onUpdateAllocationResponseError() {
    return {
        type: exports.ALLOCATION_UPDATE_ERROR,
        text: 'Error receiving data'
    };
}
exports.onUpdateAllocationResponseError = onUpdateAllocationResponseError;
function onDeleteAllocation(allocation, siteId, accessToken) {
    return function (dispatch) {
        dispatch({ type: exports.ALLOCATION_DELETE_REQUEST, allocationToDelete: allocation });
        makeAllocationDeleteRequest(dispatch, allocation, siteId, accessToken);
    };
}
exports.onDeleteAllocation = onDeleteAllocation;
function makeAllocationDeleteRequest(dispatch, allocation, siteId, accessToken) {
    return servicesDataService_1.requestAllocationDelete(allocation, accessToken).then(function (success) {
        dispatch(onDeleteAllocationResponseSuccess(success));
        dispatch(hardwareActionCreators.onServerGetRequest(siteId, accessToken));
    }, function (error) { return dispatch(onDeleteAllocationResponseError()); });
}
exports.makeAllocationDeleteRequest = makeAllocationDeleteRequest;
function onDeleteAllocationResponseSuccess(allocation) {
    return {
        type: exports.ALLOCATION_DELETE_SUCCESS,
        allocation: allocation
    };
}
exports.onDeleteAllocationResponseSuccess = onDeleteAllocationResponseSuccess;
function onDeleteAllocationResponseError() {
    return {
        type: exports.ALLOCATION_DELETE_ERROR,
        text: 'Error receiving data'
    };
}
exports.onDeleteAllocationResponseError = onDeleteAllocationResponseError;
function clearErrorMessage() {
    return function (dispatch) {
        dispatch({ type: exports.ALLOCATION_CLEAR_ERROR });
    };
}
exports.clearErrorMessage = clearErrorMessage;


/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UserFilterValue = (function () {
    function UserFilterValue() {
        this.email = '';
        this.allScopes = false;
        this.scopes = [];
        this.isAdmin = undefined;
        this.display = 15;
    }
    return UserFilterValue;
}());
exports.UserFilterValue = UserFilterValue;
var User = (function () {
    function User() {
        this.id = 0;
        this.email = '';
        this.allScopes = false;
        this.scopes = [];
        this.isAdmin = false;
    }
    return User;
}());
exports.User = User;


/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var oidc_client_1 = __webpack_require__(129);
exports.Settings = {
    authority: "" + environmentSettings.authUrl,
    client_id: 'ABB.Beacon.Licensing.UI',
    redirect_uri: environmentSettings.websiteUrl + "/login",
    post_logout_redirect_uri: environmentSettings.websiteUrl + "/logout?success=true",
    response_type: 'id_token token',
    scope: 'openid profile email ABB.Beacon.Licensing.API serviceinstalledbase-api',
    filterProtocolClaims: true,
    loadUserInfo: true,
    userStore: new oidc_client_1.WebStorageStateStore({ store: window.localStorage }),
    automaticSilentRenew: true,
    silent_redirect_uri: environmentSettings.websiteUrl + "/SilentRenew"
};


/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var serverActionCreators = __webpack_require__(104);
var licenseAllowanceActionCreators = __webpack_require__(105);
var serverWithServicesActionCreators = __webpack_require__(324);
var siteLicenseActionCreators = __webpack_require__(325);
var constants_1 = __webpack_require__(25);
var moment = __webpack_require__(0);
var initialSiteLicenseState = {
    licenseFileLoading: false
};
var initialCustomerSiteState = {
    customerSite: {
        name: '',
        physicalAddress: '',
        region: '',
        shippingAddress: '',
        site: '',
        siteID: ''
    }
};
var initialServerState = {
    server: [],
    numberOfSavedServers: 0,
    serverLoading: false,
    serverIsAddingNew: false,
    serverEditing: false,
    availableServices: [],
    operationalUsages: [],
    serverErrorMessageVisible: false
};
var initialLicenseAllocationState = {
    site: {
        id: 0,
        servIsId: '0',
        siteName: '',
        owner: '',
        operator: '',
        regionName: '',
        country: '',
        city: ''
    },
    licenseAllowances: [],
    licenseAllowancesIsAddingNew: false,
    licenseAllowancesIsEditing: false,
    licenseAllowancesLoading: false,
    licenseAllowanceErrorMessageVisible: false
};
var initialServiceOptionsState = {
    serviceOptions: {
        licensableServices: [],
        poNumber: '',
        totalAssetAllocation: 0,
        expirationDateUtc: moment()
    },
    serviceOptionsLoading: false
};
// TODO: should these be broken out into the component level?
function serverReducer(state, action) {
    if (state === void 0) { state = initialServerState; }
    switch (action.type) {
        case serverActionCreators.SERVER_GET_REQUEST:
            return __assign({}, state, { serverLoading: true });
        case serverActionCreators.SERVER_GET_SUCCESS:
            var serversWithUpdatedVisibility = action.server.map(function (x) {
                return Object.assign({}, x, {
                    isAvailable: true
                });
            });
            return Object.assign({}, state, {
                server: serversWithUpdatedVisibility,
                numberOfSavedServers: action.server.length,
                serverLoading: false,
                availableServices: action.services
            });
        case serverActionCreators.OPERATIONAL_USAGE_GET_SUCCESS:
            return __assign({}, state, { operationalUsages: action.operationalUsages });
        case serverActionCreators.SERVER_GET_ERROR:
            // TODO: Add and display error
            return __assign({}, state, { text: action.text, serverLoading: false, serverErrorMessageVisible: true });
        case serverActionCreators.SERVER_ADD_REQUEST:
            return Object.assign({}, state, {
                serverIsAddingNew: true,
                server: state.server
                    .concat([action.newServer])
            });
        case serverActionCreators.SERVER_DELETE_REQUEST:
            return __assign({}, state, { serverLoading: false, serverIsAddingNew: false });
        case serverActionCreators.SERVER_DELETE_SUCCESS:
            return Object.assign({}, state, {
                serverIsAddingNew: false,
                server: state.server
                    .filter(function (server) {
                    return server.id !== action.server.id;
                }),
                numberOfSavedServers: action.server.id === -1 ? state.numberOfSavedServers : state.numberOfSavedServers - 1
            });
        case serverActionCreators.SERVER_DELETE_ERROR:
            // TODO: Add and display error
            return __assign({}, state, { text: action.text, serverLoading: false, serverErrorMessageVisible: true });
        case serverActionCreators.SERVER_EDIT_ROW:
            var hwToEditIndex = state.server.indexOf(action.serverToEdit);
            if (hwToEditIndex > -1) {
                state.server[hwToEditIndex].isBeingEdited = true;
            }
            return __assign({}, state, { server: state.server, serverEditing: true, serverIsAddingNew: false });
        case serverActionCreators.SERVER_UPDATE_REQUEST:
            var hwToUpdateIndex = state.server.indexOf(action.serverToUpdate);
            if (hwToUpdateIndex > -1) {
                state.server[hwToUpdateIndex].isBeingEdited = false;
            }
            return __assign({}, state, { hardwareIsEditing: false, serverIsAddingNew: false });
        case serverActionCreators.SERVER_DESCRIPTION_UPDATE:
            var indexToUpdate = state.server.map(function (server) { return server.isBeingEdited; }).indexOf(true);
            return Object.assign({}, state, {
                serverIsAddingNew: false,
                server: state.server.slice(0, indexToUpdate)
                    .concat([__assign({}, state.server[indexToUpdate], { description: {
                            value: action.newDescription,
                            valid: constants_1.isValidServerNameInput(action.newDescription, constants_1.SERVER_DESCRIPTION_MAX_LENGTH) && state.server.filter(function (server) { return server.description.value === action.newDescription; }).length < 1
                        } })])
                    .concat(state.server.slice(indexToUpdate + 1))
            });
        case serverActionCreators.SERVER_SERVERID_UPDATE:
            var indexToUpdateServerId = state.server.map(function (server) { return server.isBeingEdited; }).indexOf(true);
            return Object.assign({}, state, {
                serverIsAddingNew: false,
                server: state.server.slice(0, indexToUpdateServerId)
                    .concat([__assign({}, state.server[indexToUpdateServerId], { serverId: {
                            value: action.newServerId,
                            valid: constants_1.isValidHardwareIdInput(action.newServerId, constants_1.SERVER_ID_MAX_LENGTH)
                        } })])
                    .concat(state.server.slice(indexToUpdateServerId + 1))
            });
        case serverActionCreators.SERVER_OPERATIONAL_UPDATE:
            var indexUpdate = state.server.map(function (server) { return server.isBeingEdited; }).indexOf(true);
            return Object.assign({}, state, {
                serverIsAddingNew: false,
                server: state.server.slice(0, indexUpdate)
                    .concat([__assign({}, state.server[indexUpdate], { operationalUseType: {
                            id: action.value.id,
                            usageName: action.value.label
                        } })])
                    .concat(state.server.slice(indexUpdate + 1))
            });
        case serverActionCreators.SERVER_RESET_CURRENTLY_EDITING:
            var indexUpdateEditing = state.server.map(function (server) { return server.isBeingEdited; }).indexOf(true);
            var currentServer = indexUpdateEditing > -1 ? Object.assign({}, state, {
                server: state.server.slice(0, indexUpdateEditing)
                    .concat([__assign({}, state.server[indexUpdateEditing], { isBeingEdited: false })])
                    .concat(state.server.slice(indexUpdateEditing + 1))
            }) : state;
            return Object.assign({}, currentServer, {
                hardwareIsEditing: true,
                server: currentServer.server
                    .filter(function (server) {
                    return server.id !== -1;
                })
            });
        case serverActionCreators.SERVER_CANCEL_EDITING:
            var indexEditing = state.server.map(function (server) { return server.isBeingEdited; }).indexOf(true);
            var serverBeingEdited = action.serverPreEdit;
            var serverEditing = indexEditing > -1 ? Object.assign({}, state, {
                server: state.server.slice(0, indexEditing)
                    .concat([__assign({}, action.serverPreEdit, { isBeingEdited: false })])
                    .concat(state.server.slice(indexEditing + 1))
            }) : state;
            return Object.assign({}, serverEditing, {
                hardwareIsEditing: false,
                server: serverEditing.server
                    .filter(function (server) {
                    return server.id !== -1;
                })
            });
        case serverActionCreators.SERVER_UPDATE_SUCCESS:
            return __assign({}, state, { serverEditing: false });
        case serverActionCreators.SERVER_UPDATE_ERROR:
            // TODO: Add and display error
            return __assign({}, state, { serverEditing: false, serverErrorMessageVisible: true });
        case serverActionCreators.SERVER_CLEAR_ERROR:
            return __assign({}, state, { serverErrorMessageVisible: false });
        case serverWithServicesActionCreators.SERVERWITHSERVICES_ALLOCATION_UPDATE:
            var serverWithServicesIndexOfServerToUpdateServerWithServicess = state.server.map(function (server) { return server.id; }).indexOf(action.serviceInstance.serverId);
            var serverWithServicesIndexToUpdateServerWithServicesa = state.server[serverWithServicesIndexOfServerToUpdateServerWithServicess].serviceAllocations.map(function (serviceAllocation) { return serviceAllocation; }).indexOf(action.serviceInstance);
            return Object.assign({}, state, {
                server: state.server.slice(0, serverWithServicesIndexOfServerToUpdateServerWithServicess)
                    .concat([__assign({}, state.server[serverWithServicesIndexOfServerToUpdateServerWithServicess], { serviceAllocations: state.server[serverWithServicesIndexOfServerToUpdateServerWithServicess].serviceAllocations.slice(0, serverWithServicesIndexToUpdateServerWithServicesa)
                            .concat([__assign({}, state.server[serverWithServicesIndexOfServerToUpdateServerWithServicess].serviceAllocations[serverWithServicesIndexToUpdateServerWithServicesa], { allocatedAssets: { value: action.newAllocation, valid: true } })])
                            .concat(state.server[serverWithServicesIndexOfServerToUpdateServerWithServicess].serviceAllocations.slice(serverWithServicesIndexToUpdateServerWithServicesa + 1)) })])
                    .concat(state.server.slice(serverWithServicesIndexOfServerToUpdateServerWithServicess + 1))
            });
        case serverWithServicesActionCreators.SERVICE_DELETE_SUCCESS:
            var serviceDeleteSuccessServerIndex = state.server.map(function (server) { return server.id; }).indexOf(action.serviceInstance.serverId);
            var serviceDeleteSuccessServiceIndex = state.server[serviceDeleteSuccessServerIndex].serviceAllocations.map(function (serviceAllocation) { return serviceAllocation; }).indexOf(action.serviceInstance);
            return Object.assign({}, state, {
                server: state.server.slice(0, serviceDeleteSuccessServerIndex)
                    .concat([__assign({}, state.server[serviceDeleteSuccessServerIndex], { serviceAllocations: state.server[serviceDeleteSuccessServerIndex].serviceAllocations.filter(function (service) { return service.id !== action.serviceInstance.id; }) })])
                    .concat(state.server.slice(serviceDeleteSuccessServerIndex + 1))
            });
        case serverWithServicesActionCreators.SERVICE_DELETE_ERROR:
            // TODO: Add and display error
            return __assign({}, state, { text: action.text, serverLoading: false });
        case serverWithServicesActionCreators.SERVERWITHSERVICES_UPDATE_ERROR:
            // TODO: Add and display error
            return __assign({}, state, { serverEditing: false });
        case serverWithServicesActionCreators.SERVERWITHSERVICES_UPDATE_SUCCESS:
            return Object.assign({}, state, {
                server: state.server.map(function (server) {
                    var addServiceInstance = server.id === action.newServiceInstance.serverId && action.isPost ? action.newServiceInstance : null;
                    var newServiceAllocations = server.serviceAllocations.map(function (serviceAllocation) {
                        if (action.newServiceInstance.id === serviceAllocation.id) {
                            return __assign({}, action.newServiceInstance, { isBeingEdited: false });
                        }
                        else {
                            return serviceAllocation;
                        }
                    });
                    if (addServiceInstance) {
                        newServiceAllocations = newServiceAllocations.concat([addServiceInstance]);
                    }
                    return __assign({}, server, { serviceAllocations: newServiceAllocations });
                })
            });
        case licenseAllowanceActionCreators.ALLOCATION_ADD_SUCCESS:
            return __assign({}, state, { availableServices: state.availableServices && state.availableServices.length > 0 ? state.availableServices.concat([action.allocation.licensableService]) : [action.allocation.licensableService] });
        case licenseAllowanceActionCreators.ALLOCATION_DELETE_SUCCESS:
            return __assign({}, state, { availableServices: state.availableServices && state.availableServices.length > 1 ? state.availableServices.filter(function (availableService) { return availableService.id !== action.allocation.licensableService.id; }) : [] });
        default:
            return state;
    }
}
exports.serverReducer = serverReducer;
function licenseAllowanceReducer(state, action) {
    if (state === void 0) { state = initialLicenseAllocationState; }
    switch (action.type) {
        case licenseAllowanceActionCreators.ALLOCATION_GET_REQUEST:
            return __assign({}, state, { licenseAllowancesLoading: true });
        case licenseAllowanceActionCreators.ALLOCATION_GET_SUCCESS:
            return __assign({}, state, { site: action.siteInfo.site, licenseAllowances: action.siteInfo.licenseAllowances, allocationIsAddingNew: false, licenseAllowancesLoading: false });
        case licenseAllowanceActionCreators.ALLOCATION_GET_ERROR:
            return __assign({}, state, { text: action.text, licenseAllowancesLoading: false, licenseAllowanceErrorMessageVisible: true });
        case licenseAllowanceActionCreators.ALLOCATION_EDITABLE_ROW_ADD:
            return __assign({}, state, { licenseAllowances: state.licenseAllowances.concat([action.newAllocation]), allocationIsAddingNew: true, allocationIsEditing: true });
        case licenseAllowanceActionCreators.ALLOCATION_EDIT_ROW:
            action.allocationToEdit.isBeingEdited = true;
            var serviceToEditIndex = state.licenseAllowances.indexOf(action.allocationToEdit);
            var allocationToUpdate = serviceToEditIndex > -1 ? Object.assign({}, state, {
                licenseAllowances: state.licenseAllowances.slice(0, serviceToEditIndex)
                    .concat([__assign({}, state.licenseAllowances[serviceToEditIndex], { isBeingEdited: true })])
                    .concat(state.licenseAllowances.slice(serviceToEditIndex + 1))
            }) : state;
            return Object.assign({}, allocationToUpdate, {
                allocationIsEditing: true,
                licenseAllowances: allocationToUpdate.licenseAllowances
                    .filter(function (licenseAllowances) {
                    return licenseAllowances.id !== -1;
                })
            });
        case licenseAllowanceActionCreators.ALLOCATION_RESET_CURRENTLY_EDITING:
            var indexUpdateEditing = state.licenseAllowances.map(function (allowance) { return allowance.isBeingEdited; }).indexOf(true);
            var currentAllocation = indexUpdateEditing > -1 ? Object.assign({}, state, {
                licenseAllowances: state.licenseAllowances.slice(0, indexUpdateEditing)
                    .concat([__assign({}, state.licenseAllowances[indexUpdateEditing], { isBeingEdited: false })])
                    .concat(state.licenseAllowances.slice(indexUpdateEditing + 1))
            }) : state;
            return Object.assign({}, currentAllocation, {
                allocationIsAddingNew: false,
                licenseAllowances: currentAllocation.licenseAllowances
                    .filter(function (licenseAllowances) {
                    return licenseAllowances.id !== -1;
                })
            });
        case licenseAllowanceActionCreators.ALLOCATION_CANCEL_EDITING:
            var indexUpdateCancelEditing = state.licenseAllowances.map(function (allowance) { return allowance.isBeingEdited; }).indexOf(true);
            var currentAllocationForCancel = indexUpdateCancelEditing > -1 ? Object.assign({}, state, {
                licenseAllowances: state.licenseAllowances.slice(0, indexUpdateCancelEditing)
                    .concat([__assign({}, state.licenseAllowances[indexUpdateCancelEditing], { isBeingEdited: false })])
                    .concat(state.licenseAllowances.slice(indexUpdateCancelEditing + 1))
            }) : state;
            return Object.assign({}, currentAllocationForCancel, {
                allocationIsEditing: false,
                licenseAllowances: currentAllocationForCancel.licenseAllowances
                    .filter(function (licenseAllowances) {
                    return licenseAllowances.id !== -1;
                })
            });
        case licenseAllowanceActionCreators.ALLOCATION_ADD_REQUEST:
            return Object.assign({}, state, {
                licenseAllowancesLoading: true,
            });
        case licenseAllowanceActionCreators.ALLOCATION_ADD_SUCCESS:
            return Object.assign({}, state, {
                licenseAllowances: state.licenseAllowances.concat([action.allocation]),
                licenseAllowancesLoading: false,
                allocationIsEditing: false,
                allocationIsAddingNew: false,
            });
        case licenseAllowanceActionCreators.ALLOCATION_ADD_ERROR:
            return __assign({}, state, { text: action.text, allocationIsEditing: false, licenseAllowancesLoading: false, licenseAllowanceErrorMessageVisible: true });
        case licenseAllowanceActionCreators.ALLOCATION_CANCEL_REQUEST:
            return Object.assign({}, state, {
                allocationIsAddingNew: false,
                allocationIsEditing: false,
            });
        case licenseAllowanceActionCreators.ALLOCATION_DELETE_REQUEST:
            var allocationToDeleteIndex = state.licenseAllowances.indexOf(action.allocationToDelete);
            var allocationToDelete = allocationToDeleteIndex > -1 ? Object.assign({}, state, {
                licenseAllowances: state.licenseAllowances.slice(0, allocationToDeleteIndex)
                    .concat([__assign({}, state.licenseAllowances[allocationToDeleteIndex], { isBeingEdited: false })])
                    .concat(state.licenseAllowances.slice(allocationToDeleteIndex + 1))
            }) : state;
            return Object.assign({}, allocationToDelete, {
                licenseAllowances: allocationToDelete.licenseAllowances,
                licenseAllowancesLoading: false
            });
        case licenseAllowanceActionCreators.ALLOCATION_DELETE_SUCCESS:
            return Object.assign({}, state, {
                licenseAllowances: state.licenseAllowances
                    .filter(function (licenseAllowances) {
                    return licenseAllowances.id !== action.allocation.id;
                }),
                licenseAllowancesLoading: false,
                allocationIsAddingNew: false,
            });
        case licenseAllowanceActionCreators.ALLOCATION_DELETE_ERROR:
            return __assign({}, state, { text: action.text, licenseAllowancesLoading: false, allocationIsAddingNew: false, licenseAllowanceErrorMessageVisible: true });
        case licenseAllowanceActionCreators.ALLOCATION_UPDATE_REQUEST:
            var allocationToRequestUpdateLookup = state.licenseAllowances.find(function (x) { return x.id === action.allocationToUpdate.id; });
            var allocationToRequestUpdateIndex = allocationToRequestUpdateLookup !== undefined ? state.licenseAllowances.indexOf(allocationToRequestUpdateLookup) : -1;
            var allocationToRequestUpdate = allocationToRequestUpdateIndex > -1 ? Object.assign({}, state, {
                licenseAllowances: state.licenseAllowances.slice(0, allocationToRequestUpdateIndex)
                    .concat([__assign({}, state.licenseAllowances[allocationToRequestUpdateIndex], { isBeingEdited: false })])
                    .concat(state.licenseAllowances.slice(allocationToRequestUpdateIndex + 1))
            }) : state;
            return Object.assign({}, allocationToRequestUpdate, {
                allocationIsEditing: false,
                licenseAllowances: allocationToRequestUpdate.licenseAllowances
                    .filter(function (licenseAllowances) {
                    return licenseAllowances.id !== -1;
                }),
                serviceIsAddingNew: false,
            });
        case licenseAllowanceActionCreators.ALLOCATION_UPDATE_SUCCESS:
            var allocationToUpdateLookup = state.licenseAllowances.find(function (x) { return x.id === action.allocationToUpdate.id; });
            var allocationToUpdateIndex = allocationToUpdateLookup !== undefined ? state.licenseAllowances.indexOf(allocationToUpdateLookup) : -1;
            var allocationTotUpdate = allocationToUpdateIndex > -1 ? Object.assign({}, state, {
                licenseAllowances: state.licenseAllowances.slice(0, allocationToUpdateIndex)
                    .concat([__assign({}, action.allocationToUpdate, { isBeingEdited: false })])
                    .concat(state.licenseAllowances.slice(allocationToUpdateIndex + 1))
            }) : state;
            return Object.assign({}, allocationTotUpdate, {
                licenseAllowances: allocationTotUpdate.licenseAllowances
                    .filter(function (licenseAllowances) {
                    return licenseAllowances.id !== -1;
                }),
                allocationIsAddingNew: false,
                licenseAllowancesLoading: false
            });
        case licenseAllowanceActionCreators.ALLOCATION_UPDATE_ERROR:
            return __assign({}, state, { text: action.text, licenseAllowancesLoading: false, licenseAllowanceErrorMessageVisible: true });
        case licenseAllowanceActionCreators.ALLOCATION_CLEAR_ERROR:
            return __assign({}, state, { licenseAllowanceErrorMessageVisible: false });
        default:
            return state;
    }
}
exports.licenseAllowanceReducer = licenseAllowanceReducer;
function serviceOptionsReducer(state, action) {
    if (state === void 0) { state = initialServiceOptionsState; }
    switch (action.type) {
        case licenseAllowanceActionCreators.ALLOCATION_ADD_SUCCESS:
            return __assign({}, state, { serviceOptions: __assign({}, state.serviceOptions, { licensableServices: state.serviceOptions.licensableServices.filter(function (service) { return service.id !== action.allocation.licensableService.id; }) }) });
        case licenseAllowanceActionCreators.ALLOCATION_DELETE_SUCCESS:
            return __assign({}, state, { serviceOptions: __assign({}, state.serviceOptions, { licensableServices: state.serviceOptions.licensableServices.concat([action.allocation.licensableService]) }) });
        case licenseAllowanceActionCreators.ALLOCATION_UPDATE_SUCCESS:
            return __assign({}, state, { serviceOptions: __assign({}, state.serviceOptions, { licensableServices: state.serviceOptions.licensableServices.filter(function (service) { return service.id !== action.allocationToUpdate.licensableService.id; }) }) });
        case licenseAllowanceActionCreators.ALLOCATION_EDIT_ROW:
            if (state.serviceOptions.licensableServices.indexOf(action.allocationToEdit.licensableService) < 0) {
                return __assign({}, state, { serviceOptions: __assign({}, state.serviceOptions, { licensableServices: state.serviceOptions.licensableServices.concat([action.allocationToEdit.licensableService]) }) });
            }
        case licenseAllowanceActionCreators.ALLOCATION_NEW_REQUEST:
            return __assign({}, state, { serviceOptionsLoading: true });
        case licenseAllowanceActionCreators.ALLOCATION_NEW_SUCCESS:
            return __assign({}, state, { serviceOptions: action.serviceOptions, serviceOptionsLoading: false });
        case licenseAllowanceActionCreators.ALLOCATION_NEW_ERROR:
            return __assign({}, state, { text: action.text, serviceOptionsLoading: false });
        default:
            return state;
    }
}
exports.serviceOptionsReducer = serviceOptionsReducer;
function siteLicenseReducer(state, action) {
    if (state === void 0) { state = initialSiteLicenseState; }
    switch (action.type) {
        case siteLicenseActionCreators.LICENSE_FILE_GET_REQUEST:
            return __assign({}, state, { licenseFileLoading: true });
        case siteLicenseActionCreators.GET_LICENSE_FILE_SUCCESS:
            return __assign({}, state, { licenseFileLoading: false });
        case siteLicenseActionCreators.GET_LICENSE_FILE_ERROR:
            return __assign({}, state, { text: action.text, licenseFileLoading: false });
        default:
            return state;
    }
}
exports.siteLicenseReducer = siteLicenseReducer;


/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var siteDataService_1 = __webpack_require__(141);
exports.SERVIS_SITE_POST_REQUEST = 'SERVIS_SITE_POST_REQUEST';
exports.SERVIS_SITE_POST_SUCCESS = 'SERVIS_SITE_POST_SUCCESS';
exports.SERVIS_SITE_POST_ERROR = 'SERVIS_SITE_POST_ERROR';
exports.SERVIS_SITE_GET_REQUEST = 'SERVIS_SITE_GET_REQUEST';
exports.SERVIS_SITE_GET_SUCCESS = 'SERVIS_SITE_GET_SUCCESS';
exports.SERVIS_SITE_GET_ERROR = 'SERVIS_SITE_GET_ERROR';
exports.SERVIS_SITE_PAGING_CHANGE = 'SERVIS_SITE_PAGING_CHANGE';
exports.SERVIS_SITE_SORT_CHANGE = 'SERVIS_SITE_SORT_CHANGE';
exports.SITE_APPLY_SEARCH = 'SITE_APPLY_SEARCH';
exports.SITE_SEARCH_CHANGE = 'SITE_SEARCH_CHANGE';
exports.REGISTERED_NEW_SITE_SELECTED = 'REGISTERED_NEW_SITE_SELECTED';
exports.SERVIS_SITE_REGISTER_ERROR = 'SERVIS_SITE_REGISTER_ERROR';
exports.SERVIS_SITE_REGISTER_SUCCESS = 'SERVIS_SITE_REGISTER_SUCCESS';
exports.SERVIS_SITE_PAGE_LEAVE = 'SERVIS_SITE_PAGE_LEAVE';
function onSiteGetRequest(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken) {
    return function (dispatch) {
        makeSiteGetRequest(dispatch, pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken);
    };
}
exports.onSiteGetRequest = onSiteGetRequest;
function onSiteResponseSuccess(response) {
    return {
        type: exports.SERVIS_SITE_GET_SUCCESS,
        sites: response,
        totalNumberOfSites: response.length
    };
}
exports.onSiteResponseSuccess = onSiteResponseSuccess;
function onSiteResponseError() {
    return {
        type: exports.SERVIS_SITE_GET_ERROR,
        text: 'Error receiving data'
    };
}
exports.onSiteResponseError = onSiteResponseError;
function makeSiteGetRequest(dispatch, pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken) {
    return __awaiter(this, void 0, void 0, function () {
        var sites, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: exports.SERVIS_SITE_GET_REQUEST });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, siteDataService_1.requestSiteGet(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken)];
                case 2:
                    sites = _a.sent();
                    dispatch(onSiteResponseSuccess(sites));
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    dispatch(onSiteResponseError());
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.makeSiteGetRequest = makeSiteGetRequest;
function onPagingChange(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken) {
    return function (dispatch) {
        dispatch({ type: exports.SERVIS_SITE_PAGING_CHANGE, pagingSettings: pagingSettings, sortingSettings: sortingSettings });
        makeSiteGetRequest(dispatch, pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken);
    };
}
exports.onPagingChange = onPagingChange;
function onSortingChange(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken) {
    return function (dispatch) {
        var newPagingSettings = __assign({}, pagingSettings, { skipItems: 0 });
        dispatch({ type: exports.SERVIS_SITE_SORT_CHANGE, pagingSettings: pagingSettings, sortingSettings: sortingSettings });
        makeSiteGetRequest(dispatch, newPagingSettings, sortingSettings, searchFilter, fromServIs, accessToken);
    };
}
exports.onSortingChange = onSortingChange;
function onFilterFieldChange(searchFilter) {
    return {
        type: exports.SITE_SEARCH_CHANGE,
        searchFilter: searchFilter
    };
}
exports.onFilterFieldChange = onFilterFieldChange;
function onFilterApplied(searchFilter, pagingSettings, sortingSettings, fromServIs, accessToken) {
    return function (dispatch) {
        var newPagingSettings = __assign({}, pagingSettings, { skipItems: 0 });
        dispatch({ type: exports.SITE_APPLY_SEARCH, searchFilter: searchFilter });
        dispatch({ type: exports.SERVIS_SITE_PAGING_CHANGE, pagingSettings: newPagingSettings, sortingSettings: sortingSettings });
        makeSiteGetRequest(dispatch, newPagingSettings, sortingSettings, searchFilter, fromServIs, accessToken);
    };
}
exports.onFilterApplied = onFilterApplied;
function onSiteSelected(siteIsSelected, selectedSite) {
    return {
        type: exports.REGISTERED_NEW_SITE_SELECTED,
        siteSelected: siteIsSelected,
        selectedSite: selectedSite
    };
}
exports.onSiteSelected = onSiteSelected;
function onRegisterSite(selectedSite, accessToken) {
    return function (dispatch) {
        makeSitePostRequest(dispatch, selectedSite, accessToken);
    };
}
exports.onRegisterSite = onRegisterSite;
function makeSitePostRequest(dispatch, site, accessToken) {
    return siteDataService_1.requestSitePost(site, accessToken).then(function (success) {
        return dispatch(onRegisterSiteResponseSuccess(success));
    }, function (error) {
        return dispatch(onRegisterSiteResponseError());
    });
}
exports.makeSitePostRequest = makeSitePostRequest;
function onRegisterSiteResponseSuccess(site) {
    return {
        type: exports.SERVIS_SITE_REGISTER_SUCCESS,
        site: site
    };
}
exports.onRegisterSiteResponseSuccess = onRegisterSiteResponseSuccess;
function onRegisterSiteResponseError() {
    return {
        type: exports.SERVIS_SITE_REGISTER_ERROR,
        text: 'Error receiving data'
    };
}
exports.onRegisterSiteResponseError = onRegisterSiteResponseError;
function onRegisterPageLeave() {
    return {
        type: exports.SERVIS_SITE_PAGE_LEAVE
    };
}
exports.onRegisterPageLeave = onRegisterPageLeave;


/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSite = {
    name: '',
    siteId: -1,
    customer: '',
    region: '',
    servIsId: '-1',
    registered: true
};


/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Layout_1 = __webpack_require__(631);
exports.Layout = Layout_1.default;
var Search_1 = __webpack_require__(633);
exports.Search = Search_1.default;


/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var siteApiClient_1 = __webpack_require__(88);
var constants_1 = __webpack_require__(25);
var client = new siteApiClient_1.SiteApiClient(constants_1.SITE_API_URI);
var basePath = environmentSettings.apiUrl + "Sites";
function requestSiteGet(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken) {
    return __awaiter(this, void 0, void 0, function () {
        var response, _a, json;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!fromServIs) return [3 /*break*/, 2];
                    return [4 /*yield*/, getAllServIsSites(pagingSettings.pageSize, pagingSettings.skipItems, sortingSettings.sortField, sortingSettings.sortDirection, searchFilter, accessToken)];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, getAllSites(pagingSettings.pageSize, pagingSettings.skipItems, sortingSettings.sortField, sortingSettings.sortDirection, searchFilter, accessToken)];
                case 3:
                    _a = _b.sent();
                    _b.label = 4;
                case 4:
                    response = _a;
                    if (!response.ok) return [3 /*break*/, 6];
                    return [4 /*yield*/, response.json()];
                case 5:
                    json = _b.sent();
                    return [2 /*return*/, mapToSite(json)];
                case 6: return [2 /*return*/, Promise.reject("System error: " + response.status + " " + response.statusText)];
            }
        });
    });
}
exports.requestSiteGet = requestSiteGet;
function getAllServIsSites(pageSize, skip, orderBy, sortOrder, searchFilter, accessToken) {
    return __awaiter(this, void 0, void 0, function () {
        var headers;
        return __generator(this, function (_a) {
            headers = new Headers();
            headers.append('Authorization', 'Bearer ' + accessToken);
            headers.append('pragma', 'no-cache');
            headers.append('cache-control', 'no-cache');
            headers.append('access-control-allow-methods', 'GET, HEAD, POST, PUT, PATCH, DELETE, OPTIONS');
            return [2 /*return*/, fetch(basePath + "/ServIs?pageSize=" + pageSize + "&skip=" + skip + "&orderBy=" + orderBy + "&sortOrder=" + sortOrder + "&searchData=" + searchFilter, { headers: headers, method: 'GET', cache: 'no-store' })];
        });
    });
}
function getAllSites(pageSize, skip, orderBy, sortOrder, searchFilter, accessToken) {
    return __awaiter(this, void 0, void 0, function () {
        var headers;
        return __generator(this, function (_a) {
            headers = new Headers();
            headers.append('Authorization', 'Bearer ' + accessToken);
            headers.append('pragma', 'no-cache');
            headers.append('cache-control', 'no-cache');
            headers.append('access-control-allow-methods', 'GET, HEAD, POST, PUT, PATCH, DELETE, OPTIONS');
            return [2 /*return*/, fetch(basePath + "?pageSize=" + pageSize + "&skip=" + skip + "&orderBy=" + orderBy + "&sortOrder=" + sortOrder + "&searchData=" + searchFilter, { headers: headers, method: 'GET', cache: 'no-store' })];
        });
    });
}
function mapToSite(data) {
    return data.sites.map(function (site) {
        return {
            name: site.siteName,
            siteId: site.id,
            customer: site.owner,
            region: site.regionName,
            servIsId: site.servIsId,
            registered: site.registered
        };
    });
}
function requestSiteGetById(servIsId, accessToken) {
    return new Promise(function (resolve, reject) {
        client.getServIsSite(servIsId, accessToken).then(function (site) {
            var siteResponse = {
                siteName: site.siteName,
                owner: site.owner,
                regionName: site.regionName,
                servIsId: site.servIsId,
                operator: site.operator,
                country: site.country,
                city: site.city
            };
            resolve(siteResponse);
        }).catch(function (err) {
            reject(err);
        });
    });
}
exports.requestSiteGetById = requestSiteGetById;
function requestSitePost(site, accessToken) {
    return new Promise(function (resolve, reject) {
        client.registerSite(site, accessToken).then(constants_1.handleErrors).then(function (data) {
            var siteResponse = {
                name: data.siteName,
                siteId: data.id,
                customer: data.owner,
                region: data.regionName,
                servIsId: data.servIsId,
                registered: site.registered
            };
            resolve(siteResponse);
        }).catch(function (data) {
            reject(data);
        });
    });
}
exports.requestSitePost = requestSitePost;
function requestSitePut(siteId, servIsId, accessToken) {
    return new Promise(function (resolve, reject) {
        client.updateSite(siteId, servIsId, accessToken)
            .then(function (data) { return resolve(data); })
            .catch(function (err) {
            reject(err);
        });
    });
}
exports.requestSitePut = requestSitePut;


/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.SITE_API_URI = environmentSettings.apiUrl;
exports.SERVER_ID_MAX_LENGTH = 25;
exports.SERVER_DESCRIPTION_MAX_LENGTH = 100;
exports.PO_NUMBER_MAX_LENGTH = 10;
exports.ABB_COMPANY_NAME = 'ABB';
exports.SERVER_ID_FIELD_MAX_LENGTH = 4;
exports.SITE_LIST_SEARCH_PLACEHOLDER = 'Search by Site, ServIS ID, Customer, and Region';
exports.SERVIS_SEARCH_PLACEHOLDER = 'Search by Site and ServIS ID';
exports.INVALID_SERVICE_VALUE = -1;
exports.AVAILABLE_OPERATIONAL_USAGES = [
    {
        id: 1,
        usageName: 'Customer',
        label: 'Customer'
    },
    {
        id: 2,
        usageName: 'Demo',
        label: 'Demo'
    },
    {
        id: 3,
        usageName: 'Trial',
        label: 'Trial'
    }
];
exports.API_ERROR_MESSAGE = 'Something went wrong and your updates could not be completed.  Try again or contact Customer Support at ';
exports.API_SUPPORT_EMAIL = 'us-iasvsupport@abb.com';
exports.API_SUPPORT_MAILTO = 'mailto:us-iasvsupport@abb.com';
function isValidInput(text, maxLength) {
    var alphaNumericWithDash = new RegExp(/^[a-z0-9- ]+$/i);
    var moreThanWhitespace = new RegExp(/\S/);
    return text.length > 0 && text.length <= maxLength && alphaNumericWithDash.test(text) && moreThanWhitespace.test(text);
}
exports.isValidInput = isValidInput;
function isValidServerNameInput(text, maxLength) {
    var alphaNumericWithDashEtc = new RegExp(/^[a-z0-9-_() ]+$/i);
    var moreThanWhitespace = new RegExp(/\S/);
    return text.length > 0 && text.length <= maxLength && alphaNumericWithDashEtc.test(text) && moreThanWhitespace.test(text);
}
exports.isValidServerNameInput = isValidServerNameInput;
function isValidHardwareIdInput(text, maxLength) {
    var hardwareIdFormat = new RegExp(/^(?:[A-Za-z0-9]{4}-){3}[A-Za-z0-9]{4}$/g);
    var moreThanWhitespace = new RegExp(/\S/);
    return text.length > 0 && text.length <= maxLength && hardwareIdFormat.test(text) && moreThanWhitespace.test(text);
}
exports.isValidHardwareIdInput = isValidHardwareIdInput;
function handleErrors(response) {
    if (!response.ok) {
        throw Error(response.statusText);
    }
    return response.json();
}
exports.handleErrors = handleErrors;


/***/ }),

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var AuthorizedUserServiceClass = (function () {
    function AuthorizedUserServiceClass() {
        this.basePath = environmentSettings.apiUrl + "Users/";
    }
    AuthorizedUserServiceClass.prototype.getUserByEmail = function (email, accessToken) {
        return __awaiter(this, void 0, void 0, function () {
            var response, json;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendRequest(email, 'GET', accessToken)];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        return [2 /*return*/, json];
                    case 3: return [2 /*return*/, Promise.reject("System error: " + response.status + " " + response.statusText)];
                }
            });
        });
    };
    AuthorizedUserServiceClass.prototype.sendRequest = function (email, httpMethod, accessToken) {
        var headers = new Headers();
        headers.append('Authorization', 'Bearer ' + accessToken.access_token);
        headers.append('pragma', 'no-cache');
        headers.append('cache-control', 'no-cache');
        headers.append('access-control-allow-methods', 'GET, HEAD, POST, PUT, PATCH, DELETE, OPTIONS');
        return fetch(this.basePath + "GetUserByEmail/" + email, { headers: headers, method: httpMethod, cache: 'no-store' });
    };
    return AuthorizedUserServiceClass;
}());
exports.AuthorizedUserService = new AuthorizedUserServiceClass();
exports.default = exports.AuthorizedUserService;


/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var serviceDataService_1 = __webpack_require__(643);
exports.SERVERWITHSERVICES_UPDATE_ERROR = 'SERVERWITHSERVICES_UPDATE_ERROR';
exports.SERVERWITHSERVICES_UPDATE_SUCCESS = 'SERVERWITHSERVICES_UPDATE_SUCCESS';
exports.SERVICE_DELETE_SUCCESS = 'SERVICE_DELETE_SUCCESS';
exports.SERVICE_DELETE_ERROR = 'SERVICE_DELETE_ERROR';
exports.SERVERWITHSERVICES_ALLOCATION_UPDATE = 'SERVERWITHSERVICES_ALLOCATION_UPDATE';
function onUpdateServerWithServices(serviceInstance, accessToken) {
    return function (dispatch) {
        makeServerWithServicesPutRequest(dispatch, serviceInstance, accessToken);
    };
}
exports.onUpdateServerWithServices = onUpdateServerWithServices;
function onUpdateServerWithServicesResponseSuccess(serviceInstance, isPost) {
    return {
        type: exports.SERVERWITHSERVICES_UPDATE_SUCCESS,
        newServiceInstance: serviceInstance,
        isPost: isPost
    };
}
exports.onUpdateServerWithServicesResponseSuccess = onUpdateServerWithServicesResponseSuccess;
function onUpdateServerWithServicesResponseError() {
    return {
        type: exports.SERVERWITHSERVICES_UPDATE_ERROR,
        text: 'Error receiving data'
    };
}
exports.onUpdateServerWithServicesResponseError = onUpdateServerWithServicesResponseError;
function onDeleteRow(serviceInstance, accessToken) {
    return function (dispatch) {
        makeServiceDeleteRequest(dispatch, serviceInstance, accessToken);
    };
}
exports.onDeleteRow = onDeleteRow;
function onDeleteServiceResponseSuccess(serviceInstance) {
    return function (dispatch) {
        dispatch({
            type: exports.SERVICE_DELETE_SUCCESS,
            serviceInstance: serviceInstance
        });
    };
}
exports.onDeleteServiceResponseSuccess = onDeleteServiceResponseSuccess;
function onDeleteServiceResponseError() {
    return {
        type: exports.SERVICE_DELETE_ERROR,
        text: 'Error receiving data'
    };
}
exports.onDeleteServiceResponseError = onDeleteServiceResponseError;
function makeServerWithServicesPutRequest(dispatch, serviceInstance, accessToken) {
    var isPost = serviceInstance.id === -1;
    var serviceInstanceUpdateOrAdd = isPost ? serviceDataService_1.requestServicePost(serviceInstance, accessToken) :
        serviceDataService_1.requestServicePut(serviceInstance, accessToken);
    return serviceInstanceUpdateOrAdd.then(function (success) {
        dispatch(onUpdateServerWithServicesResponseSuccess(success, isPost));
    }, function (error) {
        dispatch(onUpdateServerWithServicesResponseError());
    });
}
exports.makeServerWithServicesPutRequest = makeServerWithServicesPutRequest;
function onInstanceAllocationEdit(newAllocation, serviceInstance) {
    return {
        type: exports.SERVERWITHSERVICES_ALLOCATION_UPDATE,
        newAllocation: newAllocation,
        serviceInstance: serviceInstance
    };
}
exports.onInstanceAllocationEdit = onInstanceAllocationEdit;
function makeServiceDeleteRequest(dispatch, serviceInstance, accessToken) {
    return serviceDataService_1.requestServiceDelete(serviceInstance, accessToken).then(function (success) {
        return dispatch(onDeleteServiceResponseSuccess(success));
    }, function (error) {
        return dispatch(onDeleteServiceResponseError());
    });
}
exports.makeServiceDeleteRequest = makeServiceDeleteRequest;


/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var siteLicenseDataService_1 = __webpack_require__(645);
exports.GET_LICENSE_FILE_SUCCESS = 'GET_LICENSE_FILE_SUCCESS';
exports.GET_LICENSE_FILE_ERROR = 'GET_LICENSE_FILE_ERROR';
exports.LICENSE_FILE_GET_REQUEST = 'LICENSE_FILE_GET_REQUEST';
function onLicenseFileGetRequest(siteId, siteName, accessToken) {
    return function (dispatch) {
        makeLicenseFileGetRequest(dispatch, siteName, siteId, accessToken);
    };
}
exports.onLicenseFileGetRequest = onLicenseFileGetRequest;
function makeLicenseFileGetRequest(dispatch, siteName, siteId, accessToken) {
    dispatch({ type: exports.LICENSE_FILE_GET_REQUEST });
    return siteLicenseDataService_1.requestLicenseFile(siteName, siteId, accessToken).then(function (success) {
        dispatch(onLicenseFileGetSuccess());
    }, function (error) {
        dispatch(onLicenseFileGetError());
    });
}
exports.makeLicenseFileGetRequest = makeLicenseFileGetRequest;
function onLicenseFileGetSuccess() {
    return {
        type: exports.GET_LICENSE_FILE_SUCCESS,
    };
}
exports.onLicenseFileGetSuccess = onLicenseFileGetSuccess;
function onLicenseFileGetError() {
    return {
        type: exports.GET_LICENSE_FILE_ERROR,
        text: 'Error receiving data'
    };
}
exports.onLicenseFileGetError = onLicenseFileGetError;


/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(3);
var SiteLicense_1 = __webpack_require__(625);
var LicenseContainerComponent = (function (_super) {
    __extends(LicenseContainerComponent, _super);
    function LicenseContainerComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LicenseContainerComponent.prototype.render = function () {
        return (React.createElement(SiteLicense_1.default, null));
    };
    LicenseContainerComponent.prototype.componentWillMount = function () {
        document.getElementById('app').classList.add('background-style');
    };
    LicenseContainerComponent.prototype.componentWillUnmount = function () {
        document.getElementById('app').classList.remove('background-style');
    };
    return LicenseContainerComponent;
}(React.Component));
exports.default = LicenseContainerComponent;


/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Models = __webpack_require__(139);
var actionCreators = __webpack_require__(138);
exports.initialSitesState = {
    sites: [],
    sitesLoading: false,
    pagingSettings: {
        skipItems: 0,
        pageSize: 25
    },
    sortingSettings: {
        sortDirection: 'asc',
        sortField: 'SiteName'
    },
    totalNumberOfSites: 0,
    searchFilter: '',
    siteSelected: false,
    selectedSite: Models.defaultSite,
    selectedSiteRegistered: false,
    siteRegister: {
        attempt: false,
        success: false,
        siteId: -1
    },
    fromServIs: true
};
function registerSiteReducer(state, action) {
    if (state === void 0) { state = exports.initialSitesState; }
    switch (action.type) {
        case actionCreators.SERVIS_SITE_GET_REQUEST:
            return __assign({}, state, { sites: [], sitesLoading: true });
        case actionCreators.SERVIS_SITE_GET_SUCCESS:
            return __assign({}, state, { sites: action.sites, totalNumberOfSites: action.totalNumberOfSites, sitesLoading: false });
        case actionCreators.SERVIS_SITE_GET_ERROR:
            return __assign({}, state, { text: action.text, sitesLoading: false });
        case actionCreators.SERVIS_SITE_PAGING_CHANGE:
            return __assign({}, state, { pagingSettings: action.pagingSettings, sortingSettings: action.sortingSettings });
        case actionCreators.SERVIS_SITE_SORT_CHANGE:
            return __assign({}, state, { pagingSettings: action.pagingSettings, sortingSettings: action.sortingSettings });
        case actionCreators.SITE_APPLY_SEARCH:
            return __assign({}, state, { searchFilter: action.searchFilter, pagingSettings: {
                    skipItems: 0,
                    pageSize: 25
                } });
        case actionCreators.SITE_SEARCH_CHANGE:
            return __assign({}, state, { searchFilter: action.searchFilter });
        case actionCreators.REGISTERED_NEW_SITE_SELECTED:
            return __assign({}, state, { siteSelected: action.siteSelected, selectedSite: action.selectedSite, registeredSiteSelected: action.selectedSite.registered });
        case actionCreators.SERVIS_SITE_REGISTER_SUCCESS:
            return __assign({}, state, { siteRegister: {
                    attempt: true,
                    success: true,
                    siteId: action.site.siteId
                } });
        case actionCreators.SERVIS_SITE_REGISTER_ERROR:
            return __assign({}, state, { siteRegister: {
                    attempt: true,
                    success: false
                } });
        case actionCreators.SERVIS_SITE_PAGE_LEAVE:
            return __assign({}, state, { siteSelected: false, selectedSite: Models.defaultSite, siteRegister: {
                    attempt: false,
                    success: false,
                    siteId: -1
                } });
        default:
            return state;
    }
}
exports.registerSiteReducer = registerSiteReducer;


/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var siteDataService_1 = __webpack_require__(141);
var registerSiteActionCreators_1 = __webpack_require__(138);
exports.SITE_GET_REQUEST = 'SITE_GET_REQUEST';
exports.SITE_GET_SUCCESS = 'SITE_GET_SUCCESS';
exports.SITE_GET_ERROR = 'SITE_GET_ERROR';
exports.SITE_PAGING_CHANGE = 'SITE_PAGING_CHANGE';
exports.SITE_SORT_CHANGE = 'SITE_SORT_CHANGE';
exports.SITE_APPLY_SEARCH = 'SITE_APPLY_SEARCH';
exports.SITE_SEARCH_CHANGE = 'SITE_SEARCH_CHANGE';
function onSiteGetRequest(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken) {
    return function (dispatch) {
        makeSiteGetRequest(dispatch, pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken);
    };
}
exports.onSiteGetRequest = onSiteGetRequest;
function onSiteResponseSuccess(response) {
    return {
        type: exports.SITE_GET_SUCCESS,
        sites: response,
        totalNumberOfSites: response.length
    };
}
exports.onSiteResponseSuccess = onSiteResponseSuccess;
function onSiteResponseError() {
    return {
        type: exports.SITE_GET_ERROR,
        text: 'Error receiving data'
    };
}
exports.onSiteResponseError = onSiteResponseError;
function makeSiteGetRequest(dispatch, pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken) {
    return __awaiter(this, void 0, void 0, function () {
        var sites, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: exports.SITE_GET_REQUEST });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, siteDataService_1.requestSiteGet(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken)];
                case 2:
                    sites = _a.sent();
                    dispatch(onSiteResponseSuccess(sites));
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    dispatch(onSiteResponseError());
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.makeSiteGetRequest = makeSiteGetRequest;
function onPagingChange(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken) {
    return function (dispatch) {
        dispatch({ type: exports.SITE_PAGING_CHANGE, pagingSettings: pagingSettings, sortingSettings: sortingSettings });
        makeSiteGetRequest(dispatch, pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken);
    };
}
exports.onPagingChange = onPagingChange;
function onServIsPagingChange(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken) {
    return function (dispatch) {
        dispatch({ type: registerSiteActionCreators_1.SERVIS_SITE_PAGING_CHANGE, pagingSettings: pagingSettings, sortingSettings: sortingSettings });
        makeSiteGetRequest(dispatch, pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken);
    };
}
exports.onServIsPagingChange = onServIsPagingChange;
function onSortingChange(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken) {
    return function (dispatch) {
        var newPagingSettings = __assign({}, pagingSettings, { skipItems: 0 });
        dispatch({ type: exports.SITE_SORT_CHANGE, pagingSettings: pagingSettings, sortingSettings: sortingSettings });
        makeSiteGetRequest(dispatch, newPagingSettings, sortingSettings, searchFilter, fromServIs, accessToken);
    };
}
exports.onSortingChange = onSortingChange;
function onFilterFieldChange(searchFilter) {
    return {
        type: exports.SITE_SEARCH_CHANGE,
        searchFilter: searchFilter
    };
}
exports.onFilterFieldChange = onFilterFieldChange;
function onFilterApplied(searchFilter, pagingSettings, sortingSettings, fromServIs, accessToken) {
    return function (dispatch) {
        var newPagingSettings = __assign({}, pagingSettings, { skipItems: 0 });
        dispatch({ type: exports.SITE_APPLY_SEARCH, searchFilter: searchFilter });
        dispatch({ type: exports.SITE_PAGING_CHANGE, pagingSettings: newPagingSettings, sortingSettings: sortingSettings });
        makeSiteGetRequest(dispatch, newPagingSettings, sortingSettings, searchFilter, fromServIs, accessToken);
    };
}
exports.onFilterApplied = onFilterApplied;


/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Models = __webpack_require__(139);
var actionCreators = __webpack_require__(328);
exports.initialSitesState = {
    sites: [],
    sitesLoading: false,
    pagingSettings: {
        skipItems: 0,
        pageSize: 25
    },
    sortingSettings: {
        sortDirection: 'asc',
        sortField: 'SiteName'
    },
    totalNumberOfSites: 0,
    searchFilter: '',
    siteSelected: false,
    selectedSite: Models.defaultSite,
    selectedSiteRegistered: false,
    siteRegister: {
        attempt: false,
        success: false,
        siteId: -1
    },
    fromServIs: false
};
function sitesReducer(state, action) {
    if (state === void 0) { state = exports.initialSitesState; }
    switch (action.type) {
        case actionCreators.SITE_GET_REQUEST:
            return __assign({}, state, { sites: [], sitesLoading: true });
        case actionCreators.SITE_GET_SUCCESS:
            return __assign({}, state, { sites: action.sites, totalNumberOfSites: action.totalNumberOfSites, sitesLoading: false });
        case actionCreators.SITE_GET_ERROR:
            return __assign({}, state, { text: action.text, sitesLoading: false });
        case actionCreators.SITE_PAGING_CHANGE:
            return __assign({}, state, { pagingSettings: action.pagingSettings, sortingSettings: action.sortingSettings });
        case actionCreators.SITE_SORT_CHANGE:
            return __assign({}, state, { pagingSettings: action.pagingSettings, sortingSettings: action.sortingSettings });
        case actionCreators.SITE_APPLY_SEARCH:
            return __assign({}, state, { searchFilter: action.searchFilter, pagingSettings: {
                    skipItems: 0,
                    pageSize: 25
                } });
        case actionCreators.SITE_SEARCH_CHANGE:
            return __assign({}, state, { searchFilter: action.searchFilter });
        default:
            return state;
    }
}
exports.sitesReducer = sitesReducer;


/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var userModal_1 = __webpack_require__(331);
exports.UserModal = userModal_1.UserModal;
var userFilter_1 = __webpack_require__(638);
exports.UserFilter = userFilter_1.UserFilter;
var models_1 = __webpack_require__(106);
exports.UserFilterValue = models_1.UserFilterValue;
exports.User = models_1.User;
var userManagement_1 = __webpack_require__(639);
exports.UserManagement = userManagement_1.UserManagement;


/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:jsx-no-lambda */
var common_ux_1 = __webpack_require__(14);
var React = __webpack_require__(3);
var models_1 = __webpack_require__(106);
__webpack_require__(912);
var UserModal = (function (_super) {
    __extends(UserModal, _super);
    function UserModal(props) {
        var _this = _super.call(this, props) || this;
        _this.handleCheckbox = function (event) {
            var nextUser = __assign({}, _this.state.user, { allScopes: !_this.state.user.allScopes });
            _this.setState({ user: nextUser, isSaveButtonDisabled: _this.handleSaveButtonDisabled(nextUser, _this.state.userEmailValidation) });
        };
        _this.handleStatusChange = function (opt) {
            var nextUser = __assign({}, _this.state.user, { isAdmin: opt.value });
            _this.setState({ user: nextUser, isSaveButtonDisabled: _this.handleSaveButtonDisabled(nextUser, _this.state.userEmailValidation) });
        };
        _this.handleUserFieldChange = function (event) {
            var value = event.target.value;
            var name = event.target.name;
            var newValue = {};
            newValue[name] = value;
            var nextUser = __assign({}, _this.state.user, newValue);
            if (value.length > 100) {
                _this.setState({ user: nextUser, userEmailValidation: 'invalid', isSaveButtonDisabled: true });
            }
            else if (value.length === 0) {
                _this.setState({ user: nextUser, userEmailValidation: 'none', isSaveButtonDisabled: true });
            }
            else {
                var userEmailValidation = 'none';
                _this.setState({ user: nextUser, userEmailValidation: 'none', isSaveButtonDisabled: _this.handleSaveButtonDisabled(nextUser, userEmailValidation) });
            }
        };
        _this.handleScopeChange = function (opts) {
            var selectedScopes = [];
            opts.forEach(function (s) {
                selectedScopes = selectedScopes.concat(s.value);
            });
            var nextUser = __assign({}, _this.state.user, { scopes: selectedScopes });
            _this.setState({ user: nextUser, isSaveButtonDisabled: _this.handleSaveButtonDisabled(nextUser, _this.state.userEmailValidation) });
        };
        _this.handleCreate = function () { return __awaiter(_this, void 0, void 0, function () {
            var successful;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.state.user.scopes = this.state.user.allScopes ? [] : this.state.user.scopes;
                        return [4 /*yield*/, this.props.onCreate(this.state.user)];
                    case 1:
                        successful = _a.sent();
                        if (successful) {
                            this.handleClose();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleUpdate = function () { return __awaiter(_this, void 0, void 0, function () {
            var successful;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.state.user.scopes = this.state.user.allScopes ? [] : this.state.user.scopes;
                        return [4 /*yield*/, this.props.onUpdate(this.state.user)];
                    case 1:
                        successful = _a.sent();
                        if (successful) {
                            this.handleClose();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleClose = function () {
            _this.setState({ user: new models_1.User(), isSaveButtonDisabled: true, userEmailValidation: 'none' });
            _this.props.onClose();
        };
        _this.state = {
            user: new models_1.User(),
            countries: __webpack_require__(564),
            userEmailValidation: 'none',
            isSaveButtonDisabled: true,
            isCreateModal: true
        };
        return _this;
    }
    UserModal.prototype.render = function () {
        var adminOptions = [{ label: 'Admin', value: true }, { label: 'Non-Admin', value: false }];
        var scopeValues = this.state.countries.map(function (value) {
            var opt = { label: value.countryID, value: value.countryID };
            return opt;
        });
        var modalSubmit = this.state.isCreateModal ? 'Create' : 'Save';
        var deleteUserButton = this.state.isCreateModal ? '' : React.createElement(common_ux_1.Button, { className: 'deleteTrashCan', buttonType: 'discrete', buttonSize: 'default', id: 'deleteUser', icon: 'trash', onClick: this.props.onDelete });
        return (React.createElement(common_ux_1.Modal, { isOpen: this.props.isOpen, onClose: this.handleClose, header: this.state.isCreateModal ? 'CREATE USER' : 'EDIT USER', modalClassName: 'userModal', overlayClassName: 'modalOverlay' },
            React.createElement("div", { className: 'modal-body row' },
                React.createElement("div", { className: 'col-md-12' },
                    React.createElement("div", { className: 'row form-group' },
                        React.createElement(common_ux_1.TextInput, { name: 'email', labelText: 'Email', placeholder: 'Email', value: this.state.user.email, validationState: this.state.userEmailValidation, isRequired: true, onChange: this.handleUserFieldChange, className: 'col-md-12', inputSize: 'small' })),
                    React.createElement("div", { className: 'row' },
                        React.createElement("div", { className: 'col-lg-12' },
                            React.createElement(common_ux_1.ComboBox, { labelText: 'Admin Status', options: adminOptions, value: this.state.user.isAdmin, onChange: this.handleStatusChange, searchable: false }))),
                    React.createElement("div", { className: 'row' },
                        React.createElement("div", { className: 'col-md-12' },
                            React.createElement(common_ux_1.ComboBox, { placeholder: 'Select Many', labelText: 'Scopes', options: scopeValues, value: this.state.user.scopes, onChange: this.handleScopeChange, searchable: false, multiSelect: true, disabled: this.state.user.allScopes, size: 'small' }))),
                    React.createElement("div", { className: 'row' },
                        React.createElement("div", { className: 'col-lg-12' },
                            React.createElement(common_ux_1.Checkbox, { id: 'allScopesCheck', label: 'Scope by all countries', checked: this.state.user.allScopes, onChange: this.handleCheckbox }))))),
            React.createElement("div", { className: 'modal-footer row form-group noBottomPadding' },
                deleteUserButton,
                React.createElement("div", { style: !this.state.isCreateModal ? { position: 'absolute', right: '33px', bottom: '26px' } : {} },
                    React.createElement(common_ux_1.Button, { buttonType: 'discrete', buttonSize: 'default', id: 'closeUserModal', onClick: this.handleClose }, "Cancel"),
                    ' ',
                    React.createElement(common_ux_1.Button, { buttonType: 'primary', buttonSize: 'default', id: 'saveUserBtn', disabled: this.state.isSaveButtonDisabled, onClick: this.state.isCreateModal ? this.handleCreate : this.handleUpdate }, modalSubmit)))));
    };
    UserModal.prototype.componentDidMount = function () {
        this.setState({ user: this.props.user, isCreateModal: this.props.user.email.length === 0 });
    };
    UserModal.prototype.handleSaveButtonDisabled = function (nextUser, userEmailValidation) {
        return (nextUser.email === '' || nextUser.email.indexOf(' ') === 0 || userEmailValidation === 'invalid');
    };
    return UserModal;
}(React.Component));
exports.UserModal = UserModal;


/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var Allocation = (function () {
    function Allocation(siteId) {
        if (siteId === void 0) { siteId = -1; }
        this.id = -1;
        this.expirationDateUtc = { value: moment().add(1, 'y').toString(), valid: true };
        this.licensableService = {
            assetType: {
                id: -1,
                assetTypeName: '',
            },
            id: -1,
            licenseParameters: '',
            licensePassword: '',
            productName: ''
        };
        this.productOrderNumber = { value: '', valid: false };
        this.totalAssetAllocation = { value: 0, valid: false };
        this.isBeingEdited = true;
        this.siteId = siteId;
    }
    return Allocation;
}());
exports.Allocation = Allocation;
var Server = (function () {
    function Server(siteId) {
        if (siteId === void 0) { siteId = -1; }
        this.id = -1;
        this.description = { value: '', valid: false };
        this.serverId = { value: '', valid: false };
        this.operationalUseType = { id: 1, usageName: 'Customer' };
        this.isBeingEdited = true;
        this.serviceAllocations = [];
        this.siteId = siteId;
        this.isAvailable = false;
    }
    return Server;
}());
exports.Server = Server;
var ServiceInstance = (function () {
    function ServiceInstance(serverWithServicesId, siteId, serviceList) {
        if (serverWithServicesId === void 0) { serverWithServicesId = -1; }
        if (siteId === void 0) { siteId = -1; }
        if (serviceList === void 0) { serviceList = []; }
        this.id = -1;
        this.siteId = siteId;
        this.serverId = serverWithServicesId;
        this.serviceList = serviceList;
        this.allocatedAssets = {
            value: 0,
            valid: false
        };
        this.isBeingEdited = true;
        this.selectedServiceType = {
            licenseParameters: '',
            licensePassword: '',
            productName: '',
            id: -1,
            assetType: {
                id: -1,
                assetTypeName: ''
            }
        };
    }
    return ServiceInstance;
}());
exports.ServiceInstance = ServiceInstance;


/***/ }),

/***/ 564:
/***/ (function(module, exports) {

module.exports = [{"countryID":"AF","countryName":"Afghanistan","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":33,"longitude":65},{"countryID":"AX","countryName":"Aland Islands","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":0,"longitude":0},{"countryID":"AL","countryName":"Albania","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":41,"longitude":20},{"countryID":"DZ","countryName":"Algeria","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":28,"longitude":3},{"countryID":"AS","countryName":"American Samoa","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-14.3333,"longitude":-170},{"countryID":"AD","countryName":"Andorra","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":42.5,"longitude":1.6},{"countryID":"AO","countryName":"Angola","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-12.5,"longitude":18.5},{"countryID":"AI","countryName":"Anguilla","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":18.25,"longitude":-63.1667},{"countryID":"AQ","countryName":"Antarctica","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-90,"longitude":0},{"countryID":"AG","countryName":"Antigua and Barbuda","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":17.05,"longitude":-61.8},{"countryID":"AR","countryName":"Argentina","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-34,"longitude":-64},{"countryID":"AM","countryName":"Armenia","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":40,"longitude":45},{"countryID":"AW","countryName":"Aruba","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":12.5,"longitude":-69.9667},{"countryID":"AU","countryName":"Australia","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-27,"longitude":133},{"countryID":"AT","countryName":"Austria","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":47.3333,"longitude":13.3333},{"countryID":"AZ","countryName":"Azerbaijan","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":40.5,"longitude":47.5},{"countryID":"BS","countryName":"Bahamas","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":24.25,"longitude":-76},{"countryID":"BH","countryName":"Bahrain","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":26,"longitude":50.55},{"countryID":"BD","countryName":"Bangladesh","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":24,"longitude":90},{"countryID":"BB","countryName":"Barbados","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":13.1667,"longitude":-59.5333},{"countryID":"BY","countryName":"Belarus","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":53,"longitude":28},{"countryID":"BE","countryName":"Belgium","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":50.8333,"longitude":4},{"countryID":"BZ","countryName":"Belize","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":17.25,"longitude":-88.75},{"countryID":"BJ","countryName":"Benin","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":9.5,"longitude":2.25},{"countryID":"BM","countryName":"Bermuda","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":32.3333,"longitude":-64.75},{"countryID":"BT","countryName":"Bhutan","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":27.5,"longitude":90.5},{"countryID":"BO","countryName":"Bolivia, Plurinational State of","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-17,"longitude":-65},{"countryID":"BQ","countryName":"Bonaire, Sint Eustatius and Saba","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":0,"longitude":0},{"countryID":"BA","countryName":"Bosnia and Herzegovina","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":44,"longitude":18},{"countryID":"BW","countryName":"Botswana","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-22,"longitude":24},{"countryID":"BV","countryName":"Bouvet Island","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-54.4333,"longitude":3.4},{"countryID":"BR","countryName":"Brazil","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-10,"longitude":-55},{"countryID":"IO","countryName":"British Indian Ocean Territory","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-6,"longitude":71.5},{"countryID":"BN","countryName":"Brunei Darussalam","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":4.5,"longitude":114.6667},{"countryID":"BG","countryName":"Bulgaria","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":43,"longitude":25},{"countryID":"BF","countryName":"Burkina Faso","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":13,"longitude":-2},{"countryID":"BI","countryName":"Burundi","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-3.5,"longitude":30},{"countryID":"KH","countryName":"Cambodia","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":13,"longitude":105},{"countryID":"CM","countryName":"Cameroon","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":6,"longitude":12},{"countryID":"CA","countryName":"Canada","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":60,"longitude":-95},{"countryID":"CV","countryName":"Cape Verde","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":16,"longitude":-24},{"countryID":"KY","countryName":"Cayman Islands","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":19.5,"longitude":-80.5},{"countryID":"CF","countryName":"Central African Republic","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":7,"longitude":21},{"countryID":"TD","countryName":"Chad","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":15,"longitude":19},{"countryID":"CL","countryName":"Chile","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-30,"longitude":-71},{"countryID":"CN","countryName":"China","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":35,"longitude":105},{"countryID":"CX","countryName":"Christmas Island","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-10.5,"longitude":105.6667},{"countryID":"CC","countryName":"Cocos (Keeling) Islands","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-12.5,"longitude":96.8333},{"countryID":"CO","countryName":"Colombia","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":4,"longitude":-72},{"countryID":"KM","countryName":"Comoros","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-12.1667,"longitude":44.25},{"countryID":"CG","countryName":"Congo","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-1,"longitude":15},{"countryID":"CD","countryName":"Congo, Democratic Republic of the","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":0,"longitude":25},{"countryID":"CK","countryName":"Cook Islands","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-21.2333,"longitude":-159.7667},{"countryID":"CR","countryName":"Costa Rica","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":10,"longitude":-84},{"countryID":"CI","countryName":"Cote d'Ivoire","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":8,"longitude":-5},{"countryID":"HR","countryName":"Croatia","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":45.1667,"longitude":15.5},{"countryID":"CU","countryName":"Cuba","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":21.5,"longitude":-80},{"countryID":"CW","countryName":"Curaçao","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":0,"longitude":0},{"countryID":"CY","countryName":"Cyprus","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":35,"longitude":33},{"countryID":"CZ","countryName":"Czech Republic","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":49.75,"longitude":15.5},{"countryID":"DK","countryName":"Denmark","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":56,"longitude":10},{"countryID":"DJ","countryName":"Djibouti","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":11.5,"longitude":43},{"countryID":"DM","countryName":"Dominica","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":15.4167,"longitude":-61.3333},{"countryID":"DO","countryName":"Dominican Republic","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":19,"longitude":-70.6667},{"countryID":"EC","countryName":"Ecuador","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-2,"longitude":-77.5},{"countryID":"EG","countryName":"Egypt","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":27,"longitude":30},{"countryID":"SV","countryName":"El Salvador","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":13.8333,"longitude":-88.9167},{"countryID":"GQ","countryName":"Equatorial Guinea","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":2,"longitude":10},{"countryID":"ER","countryName":"Eritrea","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":15,"longitude":39},{"countryID":"EE","countryName":"Estonia","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":59,"longitude":26},{"countryID":"ET","countryName":"Ethiopia","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":8,"longitude":38},{"countryID":"FK","countryName":"Falkland Islands (Malvinas)","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-51.75,"longitude":-59},{"countryID":"FO","countryName":"Faroe Islands","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":62,"longitude":-7},{"countryID":"FJ","countryName":"Fiji","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-18,"longitude":175},{"countryID":"FI","countryName":"Finland","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":64,"longitude":26},{"countryID":"FR","countryName":"France","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":46,"longitude":2},{"countryID":"GF","countryName":"French Guiana","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":4,"longitude":-53},{"countryID":"PF","countryName":"French Polynesia","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-15,"longitude":-140},{"countryID":"TF","countryName":"French Southern Territories","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-43,"longitude":67},{"countryID":"GA","countryName":"Gabon","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-1,"longitude":11.75},{"countryID":"GM","countryName":"Gambia","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":13.4667,"longitude":-16.5667},{"countryID":"GE","countryName":"Georgia","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":42,"longitude":43.5},{"countryID":"DE","countryName":"Germany","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":51,"longitude":9},{"countryID":"GH","countryName":"Ghana","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":8,"longitude":-2},{"countryID":"GI","countryName":"Gibraltar","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":36.1833,"longitude":-5.3667},{"countryID":"GR","countryName":"Greece","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":39,"longitude":22},{"countryID":"GL","countryName":"Greenland","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":72,"longitude":-40},{"countryID":"GD","countryName":"Grenada","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":12.1167,"longitude":-61.6667},{"countryID":"GP","countryName":"Guadeloupe","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":16.25,"longitude":-61.5833},{"countryID":"GU","countryName":"Guam","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":13.4667,"longitude":144.7833},{"countryID":"GT","countryName":"Guatemala","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":15.5,"longitude":-90.25},{"countryID":"GG","countryName":"Guernsey","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":49.5,"longitude":-2.56},{"countryID":"GN","countryName":"Guinea","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":11,"longitude":-10},{"countryID":"GW","countryName":"Guinea-Bissau","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":12,"longitude":-15},{"countryID":"GY","countryName":"Guyana","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":5,"longitude":-59},{"countryID":"HT","countryName":"Haiti","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":19,"longitude":-72.4167},{"countryID":"HM","countryName":"Heard Island and McDonald Islands","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-53.1,"longitude":72.5167},{"countryID":"VA","countryName":"Holy See (Vatican City State)","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":41.9,"longitude":12.45},{"countryID":"HN","countryName":"Honduras","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":15,"longitude":-86.5},{"countryID":"HK","countryName":"Hong Kong","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":22.25,"longitude":114.1667},{"countryID":"HU","countryName":"Hungary","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":47,"longitude":20},{"countryID":"IS","countryName":"Iceland","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":65,"longitude":-18},{"countryID":"IN","countryName":"India","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":20,"longitude":77},{"countryID":"ID","countryName":"Indonesia","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-5,"longitude":120},{"countryID":"IR","countryName":"Iran, Islamic Republic of","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":32,"longitude":53},{"countryID":"IQ","countryName":"Iraq","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":33,"longitude":44},{"countryID":"IE","countryName":"Ireland","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":53,"longitude":-8},{"countryID":"IM","countryName":"Isle of Man","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":54.23,"longitude":-4.55},{"countryID":"IL","countryName":"Israel","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":31.5,"longitude":34.75},{"countryID":"IT","countryName":"Italy","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":42.8333,"longitude":12.8333},{"countryID":"JM","countryName":"Jamaica","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":18.25,"longitude":-77.5},{"countryID":"JP","countryName":"Japan","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":36,"longitude":138},{"countryID":"JE","countryName":"Jersey","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":49.21,"longitude":-2.13},{"countryID":"JO","countryName":"Jordan","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":31,"longitude":36},{"countryID":"KZ","countryName":"Kazakhstan","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":48,"longitude":68},{"countryID":"KE","countryName":"Kenya","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":1,"longitude":38},{"countryID":"KI","countryName":"Kiribati","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":1.4167,"longitude":173},{"countryID":"KP","countryName":"Korea, Democratic People's Republic of","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":40,"longitude":127},{"countryID":"KR","countryName":"Korea, Republic of","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":37,"longitude":127.5},{"countryID":"KW","countryName":"Kuwait","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":29.3375,"longitude":47.6581},{"countryID":"KG","countryName":"Kyrgyzstan","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":41,"longitude":75},{"countryID":"LA","countryName":"Lao People's Democratic Republic","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":18,"longitude":105},{"countryID":"LV","countryName":"Latvia","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":57,"longitude":25},{"countryID":"LB","countryName":"Lebanon","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":33.8333,"longitude":35.8333},{"countryID":"LS","countryName":"Lesotho","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-29.5,"longitude":28.5},{"countryID":"LR","countryName":"Liberia","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":6.5,"longitude":-9.5},{"countryID":"LY","countryName":"Libya","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":25,"longitude":17},{"countryID":"LI","countryName":"Liechtenstein","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":47.1667,"longitude":9.5333},{"countryID":"LT","countryName":"Lithuania","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":56,"longitude":24},{"countryID":"LU","countryName":"Luxembourg","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":49.75,"longitude":6.1667},{"countryID":"MO","countryName":"Macao","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":22.1667,"longitude":113.55},{"countryID":"MK","countryName":"Macedonia, The Former Yugoslav Republic of","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":41.8333,"longitude":22},{"countryID":"MG","countryName":"Madagascar","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-20,"longitude":47},{"countryID":"MW","countryName":"Malawi","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-13.5,"longitude":34},{"countryID":"MY","countryName":"Malaysia","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":2.5,"longitude":112.5},{"countryID":"MV","countryName":"Maldives","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":3.25,"longitude":73},{"countryID":"ML","countryName":"Mali","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":17,"longitude":-4},{"countryID":"MT","countryName":"Malta","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":35.8333,"longitude":14.5833},{"countryID":"MH","countryName":"Marshall Islands","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":9,"longitude":168},{"countryID":"MQ","countryName":"Martinique","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":14.6667,"longitude":-61},{"countryID":"MR","countryName":"Mauritania","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":20,"longitude":-12},{"countryID":"MU","countryName":"Mauritius","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-20.2833,"longitude":57.55},{"countryID":"YT","countryName":"Mayotte","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-12.8333,"longitude":45.1667},{"countryID":"MX","countryName":"Mexico","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":23,"longitude":-102},{"countryID":"FM","countryName":"Micronesia, Federated States of","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":6.9167,"longitude":158.25},{"countryID":"MD","countryName":"Moldova, Republic of","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":47,"longitude":29},{"countryID":"MC","countryName":"Monaco","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":43.7333,"longitude":7.4},{"countryID":"MN","countryName":"Mongolia","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":46,"longitude":105},{"countryID":"ME","countryName":"Montenegro","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":42,"longitude":19},{"countryID":"MS","countryName":"Montserrat","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":16.75,"longitude":-62.2},{"countryID":"MA","countryName":"Morocco","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":32,"longitude":-5},{"countryID":"MZ","countryName":"Mozambique","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-18.25,"longitude":35},{"countryID":"MM","countryName":"Myanmar","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":22,"longitude":98},{"countryID":"NA","countryName":"Namibia","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-22,"longitude":17},{"countryID":"NR","countryName":"Nauru","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-0.5333,"longitude":166.9167},{"countryID":"NP","countryName":"Nepal","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":28,"longitude":84},{"countryID":"NL","countryName":"Netherlands","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":52.5,"longitude":5.75},{"countryID":"NC","countryName":"New Caledonia","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-21.5,"longitude":165.5},{"countryID":"NZ","countryName":"New Zealand","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-41,"longitude":174},{"countryID":"NI","countryName":"Nicaragua","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":13,"longitude":-85},{"countryID":"NE","countryName":"Niger","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":16,"longitude":8},{"countryID":"NG","countryName":"Nigeria","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":10,"longitude":8},{"countryID":"NU","countryName":"Niue","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-19.0333,"longitude":-169.8667},{"countryID":"NF","countryName":"Norfolk Island","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-29.0333,"longitude":167.95},{"countryID":"MP","countryName":"Northern Mariana Islands","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":15.2,"longitude":145.75},{"countryID":"NO","countryName":"Norway","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":62,"longitude":10},{"countryID":"OM","countryName":"Oman","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":21,"longitude":57},{"countryID":"PK","countryName":"Pakistan","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":30,"longitude":70},{"countryID":"PW","countryName":"Palau","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":7.5,"longitude":134.5},{"countryID":"PS","countryName":"Palestine, State of","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":32,"longitude":35.25},{"countryID":"PA","countryName":"Panama","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":9,"longitude":-80},{"countryID":"PG","countryName":"Papua New Guinea","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-6,"longitude":147},{"countryID":"PY","countryName":"Paraguay","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-23,"longitude":-58},{"countryID":"PE","countryName":"Peru","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-10,"longitude":-76},{"countryID":"PH","countryName":"Philippines","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":13,"longitude":122},{"countryID":"PN","countryName":"Pitcairn","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-24.7,"longitude":-127.4},{"countryID":"PL","countryName":"Poland","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":52,"longitude":20},{"countryID":"PT","countryName":"Portugal","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":39.5,"longitude":-8},{"countryID":"PR","countryName":"Puerto Rico","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":18.25,"longitude":-66.5},{"countryID":"QA","countryName":"Qatar","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":25.5,"longitude":51.25},{"countryID":"RE","countryName":"Réunion","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-21.1,"longitude":55.6},{"countryID":"RO","countryName":"Romania","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":46,"longitude":25},{"countryID":"RU","countryName":"Russian Federation","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":60,"longitude":100},{"countryID":"RW","countryName":"Rwanda","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-2,"longitude":30},{"countryID":"BL","countryName":"Saint Barthélemy","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":0,"longitude":0},{"countryID":"SH","countryName":"Saint Helena, Ascension and Tristan da Cunha","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-15.9333,"longitude":-5.7},{"countryID":"KN","countryName":"Saint Kitts and Nevis","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":17.3333,"longitude":-62.75},{"countryID":"LC","countryName":"Saint Lucia","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":13.8833,"longitude":-61.1333},{"countryID":"MF","countryName":"Saint Martin (French Part)","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":18,"longitude":-63},{"countryID":"PM","countryName":"Saint Pierre and Miquelon","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":46.8333,"longitude":-56.3333},{"countryID":"VC","countryName":"Saint Vincent and the Grenadines","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":13.25,"longitude":-61.2},{"countryID":"WS","countryName":"Samoa","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-13.5833,"longitude":-172.3333},{"countryID":"SM","countryName":"San Marino","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":43.7667,"longitude":12.4167},{"countryID":"ST","countryName":"Sao Tome and Principe","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":1,"longitude":7},{"countryID":"SA","countryName":"Saudi Arabia","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":25,"longitude":45},{"countryID":"SN","countryName":"Senegal","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":14,"longitude":-14},{"countryID":"RS","countryName":"Serbia","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":44,"longitude":21},{"countryID":"SC","countryName":"Seychelles","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-4.5833,"longitude":55.6667},{"countryID":"SL","countryName":"Sierra Leone","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":8.5,"longitude":-11.5},{"countryID":"SG","countryName":"Singapore","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":1.36,"longitude":103.8},{"countryID":"SX","countryName":"Sint Maarten (Dutch part)","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":0,"longitude":0},{"countryID":"SK","countryName":"Slovakia","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":48.6667,"longitude":19.5},{"countryID":"SI","countryName":"Slovenia","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":46,"longitude":15},{"countryID":"SB","countryName":"Solomon Islands","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-8,"longitude":159},{"countryID":"SO","countryName":"Somalia","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":10,"longitude":49},{"countryID":"ZA","countryName":"South Africa","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-29,"longitude":24},{"countryID":"GS","countryName":"South Georgia and the South Sandwich Islands","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-54.5,"longitude":-37},{"countryID":"SS","countryName":"South Sudan","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":0,"longitude":0},{"countryID":"ES","countryName":"Spain","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":40,"longitude":-4},{"countryID":"LK","countryName":"Sri Lanka","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":7,"longitude":81},{"countryID":"SD","countryName":"Sudan","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":15,"longitude":30},{"countryID":"SR","countryName":"Suriname","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":4,"longitude":-56},{"countryID":"SJ","countryName":"Svalbard and Jan Mayen","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":78,"longitude":20},{"countryID":"SZ","countryName":"Swaziland","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-26.5,"longitude":31.5},{"countryID":"SE","countryName":"Sweden","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":62,"longitude":15},{"countryID":"CH","countryName":"Switzerland","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":47,"longitude":8},{"countryID":"SY","countryName":"Syrian Arab Republic","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":35,"longitude":38},{"countryID":"TW","countryName":"Taiwan, Province of China","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":23.5,"longitude":121},{"countryID":"TJ","countryName":"Tajikistan","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":39,"longitude":71},{"countryID":"TZ","countryName":"Tanzania, United Republic of","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-6,"longitude":35},{"countryID":"TH","countryName":"Thailand","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":15,"longitude":100},{"countryID":"TL","countryName":"Timor-Leste","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-8.55,"longitude":125.5167},{"countryID":"TG","countryName":"Togo","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":8,"longitude":1.1667},{"countryID":"TK","countryName":"Tokelau","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-9,"longitude":-172},{"countryID":"TO","countryName":"Tonga","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-20,"longitude":-175},{"countryID":"TT","countryName":"Trinidad and Tobago","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":11,"longitude":-61},{"countryID":"TN","countryName":"Tunisia","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":34,"longitude":9},{"countryID":"TR","countryName":"Turkey","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":39,"longitude":35},{"countryID":"TM","countryName":"Turkmenistan","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":40,"longitude":60},{"countryID":"TC","countryName":"Turks and Caicos Islands","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":21.75,"longitude":-71.5833},{"countryID":"TV","countryName":"Tuvalu","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-8,"longitude":178},{"countryID":"UG","countryName":"Uganda","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":1,"longitude":32},{"countryID":"UA","countryName":"Ukraine","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":49,"longitude":32},{"countryID":"AE","countryName":"United Arab Emirates","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":24,"longitude":54},{"countryID":"GB","countryName":"United Kingdom","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":54,"longitude":-2},{"countryID":"UK","countryName":"United Kingdom","abbRegion":{"abbRegionID":"TEST","abbRegionName":"Test ABB region"},"masterDataID":1,"status":"TEST","regionId":"1","riskClassification":"TEST","latitude":0,"longitude":0},{"countryID":"US","countryName":"United States","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":38,"longitude":-97},{"countryID":"UM","countryName":"United States Minor Outlying Islands","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":19.2833,"longitude":166.6},{"countryID":"UY","countryName":"Uruguay","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-33,"longitude":-56},{"countryID":"UZ","countryName":"Uzbekistan","abbRegion":{"abbRegionID":"EUC","abbRegionName":"Europe"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":41,"longitude":64},{"countryID":"VU","countryName":"Vanuatu","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-16,"longitude":167},{"countryID":"VE","countryName":"Venezuela, Bolivarian Republic of","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":8,"longitude":-66},{"countryID":"VN","countryName":"Viet Nam","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":16,"longitude":106},{"countryID":"VI","countryName":"Virgin Islands (U.S.)","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":18.3333,"longitude":-64.8333},{"countryID":"VG","countryName":"Virgin Islands, British","abbRegion":{"abbRegionID":"AMC","abbRegionName":"Americas"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":18.5,"longitude":-64.5},{"countryID":"WF","countryName":"Wallis and Futuna","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-13.3,"longitude":-176.2},{"countryID":"EH","countryName":"Western Sahara","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":24.5,"longitude":-13},{"countryID":"YE","countryName":"Yemen","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":15,"longitude":48},{"countryID":"ZM","countryName":"Zambia","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-15,"longitude":30},{"countryID":"ZW","countryName":"Zimbabwe","abbRegion":{"abbRegionID":"AMA","abbRegionName":"Asia, Middle East & Africa"},"masterDataID":1,"status":"TEST","regionId":"TEST","riskClassification":"TEST","latitude":-20,"longitude":30}]

/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(3);
var react_redux_1 = __webpack_require__(17);
var react_router_dom_1 = __webpack_require__(15);
var redux_1 = __webpack_require__(199);
var redux_thunk_1 = __webpack_require__(1024);
var reducers_1 = __webpack_require__(640);
var routes_1 = __webpack_require__(641);
// tslint:disable-next-line:no-string-literal
var devToolsExtension = window['devToolsExtension'] ?
    // tslint:disable-next-line:no-string-literal
    window['devToolsExtension']() : function (f) { return f; };
var store = redux_1.createStore(reducers_1.reducers, redux_1.compose(redux_1.applyMiddleware(redux_thunk_1.default), devToolsExtension));
var basename =  true ? '/licensing' : undefined;
function AppContainer() {
    return (React.createElement(react_redux_1.Provider, __assign({}, { store: store }),
        React.createElement(react_router_dom_1.BrowserRouter, __assign({}, { basename: basename, children: routes_1.default }))));
}
exports.default = AppContainer;


/***/ }),

/***/ 566:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var common_ux_1 = __webpack_require__(14);
var moment = __webpack_require__(0);
var React = __webpack_require__(3);
var react_redux_1 = __webpack_require__(17);
var react_router_dom_1 = __webpack_require__(15);
/* tslint:disable:no-empty jsx-no-lambda jsx-self-close*/
var CommonUx = (function (_super) {
    __extends(CommonUx, _super);
    function CommonUx() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommonUx.prototype.render = function () {
        var KeyValueRow = common_ux_1.ColumnDefinition;
        var userProfile = [{ name: 'Cody', value: '1337' }, { name: 'Pete', value: '42' }, { name: 'Bryan', value: '1' }];
        var changeLogger = function (x) { return console.log(x); };
        return (React.createElement("div", { className: 'container' },
            React.createElement("div", { className: 'bs-example row' },
                React.createElement("div", { className: 'row' },
                    React.createElement(common_ux_1.Banner, { bannerType: 'error', id: 'one', onRemove: function (banner) { } }, "Error"),
                    React.createElement(common_ux_1.Banner, { bannerType: 'success', id: 'two', onRemove: function (banner) { } }, "Success"),
                    React.createElement(common_ux_1.Banner, { bannerType: 'warn', id: 'three', onRemove: function (banner) { } }, "Warning"),
                    React.createElement(common_ux_1.Banner, { bannerType: 'info', id: 'four', onRemove: function (banner) { } }, "Information")),
                React.createElement("br", null),
                React.createElement("div", { className: 'row' },
                    React.createElement(common_ux_1.Banner, { bannerType: 'error', bannerStyle: 'discrete', id: 'five', onRemove: function (banner) { } }, "Error"),
                    React.createElement(common_ux_1.Banner, { bannerType: 'success', bannerStyle: 'discrete', id: 'six', onRemove: function (banner) { } }, "Success"),
                    React.createElement(common_ux_1.Banner, { bannerType: 'warn', bannerStyle: 'discrete', id: 'seven', onRemove: function (banner) { } }, "Warning"),
                    React.createElement(common_ux_1.Banner, { bannerType: 'info', bannerStyle: 'discrete', id: 'eight', onRemove: function (banner) { } }, "Information"))),
            React.createElement("br", null),
            React.createElement("div", { className: 'bs-example' },
                React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'default' }, "Normal"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'default', disabled: true }, "Normal"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'discrete', buttonSize: 'default' }, "Discrete"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'discrete', buttonSize: 'default', disabled: true }, "Discrete"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'primary', buttonSize: 'default' }, "Primary"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'primary', buttonSize: 'default', disabled: true }, "Primary"),
                ' ',
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'small' }, "Normal"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'small', disabled: true }, "Normal"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'discrete', buttonSize: 'small' }, "Discrete"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'discrete', buttonSize: 'small', disabled: true }, "Discrete"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'primary', buttonSize: 'small' }, "Primary"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'primary', buttonSize: 'small', disabled: true }, "Primary"),
                ' ',
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'minimal' }, "Normal"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'minimal', disabled: true }, "Normal"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'discrete', buttonSize: 'minimal' }, "Discrete"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'discrete', buttonSize: 'minimal', disabled: true }, "Discrete"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'primary', buttonSize: 'minimal' }, "Primary"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'primary', buttonSize: 'minimal', disabled: true }, "Primary"),
                ' ',
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'default', icon: 'filter' }),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'default', disabled: true, icon: 'filter' }),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'discrete', buttonSize: 'default', icon: 'filter' }),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'discrete', buttonSize: 'default', disabled: true, icon: 'filter' }),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'primary', buttonSize: 'default', icon: 'filter' }),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'primary', buttonSize: 'default', disabled: true, icon: 'filter' }),
                ' ',
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'small', icon: 'filter' }),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'small', disabled: true, icon: 'filter' }),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'discrete', buttonSize: 'small', icon: 'filter' }),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'discrete', buttonSize: 'small', disabled: true, icon: 'filter' }),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'primary', buttonSize: 'small', icon: 'filter' }),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'primary', buttonSize: 'small', disabled: true, icon: 'filter' }),
                ' ',
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'minimal', icon: 'filter' }),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'minimal', disabled: true, icon: 'filter' }),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'discrete', buttonSize: 'minimal', icon: 'filter' }),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'discrete', buttonSize: 'minimal', disabled: true, icon: 'filter' }),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'primary', buttonSize: 'minimal', icon: 'filter' }),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'primary', buttonSize: 'minimal', disabled: true, icon: 'filter' }),
                ' ',
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'default', icon: 'filter' }, "Normal"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'default', disabled: true, icon: 'filter' }, "Normal"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'discrete', buttonSize: 'default', icon: 'filter' }, "Discrete"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'discrete', buttonSize: 'default', disabled: true, icon: 'filter' }, "Discrete"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'primary', buttonSize: 'default', icon: 'filter' }, "Primary"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'primary', buttonSize: 'default', disabled: true, icon: 'filter' }, "Primary"),
                ' ',
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'small', icon: 'filter' }, "Normal"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'small', disabled: true, icon: 'filter' }, "Normal"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'discrete', buttonSize: 'small', icon: 'filter' }, "Discrete"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'discrete', buttonSize: 'small', disabled: true, icon: 'filter' }, "Discrete"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'primary', buttonSize: 'small', icon: 'filter' }, "Primary"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'primary', buttonSize: 'small', disabled: true, icon: 'filter' }, "Primary"),
                ' ',
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'minimal', icon: 'filter' }, "Normal"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'minimal', disabled: true, icon: 'filter' }, "Normal"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'discrete', buttonSize: 'minimal', icon: 'filter' }, "Discrete"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'discrete', buttonSize: 'minimal', disabled: true, icon: 'filter' }, "Discrete"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'primary', buttonSize: 'minimal', icon: 'filter' }, "Primary"),
                ' ',
                React.createElement(common_ux_1.Button, { buttonType: 'primary', buttonSize: 'minimal', disabled: true, icon: 'filter' }, "Primary"),
                ' '),
            React.createElement("br", null),
            React.createElement("div", { className: 'bs-example' },
                React.createElement(common_ux_1.Checkbox, { id: 'clickable' }),
                React.createElement(common_ux_1.Checkbox, { id: 'clickableLabel', label: 'Click Me!' }),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement(common_ux_1.Checkbox, { id: 'normal', checked: false, onChange: changeLogger }),
                React.createElement(common_ux_1.Checkbox, { id: 'normalChecked', checked: true, onChange: changeLogger }),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement(common_ux_1.Checkbox, { id: 'normalLabel', checked: false, label: 'Normal', onChange: changeLogger }),
                React.createElement(common_ux_1.Checkbox, { id: 'normalLabelChecked', checked: true, label: 'Normal Checked', onChange: changeLogger }),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement(common_ux_1.Checkbox, { id: 'disabled', checked: false, disabled: true, onChange: changeLogger }),
                React.createElement(common_ux_1.Checkbox, { id: 'disabledChecked', checked: true, disabled: true, onChange: changeLogger }),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement(common_ux_1.Checkbox, { id: 'disabledLabel', checked: false, disabled: true, label: 'Disabled', onChange: changeLogger }),
                React.createElement(common_ux_1.Checkbox, { id: 'disabledLabelChecked', checked: true, disabled: true, label: 'Disabled Checked', onChange: changeLogger }),
                React.createElement("br", null),
                React.createElement("br", null)),
            React.createElement("div", { className: 'bs-example' },
                React.createElement("div", null, "Searchable"),
                React.createElement("div", { className: 'row' },
                    React.createElement(common_ux_1.ComboBox, { size: 'minimal', labelText: 'Minimal', className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }] }),
                    React.createElement(common_ux_1.ComboBox, { size: 'minimal', labelText: 'Minimal Required', required: true, className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }] }),
                    React.createElement(common_ux_1.ComboBox, { size: 'minimal', labelText: 'Minimal Disabled', disabled: true, className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }] }),
                    React.createElement(common_ux_1.ComboBox, { size: 'minimal', className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }] }),
                    React.createElement(common_ux_1.ComboBox, { size: 'minimal', required: true, className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }] }),
                    React.createElement(common_ux_1.ComboBox, { size: 'minimal', disabled: true, className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }] })),
                React.createElement("br", null),
                React.createElement("div", null, "Not Searchable"),
                React.createElement("div", { className: 'row' },
                    React.createElement(common_ux_1.ComboBox, { size: 'minimal', labelText: 'Minimal', className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }], searchable: false }),
                    React.createElement(common_ux_1.ComboBox, { size: 'minimal', labelText: 'Minimal Required', required: true, className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }], searchable: false }),
                    React.createElement(common_ux_1.ComboBox, { size: 'minimal', labelText: 'Minimal Disabled', disabled: true, className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }], searchable: false }),
                    React.createElement(common_ux_1.ComboBox, { size: 'minimal', className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }], searchable: false }),
                    React.createElement(common_ux_1.ComboBox, { size: 'minimal', required: true, className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }], searchable: false }),
                    React.createElement(common_ux_1.ComboBox, { size: 'minimal', disabled: true, className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }], searchable: false })),
                React.createElement("br", null),
                React.createElement("div", null, "Searchable"),
                React.createElement("div", { className: 'row' },
                    React.createElement(common_ux_1.ComboBox, { size: 'small', labelText: 'Small', className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }] }),
                    React.createElement(common_ux_1.ComboBox, { size: 'small', labelText: 'Small Required', required: true, className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }] }),
                    React.createElement(common_ux_1.ComboBox, { size: 'small', labelText: 'Small Disabled', disabled: true, className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }] }),
                    React.createElement(common_ux_1.ComboBox, { size: 'small', className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }] }),
                    React.createElement(common_ux_1.ComboBox, { size: 'small', required: true, className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }] }),
                    React.createElement(common_ux_1.ComboBox, { size: 'small', disabled: true, className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }] })),
                React.createElement("br", null),
                React.createElement("div", null, "Not Searchable"),
                React.createElement("div", { className: 'row' },
                    React.createElement(common_ux_1.ComboBox, { size: 'small', labelText: 'Small', className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }], searchable: false }),
                    React.createElement(common_ux_1.ComboBox, { size: 'small', labelText: 'Small Required', required: true, className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }], searchable: false }),
                    React.createElement(common_ux_1.ComboBox, { size: 'small', labelText: 'Small Disabled', disabled: true, className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }], searchable: false }),
                    React.createElement(common_ux_1.ComboBox, { size: 'small', className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }], searchable: false }),
                    React.createElement(common_ux_1.ComboBox, { size: 'small', required: true, className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }], searchable: false }),
                    React.createElement(common_ux_1.ComboBox, { size: 'small', disabled: true, className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }], searchable: false })),
                React.createElement("br", null),
                React.createElement("div", null, "Searchable"),
                React.createElement("div", { className: 'row' },
                    React.createElement(common_ux_1.ComboBox, { size: 'default', labelText: 'Default', className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }] }),
                    React.createElement(common_ux_1.ComboBox, { size: 'default', labelText: 'Default Required', required: true, className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }] }),
                    React.createElement(common_ux_1.ComboBox, { size: 'default', labelText: 'Default Disabled', disabled: true, className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }] }),
                    React.createElement(common_ux_1.ComboBox, { size: 'default', className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }] }),
                    React.createElement(common_ux_1.ComboBox, { size: 'default', required: true, className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }] }),
                    React.createElement(common_ux_1.ComboBox, { size: 'default', disabled: true, className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }] })),
                React.createElement("br", null),
                React.createElement("div", null, "Not Searchable"),
                React.createElement("div", { className: 'row' },
                    React.createElement(common_ux_1.ComboBox, { size: 'default', labelText: 'Default', className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }], searchable: false }),
                    React.createElement(common_ux_1.ComboBox, { size: 'default', labelText: 'Default Required', required: true, className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }], searchable: false }),
                    React.createElement(common_ux_1.ComboBox, { size: 'default', labelText: 'Default Disabled', disabled: true, className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }], searchable: false }),
                    React.createElement(common_ux_1.ComboBox, { size: 'default', className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }], searchable: false }),
                    React.createElement(common_ux_1.ComboBox, { size: 'default', required: true, className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }], searchable: false }),
                    React.createElement(common_ux_1.ComboBox, { size: 'default', disabled: true, className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }], searchable: false }))),
            React.createElement("div", { className: 'bs-example' },
                React.createElement("div", null, "Multi Select"),
                React.createElement("div", { className: 'row' },
                    React.createElement(common_ux_1.ComboBox, { multiSelect: true, size: 'minimal', labelText: 'Minimal', className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }] }),
                    React.createElement(common_ux_1.ComboBox, { multiSelect: true, size: 'minimal', labelText: 'Minimal Required', required: true, className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }] }),
                    React.createElement(common_ux_1.ComboBox, { multiSelect: true, size: 'minimal', labelText: 'Minimal Disabled', disabled: true, className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }] }),
                    React.createElement(common_ux_1.ComboBox, { multiSelect: true, size: 'minimal', className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }] }),
                    React.createElement(common_ux_1.ComboBox, { multiSelect: true, size: 'minimal', required: true, className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }] }),
                    React.createElement(common_ux_1.ComboBox, { multiSelect: true, size: 'minimal', disabled: true, className: 'col-lg-2', options: [{ label: 'One', value: 1 }, { label: 'Two', value: 2 }, { label: 'Three', value: 3 }] })),
                React.createElement("br", null)),
            React.createElement("div", { className: 'bs-example' },
                React.createElement(common_ux_1.Cooltip, { tooltipType: 'success', tooltipContents: React.createElement("span", null,
                        "Look at that",
                        React.createElement("br", null),
                        "success"), placement: 'topLeft' },
                    React.createElement("label", null, "Hover me for success tooltip.")),
                React.createElement("br", null),
                React.createElement(common_ux_1.Cooltip, { tooltipType: 'info', tooltipContents: React.createElement("span", null,
                        "Look at that",
                        React.createElement("br", null),
                        "info"), placement: 'top' },
                    React.createElement("label", null, "Hover me for info tooltip.")),
                React.createElement("br", null),
                React.createElement(common_ux_1.Cooltip, { tooltipType: 'warn', tooltipContents: React.createElement("span", null,
                        "Look at that",
                        React.createElement("br", null),
                        "warn"), placement: 'topRight' },
                    React.createElement("label", null, "Hover me for warn tooltip.")),
                React.createElement("br", null),
                React.createElement(common_ux_1.Cooltip, { tooltipType: 'error', tooltipContents: React.createElement("span", null,
                        "Look at that",
                        React.createElement("br", null),
                        "error"), placement: 'right' },
                    React.createElement("label", null, "Hover me for error tooltip.")),
                React.createElement("br", null),
                React.createElement(common_ux_1.Cooltip, { tooltipType: 'success', tooltipContents: React.createElement("span", null,
                        "Look at that",
                        React.createElement("br", null),
                        "success"), placement: 'bottomRight' },
                    React.createElement("label", null, "Hover me for success tooltip.")),
                React.createElement("br", null),
                React.createElement(common_ux_1.Cooltip, { tooltipType: 'info', tooltipContents: React.createElement("span", null,
                        "Look at that",
                        React.createElement("br", null),
                        "info"), placement: 'bottom' },
                    React.createElement("label", null, "Hover me for info tooltip.")),
                React.createElement("br", null),
                React.createElement(common_ux_1.Cooltip, { tooltipType: 'warn', tooltipContents: React.createElement("span", null,
                        "Look at that",
                        React.createElement("br", null),
                        "warn"), placement: 'bottomLeft' },
                    React.createElement("label", null, "Hover me for warn tooltip.")),
                React.createElement("br", null),
                React.createElement(common_ux_1.Cooltip, { tooltipType: 'error', tooltipContents: React.createElement("span", null,
                        "Look at that",
                        React.createElement("br", null),
                        "error"), placement: 'left' },
                    React.createElement("label", null, "Hover me for error tooltip."))),
            React.createElement("div", { className: 'bs-example' },
                React.createElement(common_ux_1.DatePicker, { id: 'test', date: moment(), onDateChange: changeLogger }),
                React.createElement("br", null),
                React.createElement(common_ux_1.DatePicker, { id: 'test', disabled: true, date: moment(), onDateChange: changeLogger }),
                React.createElement("br", null),
                React.createElement(common_ux_1.DatePicker, { id: 'test', validationState: 'invalid', date: moment(), onDateChange: changeLogger }),
                React.createElement("br", null),
                React.createElement(common_ux_1.DatePicker, { id: 'test', validationState: 'invalid', errorMessage: 'This is a tooltip', date: moment(), onDateChange: changeLogger })),
            React.createElement("div", { className: 'bs-example' },
                React.createElement(common_ux_1.Icon, { icon: 'add_user', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'add_user', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'add_user', size: 'large' }),
                React.createElement("span", null, " add_user"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'alarm_bell', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'alarm_bell', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'alarm_bell', size: 'large' }),
                React.createElement("span", null, " alarm_bell"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'align_bottom', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'align_bottom', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'align_bottom', size: 'large' }),
                React.createElement("span", null, " align_bottom"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'align_horizontal_center', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'align_horizontal_center', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'align_horizontal_center', size: 'large' }),
                React.createElement("span", null, " align_horizontal_center"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'align_left', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'align_left', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'align_left', size: 'large' }),
                React.createElement("span", null, " align_left"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'align_right', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'align_right', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'align_right', size: 'large' }),
                React.createElement("span", null, " align_right"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'align_top', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'align_top', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'align_top', size: 'large' }),
                React.createElement("span", null, " align_top"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'align_vertical_center', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'align_vertical_center', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'align_vertical_center', size: 'large' }),
                React.createElement("span", null, " align_vertical_center"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'analyze_document', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'analyze_document', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'analyze_document', size: 'large' }),
                React.createElement("span", null, " analyze_document"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'audio_off', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'audio_off', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'audio_off', size: 'large' }),
                React.createElement("span", null, " audio_off"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'audio_on', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'audio_on', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'audio_on', size: 'large' }),
                React.createElement("span", null, " audio_on"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'bar_chart', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'bar_chart', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'bar_chart', size: 'large' }),
                React.createElement("span", null, " bar_chart"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'battery_charging', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'battery_charging', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'battery_charging', size: 'large' }),
                React.createElement("span", null, " battery_charging"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'battery_empty', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'battery_empty', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'battery_empty', size: 'large' }),
                React.createElement("span", null, " battery_empty"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'battery_full', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'battery_full', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'battery_full', size: 'large' }),
                React.createElement("span", null, " battery_full"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'battery_half', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'battery_half', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'battery_half', size: 'large' }),
                React.createElement("span", null, " battery_half"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'battery_high', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'battery_high', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'battery_high', size: 'large' }),
                React.createElement("span", null, " battery_high"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'battery_low', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'battery_low', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'battery_low', size: 'large' }),
                React.createElement("span", null, " battery_low"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'binary_data', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'binary_data', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'binary_data', size: 'large' }),
                React.createElement("span", null, " binary_data"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'bluetooth', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'bluetooth', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'bluetooth', size: 'large' }),
                React.createElement("span", null, " bluetooth"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'briefcase', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'briefcase', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'briefcase', size: 'large' }),
                React.createElement("span", null, " briefcase"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'bring_to_front', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'bring_to_front', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'bring_to_front', size: 'large' }),
                React.createElement("span", null, " bring_to_front"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'broadcast', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'broadcast', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'broadcast', size: 'large' }),
                React.createElement("span", null, " broadcast"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'calculator', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'calculator', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'calculator', size: 'large' }),
                React.createElement("span", null, " calculator"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'calendar', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'calendar', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'calendar', size: 'large' }),
                React.createElement("span", null, " calendar"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'call', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'call', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'call', size: 'large' }),
                React.createElement("span", null, " call"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'camera', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'camera', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'camera', size: 'large' }),
                React.createElement("span", null, " camera"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'cart', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'cart', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'cart', size: 'large' }),
                React.createElement("span", null, " cart"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'certificate_document1', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'certificate_document1', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'certificate_document1', size: 'large' }),
                React.createElement("span", null, " certificate_document1"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'certificate_document2', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'certificate_document2', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'certificate_document2', size: 'large' }),
                React.createElement("span", null, " certificate_document2"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'charging', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'charging', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'charging', size: 'large' }),
                React.createElement("span", null, " charging"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'chat1', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'chat1', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'chat1', size: 'large' }),
                React.createElement("span", null, " chat1"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'chat2', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'chat2', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'chat2', size: 'large' }),
                React.createElement("span", null, " chat2"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'check_mark', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'check_mark', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'check_mark', size: 'large' }),
                React.createElement("span", null, " check_mark"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'check_mark_circle1', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'check_mark_circle1', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'check_mark_circle1', size: 'large' }),
                React.createElement("span", null, " check_mark_circle1"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'check_mark_circle2', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'check_mark_circle2', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'check_mark_circle2', size: 'large' }),
                React.createElement("span", null, " check_mark_circle2"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'close', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'close', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'close', size: 'large' }),
                React.createElement("span", null, " close"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'comment1', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'comment1', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'comment1', size: 'large' }),
                React.createElement("span", null, " comment1"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'comment2', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'comment2', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'comment2', size: 'large' }),
                React.createElement("span", null, " comment2"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'computer', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'computer', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'computer', size: 'large' }),
                React.createElement("span", null, " computer"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'controls_and_settings', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'controls_and_settings', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'controls_and_settings', size: 'large' }),
                React.createElement("span", null, " controls_and_settings"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'copy', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'copy', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'copy', size: 'large' }),
                React.createElement("span", null, " copy"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'cut', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'cut', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'cut', size: 'large' }),
                React.createElement("span", null, " cut"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'dashboard1', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'dashboard1', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'dashboard1', size: 'large' }),
                React.createElement("span", null, " dashboard1"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'dashboard2', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'dashboard2', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'dashboard2', size: 'large' }),
                React.createElement("span", null, " dashboard2"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'database', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'database', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'database', size: 'large' }),
                React.createElement("span", null, " database"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'database_new', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'database_new', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'database_new', size: 'large' }),
                React.createElement("span", null, " database_new"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'devices', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'devices', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'devices', size: 'large' }),
                React.createElement("span", null, " devices"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'distribution', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'distribution', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'distribution', size: 'large' }),
                React.createElement("span", null, " distribution"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'document', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'document', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'document', size: 'large' }),
                React.createElement("span", null, " document"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'double_down', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'double_down', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'double_down', size: 'large' }),
                React.createElement("span", null, " double_down"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'double_left', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'double_left', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'double_left', size: 'large' }),
                React.createElement("span", null, " double_left"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'double_right', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'double_right', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'double_right', size: 'large' }),
                React.createElement("span", null, " double_right"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'double_up', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'double_up', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'double_up', size: 'large' }),
                React.createElement("span", null, " double_up"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'down', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'down', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'down', size: 'large' }),
                React.createElement("span", null, " down"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'down_arrow', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'down_arrow', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'down_arrow', size: 'large' }),
                React.createElement("span", null, " down_arrow"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'download', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'download', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'download', size: 'large' }),
                React.createElement("span", null, " download"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'drive', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'drive', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'drive', size: 'large' }),
                React.createElement("span", null, " drive"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'edit', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'edit', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'edit', size: 'large' }),
                React.createElement("span", null, " edit"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'end_call', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'end_call', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'end_call', size: 'large' }),
                React.createElement("span", null, " end_call"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'envelope', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'envelope', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'envelope', size: 'large' }),
                React.createElement("span", null, " envelope"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'error_circle1', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'error_circle1', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'error_circle1', size: 'large' }),
                React.createElement("span", null, " error_circle1"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'error_circle2', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'error_circle2', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'error_circle2', size: 'large' }),
                React.createElement("span", null, " error_circle2"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'event', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'event', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'event', size: 'large' }),
                React.createElement("span", null, " event"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'export', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'export', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'export', size: 'large' }),
                React.createElement("span", null, " export"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'filter', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'filter', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'filter', size: 'large' }),
                React.createElement("span", null, " filter"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'folder', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'folder', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'folder', size: 'large' }),
                React.createElement("span", null, " folder"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'folder_new', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'folder_new', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'folder_new', size: 'large' }),
                React.createElement("span", null, " folder_new"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'folder_open', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'folder_open', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'folder_open', size: 'large' }),
                React.createElement("span", null, " folder_open"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'forward', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'forward', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'forward', size: 'large' }),
                React.createElement("span", null, " forward"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'fullscreen', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'fullscreen', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'fullscreen', size: 'large' }),
                React.createElement("span", null, " fullscreen"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'gauge1', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'gauge1', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'gauge1', size: 'large' }),
                React.createElement("span", null, " gauge1"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'gauge2', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'gauge2', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'gauge2', size: 'large' }),
                React.createElement("span", null, " gauge2"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'geographic_location', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'geographic_location', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'geographic_location', size: 'large' }),
                React.createElement("span", null, " geographic_location"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'globe', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'globe', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'globe', size: 'large' }),
                React.createElement("span", null, " globe"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'group', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'group', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'group', size: 'large' }),
                React.createElement("span", null, " group"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'help_circle1', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'help_circle1', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'help_circle1', size: 'large' }),
                React.createElement("span", null, " help_circle1"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'help_circle2', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'help_circle2', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'help_circle2', size: 'large' }),
                React.createElement("span", null, " help_circle2"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'hide', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'hide', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'hide', size: 'large' }),
                React.createElement("span", null, " hide"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'history', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'history', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'history', size: 'large' }),
                React.createElement("span", null, " history"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'home', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'home', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'home', size: 'large' }),
                React.createElement("span", null, " home"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'hourglass', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'hourglass', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'hourglass', size: 'large' }),
                React.createElement("span", null, " hourglass"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'image', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'image', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'image', size: 'large' }),
                React.createElement("span", null, " image"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'import', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'import', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'import', size: 'large' }),
                React.createElement("span", null, " import"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'information_circle1', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'information_circle1', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'information_circle1', size: 'large' }),
                React.createElement("span", null, " information_circle1"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'information_circle2', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'information_circle2', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'information_circle2', size: 'large' }),
                React.createElement("span", null, " information_circle2"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'key', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'key', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'key', size: 'large' }),
                React.createElement("span", null, " key"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'label', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'label', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'label', size: 'large' }),
                React.createElement("span", null, " label"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'left', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'left', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'left', size: 'large' }),
                React.createElement("span", null, " left"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'left_arrow', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'left_arrow', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'left_arrow', size: 'large' }),
                React.createElement("span", null, " left_arrow"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'light_bulb', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'light_bulb', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'light_bulb', size: 'large' }),
                React.createElement("span", null, " light_bulb"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'link', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'link', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'link', size: 'large' }),
                React.createElement("span", null, " link"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'list', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'list', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'list', size: 'large' }),
                React.createElement("span", null, " list"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'location1', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'location1', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'location1', size: 'large' }),
                React.createElement("span", null, " location1"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'location2', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'location2', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'location2', size: 'large' }),
                React.createElement("span", null, " location2"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'lock_closed', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'lock_closed', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'lock_closed', size: 'large' }),
                React.createElement("span", null, " lock_closed"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'lock_open', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'lock_open', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'lock_open', size: 'large' }),
                React.createElement("span", null, " lock_open"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'log_in', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'log_in', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'log_in', size: 'large' }),
                React.createElement("span", null, " log_in"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'log_out', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'log_out', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'log_out', size: 'large' }),
                React.createElement("span", null, " log_out"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'magnet', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'magnet', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'magnet', size: 'large' }),
                React.createElement("span", null, " magnet"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'make_same_height', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'make_same_height', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'make_same_height', size: 'large' }),
                React.createElement("span", null, " make_same_height"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'make_same_size', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'make_same_size', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'make_same_size', size: 'large' }),
                React.createElement("span", null, " make_same_size"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'make_same_width', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'make_same_width', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'make_same_width', size: 'large' }),
                React.createElement("span", null, " make_same_width"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'map', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'map', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'map', size: 'large' }),
                React.createElement("span", null, " map"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'maximize', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'maximize', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'maximize', size: 'large' }),
                React.createElement("span", null, " maximize"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'menu', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'menu', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'menu', size: 'large' }),
                React.createElement("span", null, " menu"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'menu_narrow', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'menu_narrow', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'menu_narrow', size: 'large' }),
                React.createElement("span", null, " menu_narrow"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'microphone', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'microphone', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'microphone', size: 'large' }),
                React.createElement("span", null, " microphone"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'microphone_off', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'microphone_off', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'microphone_off', size: 'large' }),
                React.createElement("span", null, " microphone_off"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'minimize', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'minimize', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'minimize', size: 'large' }),
                React.createElement("span", null, " minimize"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'minus', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'minus', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'minus', size: 'large' }),
                React.createElement("span", null, " minus"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'minus_in_circle', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'minus_in_circle', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'minus_in_circle', size: 'large' }),
                React.createElement("span", null, " minus_in_circle"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'more', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'more', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'more', size: 'large' }),
                React.createElement("span", null, " more"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'motor', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'motor', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'motor', size: 'large' }),
                React.createElement("span", null, " motor"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'motor_voltage', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'motor_voltage', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'motor_voltage', size: 'large' }),
                React.createElement("span", null, " motor_voltage"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'network', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'network', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'network', size: 'large' }),
                React.createElement("span", null, " network"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'new_document', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'new_document', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'new_document', size: 'large' }),
                React.createElement("span", null, " new_document"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'numericals', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'numericals', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'numericals', size: 'large' }),
                React.createElement("span", null, " numericals"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'open_in_new_window', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'open_in_new_window', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'open_in_new_window', size: 'large' }),
                React.createElement("span", null, " open_in_new_window"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'panel', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'panel', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'panel', size: 'large' }),
                React.createElement("span", null, " panel"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'paper_clip', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'paper_clip', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'paper_clip', size: 'large' }),
                React.createElement("span", null, " paper_clip"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'paste', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'paste', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'paste', size: 'large' }),
                React.createElement("span", null, " paste"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'pause', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'pause', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'pause', size: 'large' }),
                React.createElement("span", null, " pause"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'pie_chart', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'pie_chart', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'pie_chart', size: 'large' }),
                React.createElement("span", null, " pie_chart"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'pin', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'pin', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'pin', size: 'large' }),
                React.createElement("span", null, " pin"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'plant', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'plant', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'plant', size: 'large' }),
                React.createElement("span", null, " plant"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'play', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'play', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'play', size: 'large' }),
                React.createElement("span", null, " play"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'plugin', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'plugin', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'plugin', size: 'large' }),
                React.createElement("span", null, " plugin"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'plus', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'plus', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'plus', size: 'large' }),
                React.createElement("span", null, " plus"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'plus_in_circle', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'plus_in_circle', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'plus_in_circle', size: 'large' }),
                React.createElement("span", null, " plus_in_circle"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'pop_out_window', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'pop_out_window', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'pop_out_window', size: 'large' }),
                React.createElement("span", null, " pop_out_window"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'power_on_off', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'power_on_off', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'power_on_off', size: 'large' }),
                React.createElement("span", null, " power_on_off"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'print', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'print', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'print', size: 'large' }),
                React.createElement("span", null, " print"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'redo', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'redo', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'redo', size: 'large' }),
                React.createElement("span", null, " redo"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'refresh', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'refresh', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'refresh', size: 'large' }),
                React.createElement("span", null, " refresh"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'reports', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'reports', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'reports', size: 'large' }),
                React.createElement("span", null, " reports"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'resistor', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'resistor', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'resistor', size: 'large' }),
                React.createElement("span", null, " resistor"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'rewind', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'rewind', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'rewind', size: 'large' }),
                React.createElement("span", null, " rewind"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'right', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'right', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'right', size: 'large' }),
                React.createElement("span", null, " right"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'right_arrow', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'right_arrow', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'right_arrow', size: 'large' }),
                React.createElement("span", null, " right_arrow"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'save', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'save', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'save', size: 'large' }),
                React.createElement("span", null, " save"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'save_as', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'save_as', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'save_as', size: 'large' }),
                React.createElement("span", null, " save_as"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'screen', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'screen', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'screen', size: 'large' }),
                React.createElement("span", null, " screen"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'search', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'search', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'search', size: 'large' }),
                React.createElement("span", null, " search"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'send_to_back', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'send_to_back', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'send_to_back', size: 'large' }),
                React.createElement("span", null, " send_to_back"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'server', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'server', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'server', size: 'large' }),
                React.createElement("span", null, " server"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'settings', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'settings', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'settings', size: 'large' }),
                React.createElement("span", null, " settings"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'share', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'share', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'share', size: 'large' }),
                React.createElement("span", null, " share"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'shortcut', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'shortcut', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'shortcut', size: 'large' }),
                React.createElement("span", null, " shortcut"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'skip_to_end', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'skip_to_end', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'skip_to_end', size: 'large' }),
                React.createElement("span", null, " skip_to_end"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'skip_to_start', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'skip_to_start', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'skip_to_start', size: 'large' }),
                React.createElement("span", null, " skip_to_start"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'sld1', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'sld1', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'sld1', size: 'large' }),
                React.createElement("span", null, " sld1"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'sld2', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'sld2', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'sld2', size: 'large' }),
                React.createElement("span", null, " sld2"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'smartphone', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'smartphone', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'smartphone', size: 'large' }),
                React.createElement("span", null, " smartphone"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'star', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'star', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'star', size: 'large' }),
                React.createElement("span", null, " star"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'stop', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'stop', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'stop', size: 'large' }),
                React.createElement("span", null, " stop"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'synchronize', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'synchronize', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'synchronize', size: 'large' }),
                React.createElement("span", null, " synchronize"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'system', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'system', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'system', size: 'large' }),
                React.createElement("span", null, " system"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'table', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'table', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'table', size: 'large' }),
                React.createElement("span", null, " table"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'template', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'template', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'template', size: 'large' }),
                React.createElement("span", null, " template"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'template_new', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'template_new', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'template_new', size: 'large' }),
                React.createElement("span", null, " template_new"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'test', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'test', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'test', size: 'large' }),
                React.createElement("span", null, " test"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'time', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'time', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'time', size: 'large' }),
                React.createElement("span", null, " time"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'trash', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'trash', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'trash', size: 'large' }),
                React.createElement("span", null, " trash"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'tree_view', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'tree_view', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'tree_view', size: 'large' }),
                React.createElement("span", null, " tree_view"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'trend1', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'trend1', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'trend1', size: 'large' }),
                React.createElement("span", null, " trend1"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'trend2', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'trend2', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'trend2', size: 'large' }),
                React.createElement("span", null, " trend2"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'undo', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'undo', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'undo', size: 'large' }),
                React.createElement("span", null, " undo"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'unpin', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'unpin', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'unpin', size: 'large' }),
                React.createElement("span", null, " unpin"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'up', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'up', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'up', size: 'large' }),
                React.createElement("span", null, " up"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'up_arrow', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'up_arrow', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'up_arrow', size: 'large' }),
                React.createElement("span", null, " up_arrow"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'upload', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'upload', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'upload', size: 'large' }),
                React.createElement("span", null, " upload"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'usb', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'usb', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'usb', size: 'large' }),
                React.createElement("span", null, " usb"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'user', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'user', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'user', size: 'large' }),
                React.createElement("span", null, " user"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'user_in_circle', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'user_in_circle', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'user_in_circle', size: 'large' }),
                React.createElement("span", null, " user_in_circle"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'view', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'view', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'view', size: 'large' }),
                React.createElement("span", null, " view"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'voltage', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'voltage', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'voltage', size: 'large' }),
                React.createElement("span", null, " voltage"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'warning_circle1', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'warning_circle1', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'warning_circle1', size: 'large' }),
                React.createElement("span", null, " warning_circle1"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'warning_circle2', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'warning_circle2', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'warning_circle2', size: 'large' }),
                React.createElement("span", null, " warning_circle2"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'warning_triangle', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'warning_triangle', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'warning_triangle', size: 'large' }),
                React.createElement("span", null, " warning_triangle"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'wrench', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'wrench', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'wrench', size: 'large' }),
                React.createElement("span", null, " wrench"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'zoom_in', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'zoom_in', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'zoom_in', size: 'large' }),
                React.createElement("span", null, " zoom_in"),
                React.createElement("br", null),
                React.createElement(common_ux_1.Icon, { icon: 'zoom_out', size: 'small' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'zoom_out', size: 'medium' }),
                ' ',
                React.createElement(common_ux_1.Icon, { icon: 'zoom_out', size: 'large' }),
                React.createElement("span", null, " zoom_out"),
                React.createElement("br", null)),
            React.createElement("div", { className: 'bs-example' },
                React.createElement(common_ux_1.PagingControl, { totalItemCount: 101, top: 10, skip: 20, pageRequested: changeLogger })),
            React.createElement("div", { className: 'bs-example' },
                React.createElement("div", null,
                    React.createElement(common_ux_1.RadioButton, { id: 'clickable', group: 'normal' }),
                    React.createElement(common_ux_1.RadioButton, { id: 'clickableLabel', group: 'normal', label: 'Click Me!' })),
                React.createElement("div", null,
                    React.createElement(common_ux_1.RadioButton, { id: 'normal', group: 'normalStatic', checked: false }),
                    React.createElement(common_ux_1.RadioButton, { id: 'normalChecked', group: 'normalStatic', checked: true })),
                React.createElement("div", null,
                    React.createElement(common_ux_1.RadioButton, { id: 'normalLabel', group: 'normalLabel', checked: false, label: 'Normal' }),
                    React.createElement(common_ux_1.RadioButton, { id: 'normalLabelChecked', group: 'normalLabel', checked: true, label: 'Normal Checked' })),
                React.createElement("div", null,
                    React.createElement(common_ux_1.RadioButton, { id: 'disabled', group: 'disabled', checked: false, disabled: true }),
                    React.createElement(common_ux_1.RadioButton, { id: 'disabledChecked', group: 'disabled', checked: true, disabled: true })),
                React.createElement("div", null,
                    React.createElement(common_ux_1.RadioButton, { id: 'disabledLabel', group: 'disabledLabel', checked: false, disabled: true, label: 'Disabled' }),
                    React.createElement(common_ux_1.RadioButton, { id: 'disabledLabelChecked', group: 'disabledLabel', checked: true, disabled: true, label: 'Disabled Checked' }))),
            React.createElement("div", { className: 'bs-example' },
                React.createElement(common_ux_1.Tab, { selected: 0 },
                    React.createElement(common_ux_1.TabPanel, { label: 'Tab 1' },
                        React.createElement("div", null, "This is my tab 1 contents!")),
                    React.createElement(common_ux_1.TabPanel, { label: 'Tab 2' },
                        React.createElement("div", null, "This is my tab 2 contents!")),
                    React.createElement(common_ux_1.TabPanel, { label: 'Tab 3' },
                        React.createElement("div", null, "This is my tab 3 contents!")))),
            React.createElement("div", { className: 'bs-example' },
                React.createElement("div", { className: 'row' },
                    React.createElement("div", { className: 'col-md-12' },
                        React.createElement(common_ux_1.Table, { data: userProfile },
                            React.createElement(KeyValueRow, { cell: function (row) { return row.name; }, header: 'Claim' }),
                            React.createElement(KeyValueRow, { cell: function (row) { return row.value; }, header: 'Value' }))))),
            React.createElement("div", { className: 'bs-example' },
                React.createElement("form", null,
                    React.createElement(common_ux_1.TextInput, { name: 'ExampleEmptyInput', labelText: 'A required input', placeholder: 'Some placeholder text. Small size. Default size.', inputSize: 'small', isRequired: true, inputProps: {}, labelProps: {} }),
                    React.createElement(common_ux_1.TextInput, { name: 'ExampleFilledInput2', labelText: 'I am label', defaultValue: 'This input logs to the console. Minimal size.', onChange: changeLogger, inputSize: 'minimal', inputProps: {}, labelProps: {} }),
                    React.createElement(common_ux_1.TextInput, { name: 'ExampleFilledInput3', labelText: 'All your base', defaultValue: 'This input has an error message. Hover over me to see it. Full size.', onChange: changeLogger, validationState: 'invalid', errorMessage: React.createElement("div", null, "All your base are belong to us."), inputSize: 'full', inputProps: {}, labelProps: {} }),
                    React.createElement(common_ux_1.TextInput, { name: 'ExampleFilledInput3', labelText: 'This is a test of the emergency broadcast system. This is only a test.', defaultValue: 'This input is valid. Full size.', onChange: changeLogger, validationState: 'valid', inputSize: 'full', inputProps: {}, labelProps: {} }),
                    React.createElement(common_ux_1.TextInput, { name: 'ExampleFilledInput2', labelText: 'Read only input', defaultValue: 'This input is read only.', inputSize: 'small', readOnly: true, inputProps: {}, labelProps: {} }),
                    React.createElement(common_ux_1.TextInput, { name: 'ExampleFilledInput2', labelText: 'Disabled input', defaultValue: 'This input is disabled.', inputSize: 'small', disabled: true, inputProps: {}, labelProps: {} }))),
            React.createElement("div", { className: 'bs-example' },
                React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'default', icon: 'filter' }, "Normal Button"),
                ' ',
                React.createElement(common_ux_1.ToggleButton, { buttonType: 'normal', buttonSize: 'default', icon: 'filter' }),
                " ",
                ' ',
                React.createElement(common_ux_1.ToggleButton, { buttonType: 'normal', buttonSize: 'default', icon: 'filter', isToggled: true }),
                " ",
                ' ',
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement(common_ux_1.ToggleButton, { buttonType: 'normal', buttonSize: 'small', icon: 'filter' }),
                " ",
                ' ',
                React.createElement(common_ux_1.ToggleButton, { buttonType: 'normal', buttonSize: 'small', icon: 'filter', isToggled: true }),
                " ",
                ' ',
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement(common_ux_1.ToggleButton, { buttonType: 'normal', buttonSize: 'minimal', icon: 'filter' }),
                " ",
                ' ',
                React.createElement(common_ux_1.ToggleButton, { buttonType: 'normal', buttonSize: 'minimal', icon: 'filter', isToggled: true }),
                " ",
                ' ')));
    };
    return CommonUx;
}(React.Component));
exports.CommonUx = CommonUx;
exports.default = react_router_dom_1.withRouter(react_redux_1.connect(mapStateToProps)(CommonUx));
function mapStateToProps(store) {
    return {
        loggedInUser: store.userState.loggedInUser
    };
}


/***/ }),

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Oidc = __webpack_require__(129);
var React = __webpack_require__(3);
var react_redux_1 = __webpack_require__(17);
var react_router_dom_1 = __webpack_require__(15);
var authorizedUserService_1 = __webpack_require__(323);
var Settings_1 = __webpack_require__(136);
var LoginComponent = (function (_super) {
    __extends(LoginComponent, _super);
    function LoginComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoginComponent.prototype.componentWillMount = function () {
        var _this = this;
        var manager = new Oidc.UserManager(Settings_1.Settings);
        if (this.props.location.hash) {
            manager.signinRedirectCallback().then(function (u) { return _this.props.login(u); });
        }
        else {
            manager.signinRedirect();
        }
    };
    LoginComponent.prototype.render = function () {
        return null;
    };
    return LoginComponent;
}(React.Component));
exports.LoginComponent = LoginComponent;
exports.default = react_router_dom_1.withRouter(react_redux_1.connect(undefined, mapDispatchToProps)(LoginComponent));
function mapDispatchToProps(dispatch, ownProps) {
    return {
        login: function (user) {
            return __awaiter(this, void 0, void 0, function () {
                var userPermissions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, authorizedUserService_1.AuthorizedUserService.getUserByEmail(user.profile.email, user)];
                        case 1:
                            userPermissions = _a.sent();
                            dispatch({ type: 'USER_LOGIN', loggedInUser: user, userPermissions: userPermissions });
                            ownProps.history.push('/');
                            return [2 /*return*/];
                    }
                });
            });
        }
    };
}


/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Oidc = __webpack_require__(129);
var React = __webpack_require__(3);
var react_redux_1 = __webpack_require__(17);
var react_router_dom_1 = __webpack_require__(15);
var Settings_1 = __webpack_require__(136);
var LogoutComponent = (function (_super) {
    __extends(LogoutComponent, _super);
    function LogoutComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LogoutComponent.prototype.componentWillMount = function () {
        var _this = this;
        var manager = new Oidc.UserManager(Settings_1.Settings);
        if (this.props.location.search.indexOf('?success') >= 0) {
            manager.signoutRedirectCallback().then(function (u) { return _this.props.logout(u); });
        }
        else {
            manager.signoutRedirect();
        }
    };
    LogoutComponent.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("h3", null, "Log out"),
            React.createElement("p", null, "You have logged out.")));
    };
    return LogoutComponent;
}(React.Component));
exports.LogoutComponent = LogoutComponent;
exports.default = react_router_dom_1.withRouter(react_redux_1.connect(mapStateToProps, mapDispatchToProps)(LogoutComponent));
function mapStateToProps(store) {
    return {};
}
function mapDispatchToProps(dispatch, ownProps) {
    return {
        logout: function (user) {
            dispatch({ type: 'USER_LOGIN', loggedInUser: null, userPermissions: null });
        },
    };
}


/***/ }),

/***/ 613:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable:jsx-no-lambda */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(3);
var react_redux_1 = __webpack_require__(17);
var react_router_dom_1 = __webpack_require__(15);
var common_ux_1 = __webpack_require__(14);
var ProfileComponent = (function (_super) {
    __extends(ProfileComponent, _super);
    function ProfileComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProfileComponent.prototype.render = function () {
        var KeyValueRow = common_ux_1.ColumnDefinition;
        var profile = this.props.loggedInUser.profile;
        var userProfile = Object.keys(profile).sort().map(function (claim) {
            return { name: claim, value: profile[claim] };
        });
        return (React.createElement("div", null,
            React.createElement("h3", null, "Claims from id token"),
            React.createElement(common_ux_1.Table, { data: userProfile },
                React.createElement(KeyValueRow, { cell: function (row) { return row.name; }, header: 'Claim' }),
                React.createElement(KeyValueRow, { cell: function (row) { return row.value; }, header: 'Value' }))));
    };
    return ProfileComponent;
}(React.Component));
exports.ProfileComponent = ProfileComponent;
exports.default = react_router_dom_1.withRouter(react_redux_1.connect(mapStateToProps)(ProfileComponent));
function mapStateToProps(store) {
    return {
        loggedInUser: store.userState.loggedInUser
    };
}


/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Oidc = __webpack_require__(129);
var React = __webpack_require__(3);
var react_redux_1 = __webpack_require__(17);
var react_router_dom_1 = __webpack_require__(15);
var authorizedUserService_1 = __webpack_require__(323);
var Settings_1 = __webpack_require__(136);
var RequireAuthenticationComponent = (function (_super) {
    __extends(RequireAuthenticationComponent, _super);
    function RequireAuthenticationComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { userManager: new Oidc.UserManager(Settings_1.Settings) };
        _this.onUserLoaded = _this.onUserLoaded.bind(_this);
        _this.onSilentRenewError = _this.onSilentRenewError.bind(_this);
        _this.onAccessTokenExpired = _this.onAccessTokenExpired.bind(_this);
        _this.onAccessTokenExpiring = _this.onAccessTokenExpiring.bind(_this);
        _this.onUserUnloaded = _this.onUserUnloaded.bind(_this);
        _this.onUserSignedOut = _this.onUserSignedOut.bind(_this);
        return _this;
    }
    RequireAuthenticationComponent.prototype.componentWillMount = function () {
        this.state.userManager.events.addUserLoaded(this.onUserLoaded);
        this.state.userManager.events.addSilentRenewError(this.onSilentRenewError);
        this.state.userManager.events.addAccessTokenExpired(this.onAccessTokenExpired);
        this.state.userManager.events.addAccessTokenExpiring(this.onAccessTokenExpiring);
        this.state.userManager.events.addUserUnloaded(this.onUserUnloaded);
        this.state.userManager.events.addUserSignedOut(this.onUserSignedOut);
    };
    RequireAuthenticationComponent.prototype.componentWillUnmount = function () {
        this.state.userManager.events.removeUserLoaded(this.onUserLoaded);
        this.state.userManager.events.removeSilentRenewError(this.onSilentRenewError);
        this.state.userManager.events.removeAccessTokenExpired(this.onAccessTokenExpired);
        this.state.userManager.events.removeAccessTokenExpiring(this.onAccessTokenExpiring);
        this.state.userManager.events.removeUserUnloaded(this.onUserUnloaded);
        this.state.userManager.events.removeUserSignedOut(this.onUserSignedOut);
    };
    RequireAuthenticationComponent.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.props.loggedInUser) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.state.userManager.getUser()];
                    case 1:
                        user = _a.sent();
                        this.props.login(user);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    // event callback when the user has been loaded (on silent renew or redirect)
    RequireAuthenticationComponent.prototype.onUserLoaded = function (user) {
        this.props.login(user);
    };
    // event callback when silent renew errored
    // tslint:disable:no-empty
    RequireAuthenticationComponent.prototype.onSilentRenewError = function (error) {
    };
    // event callback when the access token expired
    RequireAuthenticationComponent.prototype.onAccessTokenExpired = function () {
        this.props.tokenExpired();
    };
    // event callback when the user is logged out
    RequireAuthenticationComponent.prototype.onUserUnloaded = function () {
    };
    // event callback when the user is expiring
    RequireAuthenticationComponent.prototype.onAccessTokenExpiring = function () {
    };
    // event callback when the user is signed out
    RequireAuthenticationComponent.prototype.onUserSignedOut = function () {
    };
    // tslint:enable:no-empty
    RequireAuthenticationComponent.prototype.render = function () {
        var _a = this.props, children = _a.children, loggedInUser = _a.loggedInUser;
        if (loggedInUser) {
            return children;
        }
        return (React.createElement("div", null,
            React.createElement("h3", null, "Log In Required"),
            React.createElement("p", null, "You must be logged-in to view this page.")));
    };
    return RequireAuthenticationComponent;
}(React.Component));
exports.RequireAuthenticationComponent = RequireAuthenticationComponent;
exports.default = react_router_dom_1.withRouter(react_redux_1.connect(mapStateToProps, mapDispatchToProps)(RequireAuthenticationComponent));
function mapStateToProps(store) {
    return {
        loggedInUser: store.userState.loggedInUser,
    };
}
function mapDispatchToProps(dispatch, ownProps) {
    return {
        login: function (user) {
            return __awaiter(this, void 0, void 0, function () {
                var userPermissions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(user && !user.expired)) return [3 /*break*/, 2];
                            return [4 /*yield*/, authorizedUserService_1.AuthorizedUserService.getUserByEmail(user.profile.email, user)];
                        case 1:
                            userPermissions = _a.sent();
                            dispatch({ type: 'USER_LOGIN', loggedInUser: user, userPermissions: userPermissions });
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        },
        tokenExpired: function () {
            dispatch({ type: 'USER_LOGIN', loggedInUser: null });
        },
    };
}


/***/ }),

/***/ 615:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RequireAuthentication_1 = __webpack_require__(614);
exports.RequireAuthentication = RequireAuthentication_1.default;
var Login_1 = __webpack_require__(611);
exports.Login = Login_1.default;
var Logout_1 = __webpack_require__(612);
exports.Logout = Logout_1.default;
var Profile_1 = __webpack_require__(613);
exports.Profile = Profile_1.default;
var CommonUx_1 = __webpack_require__(610);
exports.CommonUx = CommonUx_1.default;


/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_ux_1 = __webpack_require__(14);
var siteDataService_1 = __webpack_require__(141);
var React = __webpack_require__(3);
var react_redux_1 = __webpack_require__(17);
var react_router_dom_1 = __webpack_require__(15);
var ActionCreators = __webpack_require__(105);
var CustomerSiteModal_1 = __webpack_require__(617);
/* tslint:disable:no-empty jsx-no-lambda jsx-self-close*/
var CustomerSite = (function (_super) {
    __extends(CustomerSite, _super);
    function CustomerSite(props) {
        var _this = _super.call(this, props) || this;
        _this.handleContinueSiteInformationModal = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, siteDataService_1.requestSitePut(this.props.site.id, this.props.site.servIsId, this.props.accessToken)];
                    case 1:
                        _a.sent();
                        this.props.updateSite(this.props.site.id, this.props.accessToken);
                        this.handleCloseSiteInformationModal();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleCloseSiteInformationModal = function () {
            _this.setState({ siteInformationModal: false });
        };
        _this.handleShowInformationModal = function () { return __awaiter(_this, void 0, void 0, function () {
            var servIsSite, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ siteInformationModal: true });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, siteDataService_1.requestSiteGetById(this.props.site.servIsId, this.props.accessToken)];
                    case 2:
                        servIsSite = _a.sent();
                        this.setState({ servIsSite: servIsSite });
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        this.setState({ siteInformationModal: false });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            siteInformationModal: false,
            servIsSite: undefined
        };
        return _this;
    }
    CustomerSite.prototype.render = function () {
        var button = this.props.userPermissions && this.props.userPermissions.isAdmin
            ? (React.createElement("div", { className: 'col-md-2 text-right align-bottom button-top-buffer' },
                React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'default', icon: 'plus', onClick: this.handleShowInformationModal }, "Update Site")))
            : null;
        return (React.createElement("div", null,
            React.createElement(CustomerSiteModal_1.CustomerSiteModal, { isOpen: this.state.siteInformationModal, servIsSite: this.state.servIsSite, onClose: this.handleCloseSiteInformationModal, onContinue: this.handleContinueSiteInformationModal }),
            React.createElement("div", { className: 'container container-style padding-bottom' },
                React.createElement("div", { className: 'row' },
                    React.createElement("div", { className: 'col-md-10' },
                        React.createElement("div", null,
                            React.createElement("h3", null, "Customer Site")),
                        React.createElement("div", { className: 'row top-buffer' },
                            React.createElement("div", { className: 'col-xs-6' },
                                React.createElement("div", { className: 'row' },
                                    React.createElement("div", { className: 'col-xs-2' },
                                        React.createElement("b", null, "Site:")),
                                    React.createElement("div", { className: 'col-xs-4' }, this.props.site && this.props.site.siteName ? this.props.site.siteName : ''),
                                    React.createElement("div", { className: 'col-xs-2' },
                                        React.createElement("b", null, "Owner:")),
                                    React.createElement("div", { className: 'col-xs-4' }, this.props.site && this.props.site.owner ? this.props.site.owner : ''))),
                            React.createElement("div", { className: 'col-xs-6' },
                                React.createElement("div", { className: 'row' },
                                    React.createElement("div", { className: 'col-xs-2' },
                                        React.createElement("b", null, "City:")),
                                    React.createElement("div", { className: 'col-xs-4' }, this.props.site && this.props.site.city ? this.props.site.city : ''),
                                    React.createElement("div", { className: 'col-xs-2' },
                                        React.createElement("b", null, "Region:")),
                                    React.createElement("div", { className: 'col-xs-4', style: { paddingLeft: '40px' } }, this.props.site && this.props.site.regionName ? this.props.site.regionName : '')))),
                        React.createElement("div", { className: 'row top-buffer' },
                            React.createElement("div", { className: 'col-xs-6' },
                                React.createElement("div", { className: 'row' },
                                    React.createElement("div", { className: 'col-xs-2 servis-id-column' },
                                        React.createElement("b", null, "ServIS ID:")),
                                    React.createElement("div", { className: 'col-xs-4' }, this.props.site && this.props.site.servIsId ? this.props.site.servIsId : ''),
                                    React.createElement("div", { className: 'col-xs-2' },
                                        React.createElement("b", null, "Operator:")),
                                    React.createElement("div", { className: 'col-xs-4' }, this.props.site && this.props.site.operator ? this.props.site.operator : ''))),
                            React.createElement("div", { className: 'col-xs-6' },
                                React.createElement("div", { className: 'row' },
                                    React.createElement("div", { className: 'col-xs-2' },
                                        React.createElement("b", null, "Country:")),
                                    React.createElement("div", { className: 'col-xs-4' }, this.props.site && this.props.site.country ? this.props.site.country : ''),
                                    React.createElement("div", { className: 'col-xs-2' },
                                        React.createElement("b", null, "ServicePorts:")),
                                    React.createElement("div", { className: 'col-xs-4', style: { paddingLeft: '40px' } }, this.props.numberOfSavedServers))))),
                    React.createElement("div", null, button)))));
    };
    return CustomerSite;
}(React.Component));
exports.CustomerSite = CustomerSite;
exports.default = react_router_dom_1.withRouter(react_redux_1.connect(mapStateToProps, mapDispatchToProps)(CustomerSite));
function mapStateToProps(store) {
    var accessToken = store.userState.loggedInUser.access_token;
    return __assign({}, store.servicesState, store.serverState, { userPermissions: store.userState.userPermissions, accessToken: accessToken });
}
exports.mapStateToProps = mapStateToProps;
function mapDispatchToProps(dispatch) {
    return {
        updateSite: function (siteId, accessToken) { return dispatch(ActionCreators.onAllocationGetRequest(siteId, accessToken)); }
    };
}


/***/ }),

/***/ 617:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:jsx-no-multiline-js
var common_ux_1 = __webpack_require__(14);
var React = __webpack_require__(3);
__webpack_require__(910);
var CustomerSiteModal = (function (_super) {
    __extends(CustomerSiteModal, _super);
    function CustomerSiteModal(props) {
        return _super.call(this, props) || this;
    }
    CustomerSiteModal.prototype.render = function () {
        var body = this.props.servIsSite ? (React.createElement("div", null,
            React.createElement("div", { className: 'row' },
                React.createElement("div", { className: 'col-xs-6 vertical-padding' },
                    React.createElement("div", { className: 'col-xs-5 bold' }, "Site:"),
                    React.createElement("div", { className: 'col-xs-7' }, this.props.servIsSite.siteName ? this.props.servIsSite.siteName : '')),
                React.createElement("div", { className: 'col-xs-6 vertical-padding' },
                    React.createElement("div", { className: 'col-xs-5 bold' }, "Owner:"),
                    React.createElement("div", { className: 'col-xs-7' }, this.props.servIsSite.owner ? this.props.servIsSite.owner : ''))),
            React.createElement("div", { className: 'row' },
                React.createElement("div", { className: 'col-xs-6 vertical-padding' },
                    React.createElement("div", { className: 'col-xs-5 bold' }, "ServIS ID:"),
                    React.createElement("div", { className: 'col-xs-7' }, this.props.servIsSite.servIsId ? this.props.servIsSite.servIsId : '')),
                React.createElement("div", { className: 'col-xs-6 vertical-padding' },
                    React.createElement("div", { className: 'col-xs-5 bold' }, "Operator:"),
                    React.createElement("div", { className: 'col-xs-7' }, this.props.servIsSite.operator ? this.props.servIsSite.operator : ''))),
            React.createElement("div", { className: 'row' },
                React.createElement("div", { className: 'col-xs-6 vertical-padding' },
                    React.createElement("div", { className: 'col-xs-5 bold' }, "City:"),
                    React.createElement("div", { className: 'col-xs-7' }, this.props.servIsSite.city ? this.props.servIsSite.city : '')),
                React.createElement("div", { className: 'col-xs-6 vertical-padding' },
                    React.createElement("div", { className: 'col-xs-5 bold' }, "Country:"),
                    React.createElement("div", { className: 'col-xs-7' }, this.props.servIsSite.country ? this.props.servIsSite.country : ''))),
            React.createElement("div", { style: { borderBottom: '1px solid #e5e5e5' }, className: 'row' },
                React.createElement("div", { className: 'col-xs-6 vertical-padding' },
                    React.createElement("div", { className: 'col-xs-5 bold' }, "Region:"),
                    React.createElement("div", { className: 'col-xs-7' }, this.props.servIsSite.regionName ? this.props.servIsSite.regionName : ''))))) : (React.createElement("div", null,
            React.createElement("div", { className: 'row col-xs-12' }, "Loading...")));
        var modal = (React.createElement("div", { className: 'modal-window' },
            React.createElement("div", { className: 'modal-overlay' },
                React.createElement("div", { className: 'modal-outer' },
                    React.createElement("div", { className: 'modal-inner' },
                        React.createElement("div", { className: 'table' },
                            React.createElement("div", { className: 'row bottom-border' },
                                React.createElement("div", { className: 'col-xs-10' },
                                    React.createElement("h4", null, "Do You Want To Update Site Information?")),
                                React.createElement("div", { className: 'col-xs-2 text-right' },
                                    React.createElement("span", { className: 'close-icon font-12', onClick: this.props.onClose },
                                        React.createElement(common_ux_1.Icon, { icon: 'close' }))))),
                        body,
                        React.createElement("div", { style: { marginTop: '15px' }, className: 'text-right' },
                            React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'default', onClick: this.props.onClose }, "Cancel"),
                            React.createElement(common_ux_1.Button, { style: { marginLeft: '5px' }, buttonType: 'primary', buttonSize: 'default', onClick: this.props.onContinue }, "Continue")))))));
        return (this.props.isOpen ? modal : null);
    };
    return CustomerSiteModal;
}(React.Component));
exports.CustomerSiteModal = CustomerSiteModal;


/***/ }),

/***/ 618:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var common_ux_1 = __webpack_require__(14);
var constants_1 = __webpack_require__(25);
var React = __webpack_require__(3);
var models_1 = __webpack_require__(52);
/* tslint:disable:jsx-no-lambda jsx-no-multiline-js*/
var ServerTable = (function (_super) {
    __extends(ServerTable, _super);
    function ServerTable(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isModalOpen: false,
            serverToDelete: null,
            preEditServer: new models_1.Server(),
            serverId: {
                serverIdFirstSection: '',
                serverIdSecondSection: '',
                serverIdThirdSection: '',
                serverIdFourthSection: ''
            }
        };
        return _this;
    }
    ServerTable.prototype.render = function () {
        var _this = this;
        var ServerTableColumn = common_ux_1.ColumnDefinition;
        var deleteButton = (React.createElement("span", null,
            React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'default', onClick: function () {
                    _this.setState({
                        isModalOpen: false,
                        serverToDelete: null
                    });
                } },
                React.createElement("span", { "aria-hidden": 'true' }, "Cancel")),
            React.createElement(common_ux_1.Button, { buttonType: 'primary', buttonSize: 'default', onClick: function () {
                    _this.props.DeleteServer(_this.state.serverToDelete);
                    _this.setState({
                        isModalOpen: false,
                        serverToDelete: null
                    });
                } },
                React.createElement("span", { "aria-hidden": 'true' }, "Confirm"))));
        var hardwareTable = (React.createElement(common_ux_1.Table, { data: this.props.server, emptyMessage: 'This site has no hardware.' },
            React.createElement(ServerTableColumn, { cell: function (row) { return _this.renderDescription(row); }, header: 'Description' }),
            React.createElement(ServerTableColumn, { cell: function (row) { return _this.renderServerIdTextInput(row); }, header: 'Hardware ID' }),
            React.createElement(ServerTableColumn, { cell: function (row) { return _this.renderComboBoxCol(row, _this.props.operationalUsages); }, header: 'Operational Use' }),
            React.createElement(ServerTableColumn, { cell: function (row) { return _this.renderManageButtons(row); }, header: 'Manage' })));
        return (React.createElement("div", null,
            hardwareTable,
            React.createElement(common_ux_1.Modal, { isOpen: this.state.isModalOpen, header: 'Confirmation', footer: deleteButton, onClose: function () { _this.closeModal(); }, modalClassName: 'styleGuideModal' }, "Deleting hardware removes all corresponding instances. Please confirm.")));
    };
    ServerTable.prototype.componentWillReceiveProps = function (props) {
        if (props.serverIsAddingNew) {
            this.setState({
                serverId: {
                    serverIdFirstSection: '',
                    serverIdSecondSection: '',
                    serverIdThirdSection: '',
                    serverIdFourthSection: ''
                }
            });
        }
    };
    ServerTable.prototype.closeModal = function () {
        this.setState({
            isModalOpen: false,
            serverToDelete: null
        });
    };
    ServerTable.prototype.renderDescription = function (server) {
        var _this = this;
        if (server.isBeingEdited) {
            return React.createElement(common_ux_1.TextInput, { name: 'NewServerDescription', labelText: '', inputSize: 'small', value: server.description.value, validationState: server.description.valid ? 'valid' : 'invalid', errorMessage: 'Description must be unique and cannot exceed 100 characters; may include "-", "_", "(", ")". "', onChange: function (event) {
                    _this.props.ServerDescriptionEdit(event.target.value);
                } });
        }
        return server.description.value;
    };
    ServerTable.prototype.renderManageButtons = function (server) {
        var _this = this;
        if (server.isBeingEdited) {
            return React.createElement("div", null,
                React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'minimal', icon: 'save', onClick: function () { return _this.handleSaveEdit(server); }, disabled: !server.description.valid || !server.serverId.valid }),
                React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'minimal', icon: 'close', onClick: function () { return _this.handleCancelEdit(server); } }));
        }
        return React.createElement("div", null,
            React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'minimal', icon: 'edit', onClick: function () { return _this.handleEditExistingRow(server); } }),
            React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'minimal', icon: 'trash', onClick: function () {
                    _this.setState({
                        isModalOpen: true,
                        serverToDelete: server
                    });
                } }));
    };
    ServerTable.prototype.handleEditExistingRow = function (server) {
        this.setState({
            preEditServer: server
        });
        this.props.EditExistingRow(server);
        var serverIdSections = server.serverId.value.split('-');
        this.setState({
            serverId: {
                serverIdFirstSection: serverIdSections[0],
                serverIdSecondSection: serverIdSections[1],
                serverIdThirdSection: serverIdSections[2],
                serverIdFourthSection: serverIdSections[3]
            }
        });
    };
    ServerTable.prototype.handleSaveEdit = function (server) {
        this.props.UpdateServer(server);
        this.setState({
            preEditServer: new models_1.Server()
        });
    };
    ServerTable.prototype.handleCancelEdit = function (server) {
        this.props.ServerCancelEdit(this.state.preEditServer);
        this.setState({
            preEditServer: new models_1.Server()
        });
    };
    ServerTable.prototype.renderServerIdTextInput = function (server) {
        var _this = this;
        if (server.isBeingEdited) {
            return React.createElement("div", null,
                React.createElement("div", { className: 'serverIdInput' },
                    React.createElement(common_ux_1.TextInput, { name: 'NewServerId', labelText: '', inputSize: 'small', validationState: server.serverId.valid ? 'valid' : 'invalid', errorMessage: 'Alphanumeric field with 4 sections of 4 characters associated with the actual ServicePort', value: this.state.serverId.serverIdFirstSection, inputProps: { maxLength: constants_1.SERVER_ID_FIELD_MAX_LENGTH, id: '1' }, onChange: function (event) {
                            _this.handleServerIdFieldChange(event.target.value, _this.state.serverId.serverIdSecondSection, _this.state.serverId.serverIdThirdSection, _this.state.serverId.serverIdFourthSection);
                            _this.TabIfMaxLength(event.target.value, '1');
                        } })),
                React.createElement("div", { className: 'serverIdInputSeperator' }, "-"),
                React.createElement("div", { className: 'serverIdInput' },
                    React.createElement(common_ux_1.TextInput, { name: 'NewServerId2', labelText: '', inputSize: 'small', inputProps: { maxLength: constants_1.SERVER_ID_FIELD_MAX_LENGTH, id: '2' }, validationState: server.serverId.valid ? 'valid' : 'invalid', errorMessage: 'Alphanumeric field with 4 sections of 4 characters associated with the actual ServicePort', value: this.state.serverId.serverIdSecondSection, onChange: function (event) {
                            _this.handleServerIdFieldChange(_this.state.serverId.serverIdFirstSection, event.target.value, _this.state.serverId.serverIdThirdSection, _this.state.serverId.serverIdFourthSection);
                            _this.TabIfMaxLength(event.target.value, '2');
                        } })),
                React.createElement("div", { className: 'serverIdInputSeperator' }, "-"),
                React.createElement("div", { className: 'serverIdInput' },
                    React.createElement(common_ux_1.TextInput, { name: 'NewServerId3', labelText: '', inputSize: 'small', inputProps: { maxLength: constants_1.SERVER_ID_FIELD_MAX_LENGTH, id: '3' }, validationState: server.serverId.valid ? 'valid' : 'invalid', errorMessage: 'Alphanumeric field with 4 sections of 4 characters associated with the actual ServicePort', value: this.state.serverId.serverIdThirdSection, onChange: function (event) {
                            _this.handleServerIdFieldChange(_this.state.serverId.serverIdFirstSection, _this.state.serverId.serverIdSecondSection, event.target.value, _this.state.serverId.serverIdFourthSection);
                            _this.TabIfMaxLength(event.target.value, '3');
                        } })),
                React.createElement("div", { className: 'serverIdInputSeperator' }, "-"),
                React.createElement("div", { className: 'serverIdInput' },
                    React.createElement(common_ux_1.TextInput, { name: 'NewServerId4', labelText: '', inputSize: 'small', inputProps: { maxLength: constants_1.SERVER_ID_FIELD_MAX_LENGTH, id: '4' }, validationState: server.serverId.valid ? 'valid' : 'invalid', errorMessage: 'Alphanumeric field with 4 sections of 4 characters associated with the actual ServicePort', value: this.state.serverId.serverIdFourthSection, onChange: function (event) {
                            _this.handleServerIdFieldChange(_this.state.serverId.serverIdFirstSection, _this.state.serverId.serverIdSecondSection, _this.state.serverId.serverIdThirdSection, event.target.value);
                        } })));
        }
        return server.serverId.value;
    };
    ServerTable.prototype.handleServerIdFieldChange = function (serverIdFirstSection, serverIdSecondSection, serverIdThirdSection, serverIdFourthSection) {
        this.setState({
            serverId: Object.assign({}, this.state.serverId, {
                serverIdFirstSection: serverIdFirstSection,
                serverIdSecondSection: serverIdSecondSection,
                serverIdThirdSection: serverIdThirdSection,
                serverIdFourthSection: serverIdFourthSection
            })
        });
        this.props.ServerServerIdEdit(serverIdFirstSection + '-' + serverIdSecondSection + '-' + serverIdThirdSection + '-' + serverIdFourthSection);
    };
    ServerTable.prototype.TabIfMaxLength = function (value, id) {
        if (value.length >= constants_1.SERVER_ID_FIELD_MAX_LENGTH) {
            document.getElementById((Number(id) + 1).toString()).focus();
        }
    };
    ServerTable.prototype.renderComboBoxCol = function (server, operationalUsages) {
        var _this = this;
        if (server.isBeingEdited) {
            // TODO: get operational usages values from API call to Server/New?
            var value = {
                value: server.operationalUseType.id,
                label: server.operationalUseType.usageName
            };
            return React.createElement(common_ux_1.ComboBox, { onChange: function (newOption) {
                    _this.props.ServerOperationUseChange(newOption);
                }, value: value, size: 'small', options: operationalUsages });
        }
        return server.operationalUseType.usageName;
    };
    return ServerTable;
}(React.Component));
exports.default = ServerTable;


/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_ux_1 = __webpack_require__(14);
var ActionCreators = __webpack_require__(104);
var models_1 = __webpack_require__(52);
var constants_1 = __webpack_require__(25);
var React = __webpack_require__(3);
var react_redux_1 = __webpack_require__(17);
var react_router_dom_1 = __webpack_require__(15);
var HardwareTable_1 = __webpack_require__(618);
/* tslint:disable:jsx-no-lambda jsx-no-multiline-js jsx-self-close*/
var ServerTableContainer = (function (_super) {
    __extends(ServerTableContainer, _super);
    function ServerTableContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ServerTableContainer.prototype.render = function () {
        var _this = this;
        var ServerTableColumn = common_ux_1.ColumnDefinition;
        var canAddHardware = !this.props.hardwareIsEditing;
        var errorMessage = React.createElement("div", { hidden: !this.props.serverErrorMessageVisible },
            React.createElement(common_ux_1.Banner, { bannerType: 'error', id: 'errorBanner', onRemove: function (banner) { _this.props.clearErrorMessage(); } },
                constants_1.API_ERROR_MESSAGE,
                React.createElement("a", { href: constants_1.API_SUPPORT_MAILTO }, constants_1.API_SUPPORT_EMAIL)));
        var button = (React.createElement("div", { className: 'col-md-4 text-right button-top-buffer' },
            React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'default', icon: 'plus', disabled: !canAddHardware, onClick: function () { _this.props.AddNewEditableRow(new models_1.Server(), _this.props.match.params.siteId); } }, "Add Hardware")));
        return (React.createElement("div", { className: 'container container-style' },
            React.createElement("div", { className: 'row bottom-buffer' },
                React.createElement("div", { className: 'col-md-8' },
                    React.createElement("h3", null, "Hardware")),
                button),
            errorMessage,
            React.createElement("div", { className: 'bs' },
                React.createElement("div", { className: 'row' },
                    React.createElement("div", { className: 'col-md-12' },
                        React.createElement(HardwareTable_1.default, __assign({}, this.props)))))));
    };
    return ServerTableContainer;
}(React.Component));
exports.ServerTableContainer = ServerTableContainer;
exports.default = react_router_dom_1.withRouter(react_redux_1.connect(mapStateToProps, mapDispatchToProps, mergeProps)(ServerTableContainer));
function mapStateToProps(store) {
    var accessToken = store.userState.loggedInUser.access_token;
    return __assign({}, store.serverState, { accessToken: accessToken });
}
exports.mapStateToProps = mapStateToProps;
function mapDispatchToProps(dispatch) {
    return {
        AddNewEditableRow: function (server, siteId) { return dispatch(ActionCreators.onAddNewEditableRow(server, siteId)); },
        EditExistingRow: function (server) {
            dispatch(ActionCreators.onEditExistingRow(server));
        },
        ServerCancelEdit: function (server) { return dispatch(ActionCreators.onServerCancelEdit(server)); },
        authenticatedUpdateServer: function (server, accessToken) {
            if (server.description.valid && server.serverId.valid) {
                dispatch(ActionCreators.onUpdateServer(server, accessToken));
            }
            // TODO: else statement
        },
        ServerDescriptionEdit: function (updatedDescription) {
            dispatch(ActionCreators.onServerDescriptionEdit(updatedDescription));
        },
        ServerServerIdEdit: function (updatedServerId) {
            dispatch(ActionCreators.onServerServerIdEdit(updatedServerId.toUpperCase()));
        },
        ServerOperationUseChange: function (value) {
            dispatch(ActionCreators.onServerOperationalUseChange(value));
        },
        authenticatedDeleteServer: function (server, accessToken) { return dispatch(ActionCreators.onDeleteServer(server, accessToken)); },
        clearErrorMessage: function () { return dispatch(ActionCreators.clearErrorMessage()); }
    };
}
function mergeProps(_a, _b, ownProps) {
    var accessToken = _a.accessToken, propsFromState = __rest(_a, ["accessToken"]);
    var authenticatedUpdateServer = _b.authenticatedUpdateServer, authenticatedDeleteServer = _b.authenticatedDeleteServer, AddNewEditableRow = _b.AddNewEditableRow, ServerCancelEdit = _b.ServerCancelEdit, EditExistingRow = _b.EditExistingRow, ServerDescriptionEdit = _b.ServerDescriptionEdit, ServerServerIdEdit = _b.ServerServerIdEdit, ServerOperationUseChange = _b.ServerOperationUseChange, clearErrorMessage = _b.clearErrorMessage, propsFromDispatch = __rest(_b, ["authenticatedUpdateServer", "authenticatedDeleteServer", "AddNewEditableRow", "ServerCancelEdit", "EditExistingRow", "ServerDescriptionEdit", "ServerServerIdEdit", "ServerOperationUseChange", "clearErrorMessage"]);
    var UpdateServer = function (server) { return authenticatedUpdateServer(server, accessToken); };
    var DeleteServer = function (server) { return authenticatedDeleteServer(server, accessToken); };
    return __assign({}, propsFromState, ownProps, { UpdateServer: UpdateServer,
        DeleteServer: DeleteServer,
        AddNewEditableRow: AddNewEditableRow,
        ServerCancelEdit: ServerCancelEdit,
        ServerDescriptionEdit: ServerDescriptionEdit,
        ServerServerIdEdit: ServerServerIdEdit,
        ServerOperationUseChange: ServerOperationUseChange,
        EditExistingRow: EditExistingRow,
        clearErrorMessage: clearErrorMessage });
}


/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_ux_1 = __webpack_require__(14);
var constants_1 = __webpack_require__(25);
var moment = __webpack_require__(0);
var React = __webpack_require__(3);
var react_redux_1 = __webpack_require__(17);
var react_router_dom_1 = __webpack_require__(15);
var models_1 = __webpack_require__(52);
// TODO: Look for oppourtunities to reuse code and move functions to container component
/* tslint:disable:no-empty jsx-no-lambda jsx-self-close jsx-no-multiline-js*/
var LicenseAllowanceTable = (function (_super) {
    __extends(LicenseAllowanceTable, _super);
    function LicenseAllowanceTable(props) {
        var _this = _super.call(this, props) || this;
        _this.renderServiceTypeComboBoxCol = function (allocation) {
            if (allocation.isBeingEdited && allocation.licensableService.productName === '') {
                var options_1 = [];
                _this.props.serviceOptions.licensableServices.forEach(function (service) {
                    var optionToAdd = {
                        label: service.productName,
                        value: service.id,
                        assetType: service.assetType.assetTypeName,
                        licenseParameters: service.assetType.licenseParameters,
                        licensePassword: service.assetType.licensePassword
                    };
                    options_1.push(optionToAdd);
                });
                if (_this.state.serviceBeingEdited.licensableService.productName !== allocation.licensableService.productName && _this.state.serviceBeingEdited.licensableService.productName && !options_1.some(function (option) { return option.label === allocation.licensableService.productName; })) {
                    options_1.push({
                        label: allocation.licensableService.productName,
                        value: allocation.licensableService.id,
                        assetType: allocation.licensableService.assetType.assetTypeName,
                        licenseParameters: allocation.licensableService.licenseParameters,
                        licensePassword: allocation.licensableService.licensePassword
                    });
                }
                options_1 = options_1.filter(function (licensableService) { return licensableService.value !== _this.state.serviceBeingEdited.licensableService.id && licensableService.value !== constants_1.INVALID_SERVICE_VALUE; });
                return React.createElement(common_ux_1.ComboBox, { value: _this.state.productNameBeingEdited, onChange: _this.handleProductNameChange, size: 'small', options: options_1 });
            }
            return allocation.licensableService.productName;
        };
        _this.renderManageIcons = function (allocation) {
            if (allocation.isBeingEdited) {
                return React.createElement("div", null,
                    React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'minimal', icon: 'save', disabled: !_this.state.serviceBeingEdited.expirationDateUtc.valid || !_this.state.serviceBeingEdited.productOrderNumber.valid || !_this.state.serviceBeingEdited.totalAssetAllocation.valid, onClick: function () { return _this.handleUpdateAllocation(_this.state.serviceBeingEdited); } }),
                    React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'minimal', icon: 'close', onClick: function () { return _this.handleCancelAllocationEdit(allocation); } }),
                    "      ");
            }
            return React.createElement("div", null,
                React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'minimal', icon: 'edit', disabled: _this.props.allocationIsAddingNew, onClick: function () { return _this.handleEditExistingRow(allocation, _this.props.match.params.siteId); } }),
                React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'minimal', icon: 'trash', disabled: _this.props.allocationIsAddingNew, onClick: function () {
                        _this.setState({
                            isModalOpen: true,
                            licenseAllowanceToDelete: allocation
                        });
                    } }));
        };
        _this.state = {
            serviceBeingEdited: new models_1.Allocation(_this.props.match.params.siteId),
            productNameBeingEdited: null,
            mappedAllocations: [],
            isModalOpen: false,
            licenseAllowanceToDelete: null
        };
        _this.handleProductNameChange = _this.handleProductNameChange.bind(_this);
        _this.handleExpirationDateInputChange = _this.handleExpirationDateInputChange.bind(_this);
        _this.renderExpirationDateTextInput = _this.renderExpirationDateTextInput.bind(_this);
        return _this;
    }
    LicenseAllowanceTable.prototype.render = function () {
        var _this = this;
        var LicenseAllowanceTableColumn = common_ux_1.ColumnDefinition;
        var deleteButton = (React.createElement("span", null,
            React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'default', onClick: function () {
                    _this.setState({
                        isModalOpen: false,
                        licenseAllowanceToDelete: null
                    });
                } },
                React.createElement("span", { "aria-hidden": 'true' }, "Cancel")),
            React.createElement(common_ux_1.Button, { buttonType: 'primary', buttonSize: 'default', onClick: function () {
                    _this.props.DeleteAllocation(_this.state.licenseAllowanceToDelete, _this.state.licenseAllowanceToDelete.siteId);
                    _this.setState({
                        isModalOpen: false,
                        licenseAllowanceToDelete: null,
                    });
                } },
                React.createElement("span", { "aria-hidden": 'true' }, "Confirm"))));
        var allowanceTable;
        if (this.props.userPermissions && this.props.userPermissions.isAdmin) {
            allowanceTable = (React.createElement(common_ux_1.Table, { data: this.state.mappedAllocations, emptyMessage: 'This site has no license allowances.' },
                React.createElement(LicenseAllowanceTableColumn, { columnWidth: 3, nowrap: true, cell: function (row) { return _this.renderServiceTypeComboBoxCol(row.allocation); }, header: 'Service' }),
                React.createElement(LicenseAllowanceTableColumn, { columnWidth: 2, nowrap: true, cell: function (row) { return _this.renderAssetType(row.allocation); }, header: 'Asset Type' }),
                React.createElement(LicenseAllowanceTableColumn, { columnWidth: 1, nowrap: true, cell: function (row) { return _this.renderExpirationDateTextInput(row.allocation); }, header: 'Expiration' }),
                React.createElement(LicenseAllowanceTableColumn, { columnWidth: 1, nowrap: true, cell: function (row) { return _this.renderTextCell(row.allocation, 'totalAssetAllocation', _this.handleTotalAssetAllocationChange, _this.handleAssetCountErrorMessage()); }, header: 'Asset Count' }),
                React.createElement(LicenseAllowanceTableColumn, { columnWidth: 1, nowrap: true, cell: function (row) { return row.allocatedAssets.toString(); }, header: 'Allocated' }),
                React.createElement(LicenseAllowanceTableColumn, { columnWidth: 1, nowrap: true, cell: function (row) { return row.availableAssets.toString(); }, header: 'Available' }),
                React.createElement(LicenseAllowanceTableColumn, { columnWidth: 2, nowrap: true, cell: function (row) { return _this.renderTextCell(row.allocation, 'productOrderNumber', _this.handleProductOrderNumberChange, 'Alphanumeric field cannot exceed 10 characters'); }, header: 'PO#' }),
                React.createElement(LicenseAllowanceTableColumn, { columnWidth: 1, nowrap: true, cell: function (row) { return _this.renderManageIcons(row.allocation); }, header: 'Manage' })));
        }
        else {
            allowanceTable = (React.createElement(common_ux_1.Table, { data: this.state.mappedAllocations, emptyMessage: 'This site has no license allowances.' },
                React.createElement(LicenseAllowanceTableColumn, { columnWidth: 2, nowrap: true, cell: function (row) { return _this.renderTextCell(row.allocation, 'productOrderNumber', _this.handleProductOrderNumberChange, 'Alphanumeric field cannot exceed 10 characters'); }, header: 'PO#' }),
                React.createElement(LicenseAllowanceTableColumn, { columnWidth: 3, nowrap: true, cell: function (row) { return _this.renderServiceTypeComboBoxCol(row.allocation); }, header: 'Service' }),
                React.createElement(LicenseAllowanceTableColumn, { columnWidth: 2, nowrap: true, cell: function (row) { return _this.renderAssetType(row.allocation); }, header: 'Asset Type' }),
                React.createElement(LicenseAllowanceTableColumn, { columnWidth: 1, nowrap: true, cell: function (row) { return _this.renderExpirationDateTextInput(row.allocation); }, header: 'Expiration' }),
                React.createElement(LicenseAllowanceTableColumn, { columnWidth: 1, nowrap: true, cell: function (row) { return _this.renderTextCell(row.allocation, 'totalAssetAllocation', _this.handleTotalAssetAllocationChange, _this.handleAssetCountErrorMessage()); }, header: 'Asset Count' }),
                React.createElement(LicenseAllowanceTableColumn, { columnWidth: 1, nowrap: true, cell: function (row) { return row.allocatedAssets.toString(); }, header: 'Allocated' }),
                React.createElement(LicenseAllowanceTableColumn, { columnWidth: 1, nowrap: true, cell: function (row) { return row.availableAssets.toString(); }, header: 'Available' })));
        }
        return (React.createElement("div", null,
            allowanceTable,
            React.createElement(common_ux_1.Modal, { isOpen: this.state.isModalOpen, header: 'Confirmation', footer: deleteButton, onClose: function () { _this.closeModal(); }, modalClassName: 'styleGuideModal' }, "Deleting a service removes all corresponding instances. Please confirm.")));
    };
    LicenseAllowanceTable.prototype.renderAssetType = function (allocation) {
        return allocation.id === this.state.serviceBeingEdited.id ? this.state.serviceBeingEdited.licensableService.assetType.assetTypeName : allocation.licensableService.assetType.assetTypeName;
    };
    LicenseAllowanceTable.prototype.renderTextCell = function (allocation, field, onChangeFunction, errorMessage) {
        if (allocation.isBeingEdited) {
            return React.createElement(common_ux_1.TextInput, { name: 'LicenseAllowanceInput', labelText: '', inputSize: 'small', validationState: this.state.serviceBeingEdited[field].valid ? 'valid' : 'invalid', defaultValue: this.state.serviceBeingEdited[field].value, errorMessage: errorMessage, onChange: onChangeFunction.bind(this, allocation) });
        }
        return allocation[field].value.toString();
    };
    LicenseAllowanceTable.prototype.renderExpirationDateTextInput = function (allocation) {
        if (allocation.isBeingEdited) {
            // this check allows us to bind the value of the field to serviceBeingEdited while still populating
            // the current expiration date initially, before serviceBeingEdited has been set to a new date
            if (this.state.serviceBeingEdited.expirationDateUtc === new models_1.Allocation().expirationDateUtc) {
                this.setState({ serviceBeingEdited: allocation });
            }
            return React.createElement(common_ux_1.DatePicker, { id: 'normal', date: moment(this.state.serviceBeingEdited.expirationDateUtc.value), onDateChange: this.handleExpirationDateInputChange, errorMessage: 'Must be a valid date', isOutsideRange: function (day) { return moment().isSameOrAfter(day); }, validationState: this.state.serviceBeingEdited.expirationDateUtc.valid ? 'valid' : 'invalid' });
        }
        return moment(allocation.expirationDateUtc.value).format('MM/DD/YYYY');
    };
    LicenseAllowanceTable.prototype.handleExpirationDateInputChange = function (date) {
        this.setState({
            serviceBeingEdited: Object.assign({}, this.state.serviceBeingEdited, {
                expirationDateUtc: { value: date, valid: date._isValid }
            })
        });
    };
    LicenseAllowanceTable.prototype.handleTotalAssetAllocationChange = function (allocation, e) {
        var indexBeingEdited = this.state.mappedAllocations.map(function (a) { return a.allocation.isBeingEdited; }).indexOf(true);
        this.setState({
            serviceBeingEdited: Object.assign({}, this.state.serviceBeingEdited, {
                totalAssetAllocation: {
                    value: e.currentTarget.value,
                    valid: !isNaN(e.currentTarget.value) && parseInt(e.currentTarget.value, 10) >= this.state.mappedAllocations[indexBeingEdited].allocatedAssets && parseInt(e.currentTarget.value, 10) > 0
                }
            })
        });
    };
    LicenseAllowanceTable.prototype.handleAssetCountErrorMessage = function () {
        return (this.props.allocationIsAddingNew) ? 'Number must be greater than zero' : 'Number must be greater than or equal to the allocated amount';
    };
    LicenseAllowanceTable.prototype.handleProductOrderNumberChange = function (allocation, e) {
        this.setState({
            serviceBeingEdited: Object.assign({}, this.state.serviceBeingEdited, {
                productOrderNumber: {
                    value: e.currentTarget.value,
                    valid: constants_1.isValidInput(e.currentTarget.value, constants_1.PO_NUMBER_MAX_LENGTH)
                }
            })
        });
    };
    LicenseAllowanceTable.prototype.closeModal = function () {
        this.setState({
            isModalOpen: false,
            licenseAllowanceToDelete: null
        });
    };
    LicenseAllowanceTable.prototype.handleProductNameChange = function (productType) {
        var serviceList = this.props.serviceOptions.licensableServices.filter(function (licensableService) { return licensableService.id === productType.value; });
        this.setState({
            serviceBeingEdited: Object.assign({}, this.state.serviceBeingEdited, {
                licensableService: serviceList.length > 0 ? serviceList[0] : {
                    assetType: { assetTypeName: productType.assetType, id: productType.id },
                    id: productType.id,
                    licenseParameters: productType.licenseParameters,
                    licensePassword: productType.licensePassword,
                    productName: productType.label
                }
            }),
            productNameBeingEdited: {
                label: productType.label,
                value: productType.value
            }
        });
    };
    LicenseAllowanceTable.prototype.handleUpdateAllocation = function (serviceBeingEdited) {
        if (serviceBeingEdited.id === -1) {
            this.props.addAllocation(serviceBeingEdited);
        }
        else {
            this.props.UpdateAllocation(serviceBeingEdited);
        }
        this.setState({ serviceBeingEdited: new models_1.Allocation(this.props.match.params.siteId), productNameBeingEdited: '' });
    };
    LicenseAllowanceTable.prototype.handleCancelAllocationEdit = function (serviceBeingEdited) {
        this.props.CancelAllocationEdit(serviceBeingEdited);
        this.setState({ serviceBeingEdited: new models_1.Allocation(this.props.match.params.siteId), productNameBeingEdited: '' });
    };
    LicenseAllowanceTable.prototype.handleEditExistingRow = function (allocation, siteId) {
        this.setState({ serviceBeingEdited: allocation });
        this.setState({ productNameBeingEdited: { label: allocation.licensableService.productName, value: allocation.licensableService.assetType.id } });
        this.props.EditExistingRow(allocation, siteId);
    };
    LicenseAllowanceTable.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({
            mappedAllocations: nextProps.licenseAllowances.map(function (licenseAllowances) {
                var allocatedAssets = nextProps.server.map(function (server) {
                    return server.serviceAllocations.map(function (serviceAllocation) {
                        if (serviceAllocation.selectedServiceType.productName === licenseAllowances.licensableService.productName) {
                            return serviceAllocation.allocatedAssets.value;
                        }
                        return 0;
                    }).reduce(function (a, b) {
                        return Number(a) + Number(b);
                    }, 0);
                }).reduce(function (first, second) { return Number(first) + Number(second); }, 0);
                return {
                    allocation: licenseAllowances,
                    allocatedAssets: allocatedAssets,
                    availableAssets: licenseAllowances.totalAssetAllocation.value - allocatedAssets,
                };
            })
        });
    };
    return LicenseAllowanceTable;
}(React.Component));
exports.LicenseAllowanceTable = LicenseAllowanceTable;
exports.default = react_router_dom_1.withRouter(react_redux_1.connect(mapStateToProps)(LicenseAllowanceTable));
function mapStateToProps(store) {
    return __assign({}, store.servicesState, store.serviceOptionsState, store.serverState, { userPermissions: store.userState.userPermissions });
}
exports.mapStateToProps = mapStateToProps;


/***/ }),

/***/ 621:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_ux_1 = __webpack_require__(14);
var ActionCreators = __webpack_require__(105);
var constants_1 = __webpack_require__(25);
var React = __webpack_require__(3);
var react_redux_1 = __webpack_require__(17);
var react_router_dom_1 = __webpack_require__(15);
var models_1 = __webpack_require__(52);
var LicenseAllowanceTable_1 = __webpack_require__(620);
/* tslint:disable:no-empty jsx-no-lambda jsx-self-close*/
var LicenseAllowanceTableContainer = (function (_super) {
    __extends(LicenseAllowanceTableContainer, _super);
    function LicenseAllowanceTableContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            allocationToAdd: new models_1.Allocation(),
            // TODO: grab initial value for service dropdown from this.props.serviceOptions for allocationToAdd product name and productNameBeingEdited
            productNameBeingEdited: { label: '', value: null }
        };
        return _this;
    }
    LicenseAllowanceTableContainer.prototype.render = function () {
        var _this = this;
        var errorMessage = React.createElement("div", { hidden: !this.props.licenseAllowanceErrorMessageVisible },
            React.createElement(common_ux_1.Banner, { bannerType: 'error', id: 'errorBanner', onRemove: function (banner) { _this.props.clearErrorMessage(); } },
                constants_1.API_ERROR_MESSAGE,
                React.createElement("a", { href: constants_1.API_SUPPORT_MAILTO }, constants_1.API_SUPPORT_EMAIL)));
        var LicenseAllowanceTableColumn = common_ux_1.ColumnDefinition;
        var canAddService = this.props.serviceOptions.licensableServices.length > 0 && !this.props.allocationIsEditing;
        var button = this.props.userPermissions && this.props.userPermissions.isAdmin
            ? (React.createElement("div", { className: 'col-md-4 text-right align-bottom button-top-buffer' },
                React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'default', icon: 'plus', disabled: !canAddService, onClick: function () { _this.handleAddNewEditableRow(_this.props.licenseAllowances, _this.props.match.params.siteId); } }, "Add Service")))
            : null;
        return (React.createElement("div", { className: 'container container-style' },
            React.createElement("div", { className: 'row toolbar bottom-buffer' },
                React.createElement("div", { className: 'col-md-8' },
                    React.createElement("h3", null, "License Allowances")),
                button),
            errorMessage,
            React.createElement("div", { className: 'bs' },
                React.createElement("div", { className: 'row' },
                    React.createElement("div", { className: 'col-md-12' },
                        React.createElement(LicenseAllowanceTable_1.default, __assign({}, this.props)))))));
    };
    LicenseAllowanceTableContainer.prototype.handleAddNewEditableRow = function (licenseAllowances, siteId) {
        // not positive how to access the serviceOptions list from my constructor below so I am updating the product and asset type here before adding the new row
        var initialService = this.getInitialProductName(this.props.serviceOptions.licensableServices, this.props.licenseAllowances);
        this.setState({
            allocationToAdd: Object.assign({}, new models_1.Allocation(), {
                licensableService: {
                    productName: initialService.productName,
                    assetType: initialService.assetType,
                    licenseParameters: '',
                    licensePassword: '',
                    id: 0,
                }
            }),
            productNameBeingEdited: Object.assign({}, this.state.productNameBeingEdited, {
                label: initialService.productName,
                value: initialService.assetType.id
            }),
            serviceBeingEdited: Object.assign({}, this.state.serviceBeingEdited, {
                productOrderNumber: {
                    value: '',
                    valid: false
                }
            })
        });
        this.props.AddNewEditableRow(licenseAllowances, siteId);
    };
    LicenseAllowanceTableContainer.prototype.getInitialProductName = function (services, licenseAllowances) {
        var _loop_1 = function (service) {
            if (!this_1.props.licenseAllowances.find(function (x) { return x.licensableService.productName === service.productName; })) {
                return { value: service };
            }
        };
        var this_1 = this;
        for (var _i = 0, services_1 = services; _i < services_1.length; _i++) {
            var service = services_1[_i];
            var state_1 = _loop_1(service);
            if (typeof state_1 === "object")
                return state_1.value;
        }
        return { id: -1, assetType: { id: -1, assetTypeName: '' }, licenseParameters: '', licensePassword: '', productName: '' };
    };
    return LicenseAllowanceTableContainer;
}(React.Component));
exports.LicenseAllowanceTableContainer = LicenseAllowanceTableContainer;
exports.default = react_router_dom_1.withRouter(react_redux_1.connect(mapStateToProps, mapDispatchToProps, mergeProps)(LicenseAllowanceTableContainer));
function mapStateToProps(store) {
    var accessToken = store.userState.loggedInUser.access_token;
    return __assign({}, store.servicesState, store.serviceOptionsState, store.serverState, { userPermissions: store.userState.userPermissions, accessToken: accessToken });
}
exports.mapStateToProps = mapStateToProps;
function mapDispatchToProps(dispatch) {
    return {
        addAllocation: function (allocation, accessToken) {
            return dispatch(ActionCreators.onAddAllocation(allocation, accessToken));
        },
        AddNewEditableRow: function (allocations, siteId, accessToken) {
            return dispatch(ActionCreators.onAddNewEditableRow(allocations, siteId, accessToken));
        },
        EditExistingRow: function (allocation, siteId, accessToken) {
            return dispatch(ActionCreators.onEditExistingRow(allocation, siteId, accessToken));
        },
        CancelAllocationEdit: function (allocation) {
            return dispatch(ActionCreators.onCancelAllocationEdit(allocation));
        },
        UpdateAllocation: function (allocation, accessToken) {
            return dispatch(ActionCreators.onUpdateAllocation(allocation, accessToken));
        },
        DeleteAllocation: function (allocation, siteId, accessToken) {
            return dispatch(ActionCreators.onDeleteAllocation(allocation, siteId, accessToken));
        },
        CancelAddAllocation: function () { return dispatch(ActionCreators.onCancelAddAllocation()); },
        clearErrorMessage: function () { return dispatch(ActionCreators.clearErrorMessage()); }
    };
}
function mergeProps(_a, _b, ownProps) {
    var accessToken = _a.accessToken, propsFromState = __rest(_a, ["accessToken"]);
    var addAllocation = _b.addAllocation, AddNewEditableRow = _b.AddNewEditableRow, EditExistingRow = _b.EditExistingRow, CancelAllocationEdit = _b.CancelAllocationEdit, UpdateAllocation = _b.UpdateAllocation, DeleteAllocation = _b.DeleteAllocation, clearErrorMessage = _b.clearErrorMessage, propsFromDispatch = __rest(_b, ["addAllocation", "AddNewEditableRow", "EditExistingRow", "CancelAllocationEdit", "UpdateAllocation", "DeleteAllocation", "clearErrorMessage"]);
    return __assign({}, propsFromState, propsFromDispatch, ownProps, { addAllocation: function (allocation) { return addAllocation(allocation, accessToken); }, AddNewEditableRow: function (allocations, siteId) { return AddNewEditableRow(allocations, siteId, accessToken); }, EditExistingRow: function (allocation, siteId) {
            EditExistingRow(allocation, siteId, accessToken);
        }, CancelAllocationEdit: function (allocation) {
            CancelAllocationEdit(allocation);
        }, UpdateAllocation: function (allocation) { return UpdateAllocation(allocation, accessToken); }, DeleteAllocation: function (allocation, siteId) { return DeleteAllocation(allocation, siteId, accessToken); }, clearErrorMessage: function () { return clearErrorMessage(); } });
}


/***/ }),

/***/ 622:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(3);
var react_redux_1 = __webpack_require__(17);
var react_router_dom_1 = __webpack_require__(15);
var MachineTableContainer_1 = __webpack_require__(624);
/* tslint:disable:jsx-no-lambda jsx-no-multiline-js*/
var ServerWithServicesList = (function (_super) {
    __extends(ServerWithServicesList, _super);
    function ServerWithServicesList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ServerWithServicesList.prototype.render = function () {
        return this.props.server.map(function (serverWithServices, index) {
            return (React.createElement(MachineTableContainer_1.default, { key: index.toString(), name: serverWithServices.description.value, serviceInstances: serverWithServices.serviceAllocations, serverWithServicesId: serverWithServices.id, siteId: serverWithServices.siteId }));
        });
    };
    return ServerWithServicesList;
}(React.Component));
exports.ServerWithServicesList = ServerWithServicesList;
exports.default = react_router_dom_1.withRouter(react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ServerWithServicesList));
function mapStateToProps(store) {
    var props = __assign({}, store.servicesState, store.serviceOptionsState, store.serverState);
    return props;
}
exports.mapStateToProps = mapStateToProps;
function mapDispatchToProps(dispatch) {
    return {};
}


/***/ }),

/***/ 623:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_ux_1 = __webpack_require__(14);
var React = __webpack_require__(3);
/* tslint:disable:jsx-no-lambda jsx-no-multiline-js*/
var ServerWithServicesTable = (function (_super) {
    __extends(ServerWithServicesTable, _super);
    function ServerWithServicesTable(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            componentServiceInstances: _this.props.componentServiceInstances.map(function (componentCI, idx) {
                return __assign({}, componentCI, { counter: idx + 1 });
            }),
            isModalOpen: false,
            serviceInstanceToDelete: null
        };
        return _this;
    }
    ServerWithServicesTable.prototype.render = function () {
        var _this = this;
        var ServerWithServicesTableColumn = common_ux_1.ColumnDefinition;
        var deleteButton = (React.createElement("span", null,
            React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'default', onClick: function () {
                    _this.setState({
                        isModalOpen: false,
                        serviceInstanceToDelete: null
                    });
                } },
                React.createElement("span", { "aria-hidden": 'true' }, "Cancel")),
            React.createElement(common_ux_1.Button, { buttonType: 'primary', buttonSize: 'default', onClick: function () {
                    _this.props.deleteRow(_this.state.serviceInstanceToDelete);
                    _this.setState({
                        isModalOpen: false,
                        serviceInstanceToDelete: null
                    });
                } },
                React.createElement("span", { "aria-hidden": 'true' }, "Confirm"))));
        var serviceInstanceTable = (React.createElement(common_ux_1.Table, { data: this.state.componentServiceInstances, emptyMessage: this.props.name + ' has no service instances.' },
            React.createElement(ServerWithServicesTableColumn, { nowrap: true, cell: function (row) { return row.counter; }, header: 'Instance' }),
            React.createElement(ServerWithServicesTableColumn, { columnWidth: 3, nowrap: true, cell: function (row) { return _this.renderService(row); }, header: 'Service' }),
            React.createElement(ServerWithServicesTableColumn, { columnWidth: 2, nowrap: true, cell: function (row) { return _this.renderAssetType(row); }, header: 'Asset Type' }),
            React.createElement(ServerWithServicesTableColumn, { nowrap: true, cell: function (row) { return _this.renderAllocateAssets(row, 'Number must be greater than zero and cannot exceed available asset count'); }, header: 'Allocate Assets' }),
            React.createElement(ServerWithServicesTableColumn, { nowrap: true, cell: function (row) { return _this.renderManageButtons(row); }, header: 'Manage' })));
        return (React.createElement("div", null,
            serviceInstanceTable,
            React.createElement(common_ux_1.Modal, { isOpen: this.state.isModalOpen, header: 'Confirmation', footer: deleteButton, onClose: function () { _this.closeModal(); }, modalClassName: 'styleGuideModal' }, "Deleting an instance credits available asset count for the service. Please confirm.")));
    };
    ServerWithServicesTable.prototype.renderService = function (serviceInstance) {
        var _this = this;
        if (serviceInstance.isBeingEdited) {
            var options = this.props.availableServicesList.map(function (service) {
                return {
                    value: service.id,
                    label: service.productName
                };
            });
            var value = void 0;
            if (serviceInstance.selectedServiceType) {
                value = {
                    value: serviceInstance.selectedServiceType.id,
                    label: serviceInstance.selectedServiceType.productName
                };
            }
            return React.createElement(common_ux_1.ComboBox, { value: value, onChange: function (newOption) { _this.updateServiceValue(newOption, serviceInstance); }, size: 'small', options: options });
        }
        return serviceInstance.selectedServiceType ? serviceInstance.selectedServiceType.productName : '';
    };
    ServerWithServicesTable.prototype.renderAssetType = function (serviceInstance) {
        if (serviceInstance.isBeingEdited) {
            return React.createElement(common_ux_1.TextInput, { name: '', labelText: '', inputSize: 'small', value: serviceInstance.assetType, readOnly: true, disabled: true });
        }
        return serviceInstance.assetType;
    };
    ServerWithServicesTable.prototype.renderAllocateAssets = function (serviceInstance, errorMessage) {
        var _this = this;
        if (serviceInstance.isBeingEdited) {
            return React.createElement(common_ux_1.TextInput, { name: 'AllocatedAssets', labelText: '', inputSize: 'small', value: serviceInstance.allocatedAssets.value.toString(), validationState: serviceInstance.allocatedAssets.valid ? 'valid' : 'invalid', errorMessage: errorMessage, onChange: function (evt) { return _this.updateAllocatedAssetsValue(evt, serviceInstance); } });
        }
        return serviceInstance.allocatedAssets.value.toString();
    };
    ServerWithServicesTable.prototype.renderManageButtons = function (serviceInstance) {
        var _this = this;
        if (serviceInstance.isBeingEdited) {
            return React.createElement("div", null,
                React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'minimal', icon: 'save', disabled: (serviceInstance.selectedServiceType && serviceInstance.selectedServiceType.productName) && serviceInstance.allocatedAssets.valid ? false : true, onClick: function () {
                        _this.props.updateServerWithServices(serviceInstance);
                    } }),
                React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'minimal', icon: 'close', onClick: function () { return _this.props.cancelEdit(); } }));
        }
        return React.createElement("div", null,
            React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'minimal', icon: 'edit', onClick: function () { _this.props.editExistingRow(serviceInstance); } }),
            React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'minimal', icon: 'trash', onClick: function () {
                    _this.setState({
                        isModalOpen: true,
                        serviceInstanceToDelete: serviceInstance
                    });
                } }));
    };
    ServerWithServicesTable.prototype.closeModal = function () {
        this.setState({
            isModalOpen: false,
            serviceInstanceToDelete: null
        });
    };
    ServerWithServicesTable.prototype.updateAllocatedAssetsValue = function (evt, serviceInstanceEdited) {
        var _this = this;
        this.setState({
            componentServiceInstances: this.state.componentServiceInstances.map(function (serviceInstance) {
                return Object.assign({}, serviceInstance, { allocatedAssets: serviceInstanceEdited.id === serviceInstance.id ? { value: evt.target.value, valid: _this.isValidAllocatedAssets(evt.target.value, serviceInstanceEdited) } : serviceInstance.allocatedAssets });
            })
        });
    };
    ServerWithServicesTable.prototype.isValidAllocatedAssets = function (value, channelInstanceEdited) {
        var checkValues = this.props.checkValues(channelInstanceEdited, value);
        return !isNaN(value) && parseInt(value, 10) > 0 && checkValues;
    };
    ServerWithServicesTable.prototype.updateServiceValue = function (newOption, serviceInstanceEdited) {
        var _this = this;
        var newSelectedServiceType = this.props.availableServicesList.filter(function (serviceOption) { return serviceOption.id === newOption.value; })[0];
        this.setState({
            componentServiceInstances: this.state.componentServiceInstances.map(function (serviceInstance) {
                return Object.assign({}, serviceInstance, {
                    selectedServiceType: serviceInstanceEdited.id === serviceInstance.id ? newSelectedServiceType : serviceInstance.selectedServiceType,
                    assetType: serviceInstanceEdited.id === serviceInstance.id ? newSelectedServiceType.assetType.assetTypeName : serviceInstance.assetType,
                    allocatedAssets: {
                        value: serviceInstance.allocatedAssets.value,
                        valid: _this.isValidAllocatedAssets(serviceInstance.allocatedAssets.value, Object.assign({}, serviceInstance, {
                            selectedServiceType: serviceInstanceEdited.id === serviceInstance.id ? newSelectedServiceType : serviceInstance.selectedServiceType,
                            assetType: serviceInstanceEdited.id === serviceInstance.id ? newSelectedServiceType.assetType.assetTypeName : serviceInstance.assetType,
                        }))
                    }
                });
            })
        });
    };
    ServerWithServicesTable.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({
            componentServiceInstances: nextProps.componentServiceInstances.map(function (componentCI, idx) {
                return __assign({}, componentCI, { counter: idx + 1 });
            })
        });
    };
    return ServerWithServicesTable;
}(React.Component));
exports.default = ServerWithServicesTable;


/***/ }),

/***/ 624:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_ux_1 = __webpack_require__(14);
var React = __webpack_require__(3);
var react_redux_1 = __webpack_require__(17);
var react_router_dom_1 = __webpack_require__(15);
var ActionCreators = __webpack_require__(324);
var models_1 = __webpack_require__(52);
var MachineTable_1 = __webpack_require__(623);
/* tslint:disable:jsx-no-lambda*/
var ServerWithServicesTableContainer = (function (_super) {
    __extends(ServerWithServicesTableContainer, _super);
    function ServerWithServicesTableContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { componentServiceInstances: _this.props.serviceInstances };
        return _this;
    }
    ServerWithServicesTableContainer.prototype.render = function () {
        var _this = this;
        var canAddInstance = false;
        for (var _i = 0, _a = this.props.licenseAllowances; _i < _a.length; _i++) {
            var x = _a[_i];
            if (x.totalAssetAllocation.value > 0) {
                canAddInstance = true;
                break;
            }
        }
        var button = (React.createElement("div", { className: 'col-md-4 text-right button-top-buffer' },
            React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'default', icon: 'plus', disabled: !canAddInstance, onClick: function () { _this.addNewEditableRow(_this.props.serverWithServicesId, _this.props.siteId); } }, "Add Instance")));
        var availableServices = this.props.availableServices === null ? this.props.licenseAllowances.map(function (a) { return a.licensableService; }) : this.props.availableServices;
        return (
        // check the instancesVisible flag on the server table being rendered
        React.createElement("div", { className: this.props.server.filter(function (x) { return x.description.value === _this.props.name; })[0].isAvailable ? 'container container-style' : 'hidden' },
            React.createElement("div", { className: 'row bottom-buffer' },
                React.createElement("div", { className: 'col-md-8' },
                    React.createElement("h3", null, this.props.name)),
                button),
            React.createElement("div", { className: 'bs' },
                React.createElement("div", { className: 'row' },
                    React.createElement("div", { className: 'col-md-12' },
                        React.createElement(MachineTable_1.default, __assign({}, this.props, { availableServicesList: availableServices, componentServiceInstances: this.state.componentServiceInstances, editExistingRow: this.editExistingRow.bind(this), cancelEdit: this.cancelEdit.bind(this) })))))));
    };
    ServerWithServicesTableContainer.prototype.addNewEditableRow = function (serverWithServicesId, siteId) {
        this.setState({
            componentServiceInstances: this.props.serviceInstances.concat([new models_1.ServiceInstance(serverWithServicesId, siteId, this.props.availableServices)])
        });
    };
    ServerWithServicesTableContainer.prototype.editExistingRow = function (editingServiceInstance) {
        this.setState({
            componentServiceInstances: this.props.serviceInstances.map(function (serviceInstance) {
                return Object.assign({}, serviceInstance, { isBeingEdited: editingServiceInstance.id === serviceInstance.id });
            })
        });
    };
    ServerWithServicesTableContainer.prototype.cancelEdit = function () {
        this.setState({
            componentServiceInstances: this.props.serviceInstances.map(function (serviceInstance) {
                return Object.assign({}, serviceInstance, { isBeingEdited: false });
            })
        });
    };
    ServerWithServicesTableContainer.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({ componentServiceInstances: nextProps.serviceInstances });
    };
    return ServerWithServicesTableContainer;
}(React.Component));
exports.ServerWithServicesTableContainer = ServerWithServicesTableContainer;
exports.default = react_router_dom_1.withRouter(react_redux_1.connect(mapStateToProps, mapDispatchToProps, mergeProps)(ServerWithServicesTableContainer));
function mapStateToProps(store) {
    var accessToken = store.userState.loggedInUser.access_token;
    var props = __assign({}, store.servicesState, store.serviceOptionsState, store.serverState, { accessToken: accessToken });
    return props;
}
exports.mapStateToProps = mapStateToProps;
function mapDispatchToProps(dispatch) {
    return {
        deleteRow: function (serviceInstance, accessToken) {
            return dispatch(ActionCreators.onDeleteRow(serviceInstance, accessToken));
        },
        updateServerWithServices: function (serviceInstance, accessToken) {
            return dispatch(ActionCreators.onUpdateServerWithServices(serviceInstance, accessToken));
        },
    };
}
function mergeProps(_a, _b, ownProps) {
    var deleteRow = _b.deleteRow, updateServerWithServices = _b.updateServerWithServices;
    var accessToken = _a.accessToken, propsFromState = __rest(_a, ["accessToken"]);
    return __assign({}, propsFromState, ownProps, { deleteRow: function (serviceInstance) { return deleteRow(serviceInstance, accessToken); }, updateServerWithServices: function (serviceInstance) { return updateServerWithServices(serviceInstance, accessToken); }, checkValues: function (serviceInstance, newValue) {
            var mappedAllocations = propsFromState.licenseAllowances.map(function (licenseAllowances) {
                var allocatedAssets = propsFromState.server.map(function (server) {
                    var saMap = server.serviceAllocations.map(function (serviceAllocation) {
                        if (serviceInstance.id !== -1 && serviceInstance.id === serviceAllocation.id && serviceInstance.selectedServiceType.productName === licenseAllowances.licensableService.productName) {
                            return Number(newValue);
                        }
                        else if (serviceAllocation.selectedServiceType.productName === licenseAllowances.licensableService.productName) {
                            return serviceAllocation.id === serviceInstance.id ? Number(newValue) : serviceAllocation.allocatedAssets.value;
                        }
                        return 0;
                    });
                    if (serviceInstance.id === -1 && serviceInstance.selectedServiceType && licenseAllowances.licensableService.id === serviceInstance.selectedServiceType.id && server.id === serviceInstance.serverId) {
                        saMap.push(Number(newValue));
                    }
                    return saMap.reduce(function (a, b) {
                        return Number(a) + Number(b);
                    }, 0);
                }).reduce(function (first, second) { return Number(first) + Number(second); }, 0);
                return {
                    allocation: licenseAllowances,
                    allocatedAssets: allocatedAssets,
                    availableAssets: licenseAllowances.totalAssetAllocation.value - allocatedAssets
                };
            });
            var matching = mappedAllocations.filter(function (mappedAllocation) {
                return mappedAllocation.allocation.licensableService.id === serviceInstance.selectedServiceType.id;
            })[0] || 0;
            return 0 < matching.allocatedAssets && matching.allocatedAssets <= matching.allocation.totalAssetAllocation.value;
        } });
}


/***/ }),

/***/ 625:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_ux_1 = __webpack_require__(14);
var ServiceActionCreators = __webpack_require__(105);
var SiteLicenseActionCreators = __webpack_require__(325);
var React = __webpack_require__(3);
var react_redux_1 = __webpack_require__(17);
var react_router_dom_1 = __webpack_require__(15);
var ActionCreators = __webpack_require__(104);
var CustomerSite_1 = __webpack_require__(616);
var HardwareTableContainer_1 = __webpack_require__(619);
var LicenseAllowanceTableContainer_1 = __webpack_require__(621);
var MachineList_1 = __webpack_require__(622);
/* tslint:disable:no-empty jsx-no-lambda jsx-self-close*/
// TODO: track down anys and type everything
var SiteLicense = (function (_super) {
    __extends(SiteLicense, _super);
    function SiteLicense() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SiteLicense.prototype.render = function () {
        var _this = this;
        var page = (React.createElement("div", null,
            React.createElement("h3", null, "Not Authorized"),
            React.createElement("p", null,
                this.props.userPermissions.email,
                " is not an authorized user. Please contact your supervisor to correct this.")));
        if (this.props.userPermissions.allScopes || (this.props.servicesState.site && this.props.userPermissions.scopes.some(function (s) { return s === _this.props.servicesState.site.country; }))) {
            page = (React.createElement("div", { className: 'container' },
                React.createElement(CustomerSite_1.default, null),
                React.createElement(LicenseAllowanceTableContainer_1.default, null),
                React.createElement(HardwareTableContainer_1.default, null),
                React.createElement(MachineList_1.default, null),
                React.createElement("div", { className: 'container' },
                    React.createElement("div", { className: 'row bottom-buffer' },
                        React.createElement("div", { className: 'text-right' },
                            React.createElement(common_ux_1.Button, { buttonType: 'primary', buttonSize: 'default', disabled: !this.props.server.reduce(function (a, b) { return a || b.serviceAllocations.length > 0; }, false), onClick: function () { return _this.props.requestLicenseFile(_this.props.match.params.siteId); } }, "Download ServicePort License File"))))));
        }
        return (page);
    };
    SiteLicense.prototype.componentDidMount = function () {
        this.props.requestServerGet(this.props.match.params.siteId);
        this.props.requestServices(this.props.match.params.siteId);
        this.props.requestServiceTypes(this.props.match.params.siteId);
        this.props.requestOperationalUsagesGet();
    };
    return SiteLicense;
}(React.Component));
exports.SiteLicense = SiteLicense;
exports.default = react_router_dom_1.withRouter(react_redux_1.connect(mapStateToProps, mapDispatchToProps, mergeProps)(SiteLicense));
function mapStateToProps(store) {
    var accessToken = store.userState.loggedInUser.access_token;
    return __assign({}, store.servicesState, store.serverState, store.serviceOptionsState, store.userState, { servicesState: store.servicesState, userPermissions: store.userState.userPermissions, accessToken: accessToken });
}
exports.mapStateToProps = mapStateToProps;
function mapDispatchToProps(dispatch) {
    return {
        requestServerGet: function (siteId, accessToken) { return dispatch(ActionCreators.onServerGetRequest(siteId, accessToken)); },
        requestServices: function (siteId, accessToken) { return dispatch(ServiceActionCreators.onAllocationGetRequest(siteId, accessToken)); },
        requestServiceTypes: function (siteId, accessToken) { return dispatch(ServiceActionCreators.onNewAllocationGetRequest(siteId, accessToken)); },
        requestOperationalUsagesGet: function (accessToken) { return dispatch(ActionCreators.onOperationalUsagesGetRequest(accessToken)); },
        requestLicenseFile: function (siteId, siteName, accessToken) { return dispatch(SiteLicenseActionCreators.onLicenseFileGetRequest(siteId, siteName, accessToken)); }
    };
}
function mergeProps(_a, _b, ownProps) {
    var accessToken = _a.accessToken, site = _a.site, loggedInUser = _a.loggedInUser, propsFromState = __rest(_a, ["accessToken", "site", "loggedInUser"]);
    var requestServerGet = _b.requestServerGet, requestServices = _b.requestServices, requestServiceTypes = _b.requestServiceTypes, requestOperationalUsagesGet = _b.requestOperationalUsagesGet, requestLicenseFile = _b.requestLicenseFile, propsFromDispatch = __rest(_b, ["requestServerGet", "requestServices", "requestServiceTypes", "requestOperationalUsagesGet", "requestLicenseFile"]);
    return __assign({}, propsFromState, propsFromDispatch, ownProps, { requestServerGet: function (siteId) { return requestServerGet(siteId, accessToken); }, requestServices: function (siteId) { return requestServices(siteId, accessToken); }, requestServiceTypes: function (siteId) { return requestServiceTypes(siteId, accessToken); }, requestOperationalUsagesGet: function () { return requestOperationalUsagesGet(accessToken); }, requestLicenseFile: function (siteId, siteName) { return requestLicenseFile(siteId, site.siteName, accessToken); } });
}


/***/ }),

/***/ 626:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LicenseContainer_1 = __webpack_require__(326);
exports.LicenseContainerComponent = LicenseContainer_1.default;
var reducers_1 = __webpack_require__(137);
exports.licenseAllowanceReducer = reducers_1.licenseAllowanceReducer;
var reducers_2 = __webpack_require__(137);
exports.serverReducer = reducers_2.serverReducer;
var reducers_3 = __webpack_require__(137);
exports.serviceOptionsReducer = reducers_3.serviceOptionsReducer;


/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(3);
var common_ux_1 = __webpack_require__(14);
/* tslint:disable:jsx-no-lambda */
var Sites = (function (_super) {
    __extends(Sites, _super);
    function Sites() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Sites.prototype.render = function () {
        var _this = this;
        var SiteTableColumn = common_ux_1.ColumnDefinition;
        var _a = this.props, sites = _a.sites, sortingSettings = _a.sortingSettings;
        if (this.props.sites.length > 0 || this.props.sitesLoading) {
            return (React.createElement(common_ux_1.Table, { data: sites, hover: true, emptyMessage: 'Loading ..', sortedColumnName: sortingSettings.sortField, sortedColDirection: sortingSettings.sortDirection, headerClick: this.props.sortField },
                React.createElement(SiteTableColumn, { cell: function (row) { return React.createElement(common_ux_1.RadioButton, { id: 'box' + row.siteId.toString(), checked: _this.props.siteSelected && _this.props.selectedSite.servIsId === row.servIsId, onChange: function () { return _this.props.onCheck(row); } }); } }),
                React.createElement(SiteTableColumn, { cell: function (row) { return row.name; }, header: 'Site Name', columnName: 'SiteName' }),
                React.createElement(SiteTableColumn, { cell: function (row) { return row.servIsId; }, header: 'ServIS ID', columnName: 'ServIsId' }),
                React.createElement(SiteTableColumn, { cell: function (row) { return row.customer; }, header: 'Customer (Owner)', columnName: 'Owner' }),
                React.createElement(SiteTableColumn, { cell: function (row) { return row.region; }, header: 'Region', columnName: 'RegionName' }),
                React.createElement(SiteTableColumn, { cell: function (row) { return row.registered ? 'Yes' : 'No'; }, header: 'Registered', columnName: 'Registered' })));
        }
        else {
            if (this.props.searchFilter.length > 0) {
                return (React.createElement("div", null,
                    React.createElement("p", null, "No results found based on provided search criteria."),
                    React.createElement("p", null, "Make sure all words are spelled correctly."),
                    React.createElement("p", null,
                        "Try again or contact customer Support at ",
                        React.createElement("a", { href: 'mailto:us-iasvsupport@abb.com' }, "us-iasvsupport@abb.com."))));
            }
        }
        return (React.createElement("p", null, "should not get here"));
    };
    return Sites;
}(React.Component));
exports.default = Sites;


/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:jsx-no-lambda no-empty*/
var common_ux_1 = __webpack_require__(14);
var shared_1 = __webpack_require__(140);
var models_1 = __webpack_require__(139);
var constants_1 = __webpack_require__(25);
var React = __webpack_require__(3);
var react_redux_1 = __webpack_require__(17);
var react_router_dom_1 = __webpack_require__(15);
var ActionCreators = __webpack_require__(138);
var Sites_1 = __webpack_require__(627);
var RegisterSitesContainer = (function (_super) {
    __extends(RegisterSitesContainer, _super);
    function RegisterSitesContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RegisterSitesContainer.prototype.render = function () {
        var _this = this;
        var errorMessage;
        if (this.props.siteRegister.attempt && this.props.siteRegister.success) {
            this.props.history.push("/Licenses/" + this.props.siteRegister.siteId);
        }
        else if (this.props.siteRegister.attempt && !this.props.siteRegister.success) {
            errorMessage = React.createElement("div", { className: 'row' },
                " ",
                React.createElement(common_ux_1.Banner, { bannerType: 'error', id: 'errorBanner', onRemove: function (banner) { } }, "Error"),
                React.createElement("br", null),
                React.createElement("br", null));
        }
        var SiteTableColumn = common_ux_1.ColumnDefinition;
        return (React.createElement("div", { className: 'container' },
            React.createElement("div", null,
                React.createElement("h3", null, "ServIS Sites")),
            React.createElement("div", { className: 'row' },
                React.createElement("div", { className: 'col-sm-4' },
                    React.createElement(shared_1.Search, { filter: this.props.searchFilter, applyFilter: this.props.applyFilter, clearFilter: this.props.clearFilter, changeFilterField: this.props.changeFilterField, placeholder: constants_1.SERVIS_SEARCH_PLACEHOLDER })),
                React.createElement("div", { className: 'col-sm-6 col-sm-offset-2 text-right' },
                    React.createElement(common_ux_1.Button, { buttonType: 'primary', buttonSize: 'default', disabled: !this.props.siteSelected || this.props.registeredSiteSelected, onClick: function () { return _this.props.registerSite(); } }, "Register Site"),
                    React.createElement(common_ux_1.PagingControl, { totalItemCount: this.props.totalNumberOfSites, top: this.props.pagingSettings.pageSize, skip: this.props.pagingSettings.skipItems, pageRequested: this.props.requestPage }))),
            errorMessage,
            React.createElement("div", { className: 'row' },
                React.createElement("div", { className: 'col-md-12' },
                    React.createElement(Sites_1.default, { sites: this.props.sites, sortingSettings: this.props.sortingSettings, history: this.props.history, sortField: this.props.sortField, onCheck: this.props.checkboxSelected, siteSelected: this.props.siteSelected, selectedSite: this.props.selectedSite, searchFilter: this.props.searchFilter, sitesLoading: this.props.sitesLoading })))));
    };
    RegisterSitesContainer.prototype.componentDidMount = function () {
        this.props.requestSitesGet(this.props.pagingSettings, this.props.sortingSettings, this.props.searchFilter, this.props.fromServIs);
    };
    RegisterSitesContainer.prototype.componentWillUnmount = function () {
        this.props.dispatchLeavingPage();
    };
    return RegisterSitesContainer;
}(React.Component));
exports.RegisterSitesContainer = RegisterSitesContainer;
exports.default = react_router_dom_1.withRouter(react_redux_1.connect(mapStateToProps, mapDispatchToProps, mergeProps)(RegisterSitesContainer));
function mapStateToProps(store) {
    var accessToken = store.userState.loggedInUser.access_token;
    return __assign({}, store.registerState, { accessToken: accessToken });
}
exports.mapStateToProps = mapStateToProps;
function mapDispatchToProps(dispatch) {
    return {
        requestSitesGet: function (pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken) {
            return dispatch(ActionCreators.onSiteGetRequest(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken));
        },
        registerSite: function (selectedSite, accessToken) {
            return dispatch(ActionCreators.onRegisterSite(selectedSite, accessToken));
        },
        dispatchPagingChange: function (pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken) {
            return dispatch(ActionCreators.onPagingChange(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken));
        },
        dispatchSortingChange: function (pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken) {
            return dispatch(ActionCreators.onSortingChange(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken));
        },
        dispatchApplyFilter: function (searchFilter, pagingSettings, sortingSettings, fromServIs, accessToken) {
            return dispatch(ActionCreators.onFilterApplied(searchFilter, pagingSettings, sortingSettings, fromServIs, accessToken));
        },
        dispatchFilterFieldChange: function (searchFilter) {
            return dispatch(ActionCreators.onFilterFieldChange(searchFilter));
        },
        dispatchCheckboxSelected: function (siteIsSelected, selectedSite) {
            return dispatch(ActionCreators.onSiteSelected(siteIsSelected, selectedSite));
        },
        dispatchLeavingPage: function () {
            return dispatch(ActionCreators.onRegisterPageLeave());
        }
    };
}
function mergeProps(_a, propsFromDispatch, ownProps) {
    var accessToken = _a.accessToken, propsFromState = __rest(_a, ["accessToken"]);
    return __assign({}, propsFromState, ownProps, { requestSitesGet: function (pagingSettings, sortingSettings, searchFilter, fromServIs) {
            return propsFromDispatch.requestSitesGet(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken);
        }, requestPage: function (skipItems) {
            var newPagingSettings = __assign({}, propsFromState.pagingSettings, { skipItems: skipItems });
            propsFromDispatch.dispatchPagingChange(newPagingSettings, propsFromState.sortingSettings, propsFromState.searchFilter, propsFromState.fromServIs, accessToken);
        }, sortField: function (sortField) {
            var newSortingSettings = null;
            if (sortField === propsFromState.sortingSettings.sortField) {
                var newDirection = propsFromState.sortingSettings.sortDirection === 'asc' ? 'desc' : 'asc';
                newSortingSettings = __assign({}, propsFromState.sortingSettings, { sortDirection: newDirection });
            }
            else {
                newSortingSettings = { sortField: sortField, sortDirection: 'asc' };
            }
            propsFromDispatch.dispatchSortingChange(propsFromState.pagingSettings, newSortingSettings, propsFromState.searchFilter, propsFromState.fromServIs, accessToken);
        }, applyFilter: function (event) {
            event.preventDefault();
            propsFromDispatch.dispatchApplyFilter(propsFromState.searchFilter, propsFromState.pagingSettings, propsFromState.sortingSettings, propsFromState.fromServIs, accessToken);
        }, clearFilter: function () { return propsFromDispatch.dispatchApplyFilter('', propsFromState.pagingSettings, propsFromState.sortingSettings, propsFromState.fromServIs, accessToken); }, changeFilterField: function (event) {
            propsFromDispatch.dispatchFilterFieldChange(event.target.value);
        }, checkboxSelected: function (selectedSite) {
            var siteIsSelected = !propsFromState.siteSelected || (propsFromState.selectedSite.servIsId !== selectedSite.servIsId);
            selectedSite = siteIsSelected ? selectedSite : models_1.defaultSite;
            propsFromDispatch.dispatchCheckboxSelected(siteIsSelected, selectedSite);
        }, registerSite: function () { return propsFromDispatch.registerSite(propsFromState.selectedSite, accessToken); }, dispatchLeavingPage: function () { return propsFromDispatch.dispatchLeavingPage(); } });
}


/***/ }),

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SitesContainer_1 = __webpack_require__(628);
exports.default = SitesContainer_1.default;
var reducers_1 = __webpack_require__(327);
exports.registerSiteReducer = reducers_1.registerSiteReducer;


/***/ }),

/***/ 630:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(3);
var react_redux_1 = __webpack_require__(17);
var react_router_dom_1 = __webpack_require__(15);
var common_ux_1 = __webpack_require__(14);
var LayoutComponent = (function (_super) {
    __extends(LayoutComponent, _super);
    function LayoutComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LayoutComponent.prototype.render = function () {
        var AdminTab = React.createElement("div", null);
        var userBarNav = (React.createElement(common_ux_1.BarNav, { position: common_ux_1.BarNavPosition.Right },
            React.createElement(common_ux_1.BarNavLink, { to: '/Login' }, "Log In")));
        if (this.props.loggedInUser) {
            var profile = this.props.loggedInUser.profile;
            userBarNav = (React.createElement(common_ux_1.BarNav, { position: common_ux_1.BarNavPosition.Right },
                React.createElement(common_ux_1.BarDivider, { orientation: 'vertical' }),
                React.createElement(common_ux_1.BarNavLink, { to: '/' },
                    React.createElement(common_ux_1.Icon, { icon: 'user' }),
                    " ",
                    profile.name ? profile.name : profile.email),
                React.createElement(common_ux_1.BarDivider, { orientation: 'vertical' }),
                React.createElement(common_ux_1.BarNavLink, { to: '/Logout' },
                    React.createElement(common_ux_1.Icon, { icon: 'log_out' }))));
            if (this.props.userPermissions && this.props.userPermissions.isAdmin) {
                AdminTab = (React.createElement(common_ux_1.BarNav, null,
                    React.createElement(common_ux_1.BarNavLink, { to: '/UserManagement' }, "User Management")));
            }
        }
        return (React.createElement("div", null,
            React.createElement(common_ux_1.Bar, { productName: 'License Portal' },
                React.createElement(common_ux_1.BarNav, null),
                AdminTab,
                userBarNav),
            React.createElement("div", { className: 'container-fluid' }, this.props.children)));
    };
    return LayoutComponent;
}(React.Component));
exports.LayoutComponent = LayoutComponent;
exports.default = react_router_dom_1.withRouter(react_redux_1.connect(mapStateToProps)(LayoutComponent));
function mapStateToProps(store) {
    return {
        loggedInUser: store.userState.loggedInUser,
        userPermissions: store.userState.userPermissions
    };
}


/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Layout_1 = __webpack_require__(630);
exports.default = Layout_1.default;


/***/ }),

/***/ 632:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(3);
var common_ux_1 = __webpack_require__(14);
/* tslint:disable:jsx-no-lambda */
var Search = (function (_super) {
    __extends(Search, _super);
    function Search() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Search.prototype.render = function () {
        var _a = this.props, filter = _a.filter, applyFilter = _a.applyFilter, clearFilter = _a.clearFilter, changeFilterField = _a.changeFilterField, placeholder = _a.placeholder;
        return (React.createElement("div", { className: 'row' },
            React.createElement("div", { className: 'col-lg-12 form-group' },
                React.createElement("div", { className: 'input-group-touching' },
                    React.createElement("form", { onSubmit: applyFilter },
                        React.createElement(common_ux_1.TextInput, { name: 'Search', id: 'searchFilter', readOnly: false, inputSize: 'small', placeholder: placeholder, labelText: '', value: filter, disabled: false, onChange: changeFilterField }))))));
    };
    return Search;
}(React.Component));
exports.default = Search;


/***/ }),

/***/ 633:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Search_1 = __webpack_require__(632);
exports.default = Search_1.default;


/***/ }),

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(3);
var common_ux_1 = __webpack_require__(14);
/* tslint:disable:jsx-no-lambda */
var Sites = (function (_super) {
    __extends(Sites, _super);
    function Sites() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Sites.prototype.render = function () {
        var _this = this;
        var SiteTableColumn = common_ux_1.ColumnDefinition;
        var _a = this.props, sites = _a.sites, sortingSettings = _a.sortingSettings;
        if (this.props.sites.length > 0 || this.props.sitesLoading) {
            return (React.createElement(common_ux_1.Table, { data: sites, hover: true, emptyMessage: 'Loading ..', navigateColumn: function (row) { _this.props.history.push("/Licenses/" + row.siteId); }, sortedColumnName: sortingSettings.sortField, sortedColDirection: sortingSettings.sortDirection, headerClick: this.props.sortField },
                React.createElement(SiteTableColumn, { cell: function (row) { return row.name; }, header: 'Site Name', columnName: 'SiteName' }),
                React.createElement(SiteTableColumn, { cell: function (row) { return row.servIsId.toString(); }, header: 'ServIS ID', columnName: 'ServIsId' }),
                React.createElement(SiteTableColumn, { cell: function (row) { return row.customer; }, header: 'Customer (Owner)', columnName: 'Owner' }),
                React.createElement(SiteTableColumn, { cell: function (row) { return row.region; }, header: 'Region', columnName: 'RegionName' })));
        }
        else {
            if (this.props.searchFilter.length > 0) {
                return (React.createElement("div", null,
                    React.createElement("p", null, "No results found based on provided search criteria."),
                    React.createElement("p", null, "Make sure all words are spelled correctly."),
                    React.createElement("p", null,
                        "Try again or contact customer Support at ",
                        React.createElement("a", { href: 'mailto:us-iasvsupport@abb.com' }, "us-iasvsupport@abb.com."))));
            }
            else {
                return (React.createElement("div", null,
                    React.createElement("p", null, "At this time, you do not have permission to view any sites."),
                    React.createElement("p", null,
                        "Contact customer Support at ",
                        React.createElement("a", { href: 'mailto:us-iasvsupport@abb.com' }, "us-iasvsupport@abb.com"),
                        " to gain access.")));
            }
        }
    };
    return Sites;
}(React.Component));
exports.default = Sites;


/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:jsx-no-lambda*/
var common_ux_1 = __webpack_require__(14);
var shared_1 = __webpack_require__(140);
var constants_1 = __webpack_require__(25);
var React = __webpack_require__(3);
var react_redux_1 = __webpack_require__(17);
var react_router_dom_1 = __webpack_require__(15);
var ActionCreators = __webpack_require__(328);
var Sites_1 = __webpack_require__(634);
var SitesContainer = (function (_super) {
    __extends(SitesContainer, _super);
    function SitesContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SitesContainer.prototype.render = function () {
        var _this = this;
        this.props.history.listen(function (location, action) {
            if (action === 'PUSH' && location.pathname === '/') {
                _this.props.clearSearchField();
            }
        });
        var searchServIsButton = React.createElement(common_ux_1.Button, { buttonType: 'primary', buttonSize: 'default', onClick: function () { _this.handleServIsButtonClick(); } }, "Search ServIS");
        return (React.createElement("div", { className: 'container' },
            React.createElement("div", null,
                React.createElement("h3", null, "Registered Sites")),
            React.createElement("div", { className: 'row' },
                React.createElement("div", { className: 'col-sm-4' },
                    React.createElement(shared_1.Search, { filter: this.props.searchFilter, applyFilter: this.props.applyFilter, clearFilter: this.props.clearFilter, changeFilterField: this.props.changeFilterField, placeholder: constants_1.SITE_LIST_SEARCH_PLACEHOLDER })),
                React.createElement("div", { className: 'col-sm-6 col-sm-offset-2 text-right' },
                    searchServIsButton,
                    React.createElement(common_ux_1.PagingControl, { totalItemCount: this.props.totalNumberOfSites, top: this.props.pagingSettings.pageSize, skip: this.props.pagingSettings.skipItems, pageRequested: this.props.requestPage }))),
            React.createElement("div", { className: 'row' },
                React.createElement("div", { className: 'col-md-12' },
                    React.createElement(Sites_1.default, { sites: this.props.sites, sortingSettings: this.props.sortingSettings, history: this.props.history, sortField: this.props.sortField, searchFilter: this.props.searchFilter, sitesLoading: this.props.sitesLoading })))));
    };
    SitesContainer.prototype.componentDidMount = function () {
        this.props.requestSitesGet(this.props.pagingSettings, this.props.sortingSettings, this.props.searchFilter, this.props.fromServIs);
    };
    SitesContainer.prototype.handleServIsButtonClick = function () {
        this.props.history.push("/register");
        this.props.requestServIsPage(0);
    };
    return SitesContainer;
}(React.Component));
exports.SitesContainer = SitesContainer;
exports.default = react_router_dom_1.withRouter(react_redux_1.connect(mapStateToProps, mapDispatchToProps, mergeProps)(SitesContainer));
function mapStateToProps(store) {
    var accessToken = store.userState.loggedInUser.access_token;
    return __assign({}, store.sitesState, store.userState, store.permissionsState, { accessToken: accessToken });
}
exports.mapStateToProps = mapStateToProps;
function mapDispatchToProps(dispatch) {
    return {
        requestSitesGet: function (pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken) {
            return dispatch(ActionCreators.onSiteGetRequest(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken));
        },
        dispatchPagingChange: function (pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken) {
            return dispatch(ActionCreators.onPagingChange(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken));
        },
        dispatchServIsPagingChange: function (pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken) {
            return dispatch(ActionCreators.onServIsPagingChange(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken));
        },
        dispatchSortingChange: function (pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken) {
            return dispatch(ActionCreators.onSortingChange(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken));
        },
        dispatchApplyFilter: function (searchFilter, pagingSettings, sortingSettings, fromServIs, accessToken) {
            return dispatch(ActionCreators.onFilterApplied(searchFilter, pagingSettings, sortingSettings, fromServIs, accessToken));
        },
        dispatchFilterFieldChange: function (searchFilter) {
            return dispatch(ActionCreators.onFilterFieldChange(searchFilter));
        }
    };
}
function mergeProps(_a, propsFromDispatch, ownProps) {
    var accessToken = _a.accessToken, propsFromState = __rest(_a, ["accessToken"]);
    return __assign({}, propsFromState, ownProps, { requestSitesGet: function (pagingSettings, sortingSettings, searchFilter, fromServIs) {
            return propsFromDispatch.requestSitesGet(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken);
        }, requestPage: function (skipItems) {
            var newPagingSettings = __assign({}, propsFromState.pagingSettings, { skipItems: skipItems });
            propsFromDispatch.dispatchPagingChange(newPagingSettings, propsFromState.sortingSettings, propsFromState.searchFilter, propsFromState.fromServIs, accessToken);
        }, requestServIsPage: function (skipItems) {
            var newPagingSettings = __assign({}, propsFromState.pagingSettings, { skipItems: skipItems });
            propsFromDispatch.dispatchServIsPagingChange(newPagingSettings, propsFromState.sortingSettings, propsFromState.searchFilter, true, accessToken);
        }, sortField: function (sortField) {
            var newSortingSettings = null;
            if (sortField === propsFromState.sortingSettings.sortField) {
                var newDirection = propsFromState.sortingSettings.sortDirection === 'asc' ? 'desc' : 'asc';
                newSortingSettings = __assign({}, propsFromState.sortingSettings, { sortDirection: newDirection });
            }
            else {
                newSortingSettings = { sortField: sortField, sortDirection: 'asc' };
            }
            propsFromDispatch.dispatchSortingChange(propsFromState.pagingSettings, newSortingSettings, propsFromState.searchFilter, propsFromState.fromServIs, accessToken);
        }, applyFilter: function (event) {
            event.preventDefault();
            propsFromDispatch.dispatchApplyFilter(propsFromState.searchFilter, propsFromState.pagingSettings, propsFromState.sortingSettings, propsFromState.fromServIs, accessToken);
        }, clearFilter: function () { propsFromDispatch.dispatchApplyFilter('', propsFromState.pagingSettings, propsFromState.sortingSettings, propsFromState.fromServIs, accessToken); }, changeFilterField: function (event) {
            propsFromDispatch.dispatchFilterFieldChange(event.target.value);
        }, clearSearchField: function () {
            propsFromDispatch.dispatchApplyFilter('', propsFromState.pagingSettings, propsFromState.sortingSettings, propsFromState.fromServIs, accessToken);
        }, setPermissions: propsFromDispatch.setPermissions });
}


/***/ }),

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SitesContainer_1 = __webpack_require__(635);
exports.default = SitesContainer_1.default;
var reducers_1 = __webpack_require__(329);
exports.sitesReducer = reducers_1.sitesReducer;


/***/ }),

/***/ 637:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = __webpack_require__(106);
exports.initialUserFilterState = {
    filter: new models_1.UserFilterValue(),
    display: 15,
    skip: 0,
    sortField: 'email',
    sortDirection: 'asc',
};
function userSearchReducer(state, action) {
    if (state === void 0) { state = exports.initialUserFilterState; }
    switch (action.type) {
        case 'USER_FILTER_UPDATE':
            return __assign({}, state, { filter: action.filter, skip: 0 });
        case 'USER_SORT_UPDATE':
            return __assign({}, state, { sortField: action.sortField, sortDirection: action.sortDirection });
        case 'USER_PAGING_UPDATE':
            return __assign({}, state, { skip: action.skip });
        case 'USER_CLEAR':
            var newFilter = __assign({}, exports.initialUserFilterState.filter, { display: state.filter.display });
            return __assign({}, exports.initialUserFilterState, { filter: newFilter });
        default:
            return state;
    }
}
exports.userSearchReducer = userSearchReducer;


/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:jsx-no-lambda */
var common_ux_1 = __webpack_require__(14);
var React = __webpack_require__(3);
var UserFilter = (function (_super) {
    __extends(UserFilter, _super);
    function UserFilter(props) {
        var _this = _super.call(this, props) || this;
        _this.handleAdminChange = function (userValue) {
            var newValue = userValue ? userValue.value : undefined;
            _this.setState({ filter: __assign({}, _this.state.filter, { isAdmin: newValue }) });
        };
        _this.handleCheckbox = function (event) {
            _this.setState({ filter: __assign({}, _this.state.filter, { allScopes: !_this.state.filter.allScopes }) });
        };
        _this.handleTextInputChange = function (event) {
            var target = event.target;
            var value = target.value;
            var name = target.name;
            var newValue = {};
            newValue[name] = value;
            _this.setState({ filter: __assign({}, _this.state.filter, newValue) });
        };
        _this.handleScopeChange = function (opts) {
            var selectedScopes = [];
            opts.forEach(function (s) {
                selectedScopes = selectedScopes.concat(s.value);
            });
            _this.setState({ filter: __assign({}, _this.state.filter, { scopes: selectedScopes }) });
        };
        _this.handleApply = function (event) {
            event.preventDefault();
            if (JSON.stringify(_this.props.filter) !== JSON.stringify(_this.state.filter)) {
                _this.props.onFilterApply(_this.state.filter);
            }
        };
        _this.state = {
            filter: props.filter,
            countries: __webpack_require__(564)
        };
        return _this;
    }
    UserFilter.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({ filter: nextProps.filter });
    };
    UserFilter.prototype.render = function () {
        var adminOptions = [{ label: 'Admin', value: true }, { label: 'Non-Admin', value: false }];
        var scopeValues = this.state.countries.map(function (value) {
            var opt = { label: value.countryID, value: value.countryID };
            return opt;
        });
        return (React.createElement("div", { className: 'panel panel-default' },
            React.createElement("div", { className: 'panel-body' },
                React.createElement("form", { id: 'pbFilterForm', onSubmit: this.handleApply },
                    React.createElement("fieldset", null,
                        React.createElement("legend", null, "FILTER USERS"),
                        React.createElement("div", { className: 'row' },
                            React.createElement("div", { className: 'col-lg-12' },
                                React.createElement(common_ux_1.TextInput, { name: 'email', labelText: 'Email Address', isRequired: false, inputSize: 'small', placeholder: 'Email', value: this.state.filter ? this.state.filter.email : '', onChange: this.handleTextInputChange }))),
                        React.createElement("div", { className: 'row' },
                            React.createElement("div", { className: 'col-lg-12' },
                                React.createElement(common_ux_1.ComboBox, { placeholder: 'Select One', labelText: 'Admin', options: adminOptions, value: this.state.filter.isAdmin, onChange: this.handleAdminChange, searchable: false, size: 'small' }))),
                        React.createElement("div", { className: 'row' },
                            React.createElement("div", { className: 'col-lg-12' },
                                React.createElement(common_ux_1.ComboBox, { placeholder: 'Select One', labelText: 'Scopes', options: scopeValues, value: this.state.filter.scopes, onChange: this.handleScopeChange, searchable: false, multiSelect: true, disabled: this.state.filter.allScopes, size: 'small' }))),
                        React.createElement("div", { className: 'row' },
                            React.createElement("div", { className: 'col-lg-12' },
                                React.createElement(common_ux_1.Checkbox, { id: 'allScopesCheck', label: 'Scoped by all countries', checked: this.state.filter.allScopes, onChange: this.handleCheckbox }))),
                        React.createElement("div", { className: 'row' },
                            React.createElement("div", { className: 'col-lg-6' }),
                            React.createElement("div", { className: 'col-lg-6 form-group text-right' },
                                React.createElement(common_ux_1.Button, { buttonType: 'discrete', buttonSize: 'default', onClick: this.props.onClear }, "Clear"),
                                ' ',
                                React.createElement(common_ux_1.Button, { buttonType: 'primary', buttonSize: 'default' }, "Apply"))))))));
    };
    return UserFilter;
}(React.Component));
exports.UserFilter = UserFilter;


/***/ }),

/***/ 639:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:jsx-no-lambda */
var React = __webpack_require__(3);
var react_redux_1 = __webpack_require__(17);
var react_router_dom_1 = __webpack_require__(15);
var common_ux_1 = __webpack_require__(14);
var userManagement_1 = __webpack_require__(330);
var userDataService_1 = __webpack_require__(646);
var models_1 = __webpack_require__(106);
var userModal_1 = __webpack_require__(331);
__webpack_require__(911);
var UserManagementComponent = (function (_super) {
    __extends(UserManagementComponent, _super);
    function UserManagementComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.getUsers = function () { return __awaiter(_this, void 0, void 0, function () {
            var users;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, userDataService_1.UserDataService.getUsers(this.props.loggedInUser)];
                    case 1:
                        users = _a.sent();
                        this.setState({ UserList: users, totalItemCount: users.length, filteredList: users });
                        this.filterUsers(this.state.UserList, this.props.filter);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onClickPill = function (pillKey) {
            // Do Nothing
        };
        _this.onClosePill = function (pillKey) {
            var newFilter = __assign({}, _this.props.filter);
            if (pillKey === 'Admin Status') {
                newFilter.isAdmin = undefined;
            }
            else {
                newFilter[pillKey] = '';
            }
            _this.handleApply(newFilter);
        };
        _this.stopEventPropogation = function (e) {
            e.nativeEvent.stopImmediatePropagation();
        };
        _this.handleApply = function (filter) {
            var dispatch = _this.props.dispatch;
            dispatch({ type: 'USER_FILTER_UPDATE', filter: filter });
        };
        _this.handleClear = function () {
            var dispatch = _this.props.dispatch;
            dispatch({ type: 'USER_CLEAR' });
        };
        _this.changePage = function (newSkip) {
            var dispatch = _this.props.dispatch;
            dispatch({ type: 'USER_PAGING_UPDATE', skip: newSkip });
        };
        _this.updateTableData = function (tablePackageList, skip) {
            var display = _this.props.display;
            _this.setState({ CurrentUserList: tablePackageList.slice(skip, display + skip), filteredList: tablePackageList });
        };
        _this.toggleFilter = function (e) {
            e.nativeEvent.stopImmediatePropagation();
            _this.setState({ showFilter: !_this.state.showFilter });
        };
        _this.dismissFilter = function () {
            _this.setState({ showFilter: false });
        };
        _this.handleToggleUserModal = function (user) {
            if (user === void 0) { user = new models_1.User(); }
            _this.setState({ UserModalForm: user, userToDelete: user.id }, _this.toggleUserModal);
        };
        _this.toggleUserModal = function () {
            _this.setState({ showUserModal: !_this.state.showUserModal });
        };
        _this.toggleDeleteUserWarningModal = function () {
            _this.setState({ showDeleteUserWarningModal: !_this.state.showDeleteUserWarningModal });
        };
        _this.handleCreate = function (user) { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, userDataService_1.UserDataService.createUser(user, this.props.loggedInUser)];
                    case 1:
                        _a.sent();
                        this.getUsers();
                        return [2 /*return*/, true];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.handleUpdate = function (user) { return __awaiter(_this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, userDataService_1.UserDataService.updateUser(user, this.props.loggedInUser)];
                    case 1:
                        _a.sent();
                        this.getUsers();
                        return [2 /*return*/, true];
                    case 2:
                        error_2 = _a.sent();
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.handleDelete = function () { return __awaiter(_this, void 0, void 0, function () {
            var error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, userDataService_1.UserDataService.deleteUser(this.state.userToDelete, this.props.loggedInUser)];
                    case 1:
                        _a.sent();
                        this.getUsers();
                        this.toggleDeleteUserWarningModal();
                        this.toggleUserModal();
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        console.log('User delete failed');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.filterUsers = function (users, filter) {
            if (users !== undefined && filter !== undefined) {
                var newUsersList = users;
                if (filter.email !== undefined) {
                    var userEmail_1 = filter.email.toLowerCase();
                    newUsersList = newUsersList.filter(function (user) { return user.email.toLowerCase().includes(userEmail_1); });
                }
                if (filter.email !== undefined) {
                    var userFirstName_1 = filter.email.toLowerCase();
                    newUsersList = newUsersList.filter(function (user) { return user.email.toLowerCase().includes(userFirstName_1); });
                }
                if (filter.scopes !== undefined) {
                    newUsersList = filter.scopes.length !== 0 ? newUsersList.filter(function (user) { return filter.scopes.every(function (s) { return user.allScopes || (user.scopes.some(function (scope) { return scope === s; })); }); }) : newUsersList;
                }
                if (filter.isAdmin !== undefined) {
                    if (filter.isAdmin) {
                        var userTrue_1 = filter.isAdmin.toString();
                        newUsersList = newUsersList.filter(function (user) { return user.isAdmin.toString().includes(userTrue_1); });
                    }
                    if (!filter.isAdmin) {
                        var userFalse_1 = filter.isAdmin.toString();
                        newUsersList = newUsersList.filter(function (user) { return user.isAdmin.toString().includes(userFalse_1); });
                    }
                }
                if (filter.allScopes) {
                    var allScopesTrue_1 = filter.allScopes.toString();
                    newUsersList = newUsersList.filter(function (user) { return user.allScopes.toString().includes(allScopesTrue_1); });
                }
                var sortedUsers = _this.sortData(_this.props.sortField, _this.props.sortDirection, newUsersList);
                _this.updateTableData(sortedUsers, _this.props.skip);
            }
        };
        _this.sortData = function (sortByField, sortDir, unsortedList) {
            var rows = unsortedList.slice();
            rows.sort(function (a, b) {
                var sortVal = 0;
                if (!a[sortByField] && !b[sortByField]) {
                    sortVal = 1;
                }
                else if (!a[sortByField] || a[sortByField] === undefined) {
                    sortVal = -1;
                }
                else if (!b[sortByField] || b[sortByField] === undefined) {
                    sortVal = 1;
                }
                else {
                    if (a[sortByField].toString().toLowerCase() > b[sortByField].toString().toLowerCase()) {
                        sortVal = 1;
                    }
                    if (a[sortByField].toString().toLowerCase() < b[sortByField].toString().toLowerCase()) {
                        sortVal = -1;
                    }
                }
                if (sortDir === 'desc') {
                    sortVal = sortVal * -1;
                }
                return sortVal;
            });
            return rows;
        };
        _this.sortColumn = function (sortByFieldName) {
            var sortField = _this.props.sortField;
            var sortDirection = _this.props.sortDirection;
            if (sortByFieldName) {
                if (_this.props.sortField === sortByFieldName) {
                    sortDirection = _this.toggleSortDirection(_this.props.sortDirection);
                }
                else {
                    sortField = sortByFieldName;
                    sortDirection = 'asc';
                }
                var sortedList = _this.sortData(sortField, sortDirection, _this.state.filteredList);
                _this.setState({ filteredList: sortedList, CurrentUserList: sortedList.slice(_this.props.skip, _this.props.display + _this.props.skip) });
                var dispatch = _this.props.dispatch;
                dispatch({ type: 'USER_SORT_UPDATE', sortField: sortField, sortDirection: sortDirection });
            }
        };
        _this.toggleSortDirection = function (currentDirection) {
            if (currentDirection === 'asc') {
                return 'desc';
            }
            else {
                return 'asc';
            }
        };
        _this.state = {
            UserModalForm: new models_1.User(),
            UserList: [],
            CurrentUserList: undefined,
            filteredList: [],
            showUserModal: false,
            showDeleteUserWarningModal: false,
            showFilter: false,
            totalItemCount: 0,
            userToDelete: 0
        };
        return _this;
    }
    UserManagementComponent.prototype.render = function () {
        var _this = this;
        var UserColumn = common_ux_1.ColumnDefinition;
        var page = (React.createElement("div", null,
            React.createElement("h3", null, "Not Authorized"),
            React.createElement("p", null,
                this.props.userPermissions.email,
                " is not an authorized user. Please contact your supervisor to correct this.")));
        // Create list of pills
        var pillList = [];
        if (this.props.filter) {
            if (this.props.filter.isAdmin !== undefined) {
                var pillKey = 'Admin Status';
                var lacct = (this.props.filter.isAdmin ? 'Admin' : 'Non-Admin');
                pillList.push(React.createElement(common_ux_1.Pill, { key: pillKey, id: pillKey, label: 'Admin Status', value: lacct, onClose: this.onClosePill, onClick: this.onClickPill }));
            }
            if (this.props.filter.email && this.props.filter.email.length > 0) {
                var pillKey = 'email';
                pillList.push(React.createElement(common_ux_1.Pill, { key: pillKey, id: pillKey, label: 'Email', value: this.props.filter.email, onClose: this.onClosePill, onClick: this.onClickPill }));
            }
            if (!this.props.filter.allScopes && this.props.filter.scopes && this.props.filter.scopes.length > 0) {
                var pillKey = 'scopes';
                pillList.push(React.createElement(common_ux_1.Pill, { key: pillKey, id: pillKey, label: 'Scopes', value: this.renderScopePill(this.props.filter.scopes), onClose: this.onClosePill, onClick: this.onClickPill }));
            }
            if (this.props.filter.allScopes) {
                var pillKey = 'allScopes';
                pillList.push(React.createElement(common_ux_1.Pill, { key: pillKey, id: pillKey, label: 'Scopes', value: 'Scoped to all countries', onClose: this.onClosePill, onClick: this.onClickPill }));
            }
        }
        if (this.props.userPermissions.isAdmin) {
            page = (React.createElement("div", null,
                React.createElement("div", { className: 'row' },
                    React.createElement("div", { className: 'col-md-12' },
                        React.createElement("div", { className: 'row toolbar' },
                            React.createElement("div", { className: 'col-md-8 toolbar-title' }, "User Management"),
                            React.createElement("div", { className: 'col-md-4' },
                                React.createElement("div", { className: 'text-right' },
                                    React.createElement(common_ux_1.Button, { buttonType: 'primary', buttonSize: 'default', icon: 'plus', onClick: function () { return _this.handleToggleUserModal(); } }),
                                    ' ',
                                    React.createElement(common_ux_1.PagingControl, { pageRequested: this.changePage, skip: this.props.skip, top: this.props.filter.display, totalItemCount: this.state.filteredList.length }),
                                    ' ',
                                    React.createElement(common_ux_1.ToggleButton, { isToggled: this.state.showFilter, buttonSize: 'default', buttonType: 'normal', icon: 'filter', id: 'userFilterBtn', onClick: this.toggleFilter })),
                                this.state.showFilter ? this.renderFilter() : null)),
                        React.createElement("div", { className: 'row' },
                            React.createElement("div", { className: 'col-md-12' },
                                React.createElement(common_ux_1.PillBox, null, pillList))),
                        React.createElement("div", { className: 'row' },
                            React.createElement("div", { className: 'col-md-12' },
                                React.createElement(common_ux_1.Table, { data: this.state.CurrentUserList, sortedColumnName: this.props.sortField, sortedColDirection: this.props.sortDirection, headerClick: this.sortColumn, navigateRow: this.handleToggleUserModal, hover: true, emptyMessage: this.state.CurrentUserList ? 'No User Data' : 'Loading...' },
                                    React.createElement(UserColumn, { cell: function (user) { return user.email; }, header: 'Email Address', columnName: 'email', columnWidth: 2 }),
                                    React.createElement(UserColumn, { cell: function (user) { if (user.isAdmin) {
                                            return 'Admin';
                                        }
                                        else {
                                            return 'Non-Admin';
                                        } }, header: 'Admin Status', columnName: 'isAdmin', columnWidth: 1 }),
                                    React.createElement(UserColumn, { cell: function (user) { return _this.renderScopes(user); }, header: 'Scopes', columnName: 'scopes', columnWidth: 10 }))))),
                    this.state.showDeleteUserWarningModal ? this.renderDeleteUserWarningModal() : null,
                    this.state.showUserModal ? this.renderUserModal() : null)));
        }
        return (page);
    };
    UserManagementComponent.prototype.renderFilter = function () {
        return (React.createElement("div", { className: 'userFilter', id: 'userFilter', onClick: this.stopEventPropogation },
            React.createElement(userManagement_1.UserFilter, { filter: this.props.filter, onFilterApply: this.handleApply, onClear: this.handleClear })));
    };
    UserManagementComponent.prototype.renderScopes = function (user) {
        var returnString = '';
        if (user.allScopes) {
            returnString = 'Scoped to all countries';
        }
        else {
            if (user.scopes) {
                user.scopes.map(function (s, index) {
                    if (index === 0) {
                        returnString = s;
                    }
                    else {
                        returnString = returnString + ', ' + s;
                    }
                });
            }
        }
        return returnString;
    };
    UserManagementComponent.prototype.renderScopePill = function (scopes) {
        var returnString = '';
        if (scopes) {
            scopes.map(function (s, index) {
                if (index === 0) {
                    returnString = s;
                }
                else {
                    returnString = returnString + ', ' + s;
                }
            });
        }
        return returnString;
    };
    UserManagementComponent.prototype.renderDeleteUserWarningModal = function () {
        return (React.createElement(common_ux_1.Modal, { isOpen: this.state.showDeleteUserWarningModal, onClose: this.toggleDeleteUserWarningModal, header: 'DELETE USER', modalClassName: 'deleteWarningModal', overlayClassName: 'modalOverlay' },
            React.createElement("p", null, "Are you sure you want to DELETE the User?"),
            React.createElement("p", null, "This action cannot be undone."),
            React.createElement("div", { className: 'row' },
                React.createElement("div", { style: { textAlign: 'right', paddingRight: '15px' } },
                    React.createElement(common_ux_1.Button, { buttonType: 'normal', buttonSize: 'default', id: 'cancelDelete', onClick: this.toggleDeleteUserWarningModal }, "Cancel"),
                    ' ',
                    React.createElement(common_ux_1.Button, { buttonType: 'primary', buttonSize: 'default', id: 'deleteUserButton', onClick: this.handleDelete }, "Delete")))));
    };
    UserManagementComponent.prototype.renderUserModal = function () {
        return (React.createElement(userModal_1.UserModal, { user: this.state.UserModalForm, isOpen: this.state.showUserModal, onClose: this.handleToggleUserModal, onCreate: this.handleCreate, onUpdate: this.handleUpdate, onDelete: this.toggleDeleteUserWarningModal }));
    };
    UserManagementComponent.prototype.componentDidMount = function () {
        // This code is so we close the user filter when we click anywhere that's not inside the filter.
        window.addEventListener('click', this.dismissFilter);
        if (this.props.loggedInUser) {
            this.getUsers();
        }
    };
    UserManagementComponent.prototype.componentWillUnmount = function () {
        window.removeEventListener('click', this.dismissFilter);
    };
    UserManagementComponent.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.skip !== this.props.skip) {
            var shortList = this.state.filteredList.slice(nextProps.skip, nextProps.display + nextProps.skip);
            this.setState({ CurrentUserList: shortList });
        }
        if (nextProps.filter !== this.props.filter) {
            this.filterUsers(this.state.UserList, nextProps.filter);
        }
    };
    return UserManagementComponent;
}(React.Component));
exports.UserManagement = react_router_dom_1.withRouter(react_redux_1.connect(mapStateToProps)(UserManagementComponent));
function mapStateToProps(store) {
    return {
        loggedInUser: store.userState.loggedInUser,
        userPermissions: store.userState.userPermissions,
        filter: store.userFilter.filter,
        skip: store.userFilter.skip,
        display: store.userFilter.display,
        sortDirection: store.userFilter.sortDirection,
        sortField: store.userFilter.sortField
    };
}


/***/ }),

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var license_1 = __webpack_require__(626);
var reducers_1 = __webpack_require__(327);
var reducers_2 = __webpack_require__(329);
var reducers_3 = __webpack_require__(637);
var redux_1 = __webpack_require__(199);
var initialUserState = {
    loggedInUser: null,
    userPermissions: null
};
exports.reducers = redux_1.combineReducers({
    userState: userReducer,
    serverState: license_1.serverReducer,
    servicesState: license_1.licenseAllowanceReducer,
    serviceOptionsState: license_1.serviceOptionsReducer,
    sitesState: reducers_2.sitesReducer,
    registerState: reducers_1.registerSiteReducer,
    userFilter: reducers_3.userSearchReducer
});
function userReducer(state, action) {
    if (state === void 0) { state = initialUserState; }
    switch (action.type) {
        case 'USER_LOGIN':
            return __assign({}, state, { loggedInUser: action.loggedInUser, userPermissions: action.userPermissions });
        default:
            return state;
    }
}


/***/ }),

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(3);
var react_router_dom_1 = __webpack_require__(15);
var authentication_1 = __webpack_require__(615);
var LicenseContainer_1 = __webpack_require__(326);
var index_1 = __webpack_require__(629);
var shared_1 = __webpack_require__(140);
var index_2 = __webpack_require__(636);
var index_3 = __webpack_require__(330);
var ourRoutes = [
    {
        component: shared_1.Layout,
        routes: [
            { path: '/Login', component: authentication_1.Login },
            { path: '/Logout', component: authentication_1.Logout },
            {
                component: authentication_1.RequireAuthentication,
                routes: [
                    { path: '/UserManagement', component: index_3.UserManagement },
                    { path: '/Register', component: index_1.default },
                    { path: '/Licenses/:siteId', component: LicenseContainer_1.default },
                    { path: '/', component: index_2.default },
                ]
            }
        ]
    }
];
// Common below this point
exports.default = toSwitch(ourRoutes);
function RouteWithSubroutes(_a) {
    var component = _a.component, routes = _a.routes, exact = _a.exact, path = _a.path;
    return (
    // tslint:disable-next-line:jsx-no-lambda
    React.createElement(react_router_dom_1.Route, __assign({}, { path: path, exact: exact }, { render: function (props) { return renderComponent(props, component, routes); } })));
}
function renderComponent(props, Component, routes) {
    var children = routes ? toSwitch(routes) : undefined;
    return (React.createElement(Component, __assign({}, props, { children: children })));
}
function toSwitch(routes) {
    return (React.createElement(react_router_dom_1.Switch, null, routes.map(function (r, i) { return React.createElement(RouteWithSubroutes, __assign({ key: i }, r)); })));
}


/***/ }),

/***/ 642:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__(25);
var siteApiClient_1 = __webpack_require__(88);
var client = new siteApiClient_1.default(constants_1.SITE_API_URI);
function requestServerGet(siteId, accessToken) {
    return new Promise(function (resolve, reject) {
        var req = client.getAllServers(siteId, accessToken);
        req.then(function (data) {
            var server = data.allowances.map(toServer);
            var services = data.availableServices;
            resolve({ server: server, services: services });
        }).catch(function (err) { return reject(err); });
    });
}
exports.requestServerGet = requestServerGet;
function requestOperationalUsageGet(accessToken) {
    return new Promise(function (resolve, reject) {
        var req = client.getOperationalUsages(accessToken);
        req.then(function (data) {
            resolve(toOperationalUsage(data));
        }).catch(function (err) { return reject(err); });
    });
}
exports.requestOperationalUsageGet = requestOperationalUsageGet;
function toOperationalUsage(it) {
    var OperationalUsages = [];
    it.forEach(function (instance) {
        OperationalUsages.push({
            id: instance.id,
            usageName: instance.usageName,
            label: instance.usageName
        });
    });
    return OperationalUsages;
}
function toServiceInstance(it) {
    var ServiceInstances = [];
    it.forEach(function (instance) {
        ServiceInstances.push({
            id: instance.id,
            serverId: instance.serverId,
            siteId: instance.siteId,
            selectedServiceType: instance.selectedService,
            serviceList: instance.availableServices,
            allocatedAssets: { value: instance.allocatedAssets, valid: true },
            assetType: instance.selectedService.assetType.assetTypeName,
            isBeingEdited: false,
            discriminator: ''
        });
    });
    return ServiceInstances;
}
function requestServerPost(server, accessToken) {
    return new Promise(function (resolve, reject) {
        var req = client.addServer(server, accessToken).then(function (r) { return r.json(); }).then(function (data) {
            resolve(toServerResponse(data));
        }).catch(function (err) { return reject(err); });
    });
}
exports.requestServerPost = requestServerPost;
function requestServerPut(server, accessToken) {
    return new Promise(function (resolve, reject) {
        // Make data service web call from here and pass response to success and error    testServerData.push(server)
        client.updateServer(server, accessToken)
            .catch(function (err) {
            reject(err);
        });
    });
}
exports.requestServerPut = requestServerPut;
function requestServerDelete(server, accessToken) {
    return new Promise(function (resolve, reject) {
        var req = client.deleteServer(server, accessToken).then(function (r) {
            resolve(server);
        }).catch(function (err) {
            reject(err);
        });
    });
}
exports.requestServerDelete = requestServerDelete;
function toServer(it) {
    return {
        id: it.server.id,
        description: { value: it.server.serverName, valid: true },
        serverId: { value: it.server.hardwareId, valid: true },
        operationalUseType: it.server.selectedOperationalUsage,
        isBeingEdited: false,
        siteId: it.server.siteId,
        serviceAllocations: toServiceInstance(it.allowances),
        isAvailable: false
    };
}
function toServerResponse(data) {
    var serverResponse = {
        description: { value: data.serverName, valid: true },
        id: data.id,
        siteId: data.siteId,
        serverId: { value: data.hardwareId, valid: true },
        isBeingEdited: false,
        operationalUseType: data.selectedOperationalUsage,
        serviceAllocations: [],
        discriminator: '',
        isAvailable: false
    };
    return serverResponse;
}


/***/ }),

/***/ 643:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__(25);
var siteApiClient_1 = __webpack_require__(88);
var client = new siteApiClient_1.default(constants_1.SITE_API_URI);
function requestServicePost(serviceInstance, accessToken) {
    serviceInstance.id = 0;
    return new Promise(function (resolve, reject) {
        var req = client.addService(serviceInstance, accessToken).then(function (r) { return r.json(); }).then(function (data) {
            resolve(toServiceInstanceResponse(data));
        }).catch(function (err) {
            reject(err);
        });
    });
}
exports.requestServicePost = requestServicePost;
function requestServicePut(serviceInstance, accessToken) {
    return new Promise(function (resolve, reject) {
        var req = client.updateService(serviceInstance, accessToken).then(function (data) {
            resolve(serviceInstance);
        }).catch(function (err) {
            reject(err);
        });
    });
}
exports.requestServicePut = requestServicePut;
function requestServiceDelete(serviceInstance, accessToken) {
    return new Promise(function (resolve, reject) {
        var req = client.deleteService(serviceInstance, accessToken).then(function (data) {
            resolve(serviceInstance);
        });
    });
}
exports.requestServiceDelete = requestServiceDelete;
function toServiceInstanceResponse(data) {
    var serviceInstanceResponse = {
        id: data.id,
        siteId: data.siteId,
        serverId: data.serverId,
        serviceList: [],
        selectedServiceType: data.selectedService,
        assetType: data.selectedService.assetType.assetTypeName,
        allocatedAssets: { value: data.allocatedAssets, valid: true },
        isBeingEdited: false,
        discriminator: ''
    };
    return serviceInstanceResponse;
}


/***/ }),

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__(25);
var siteApiClient_1 = __webpack_require__(88);
var client = new siteApiClient_1.default(constants_1.SITE_API_URI);
function requestAllocationGet(siteId, accessToken) {
    return new Promise(function (resolve, reject) {
        client.getAllServices(siteId, accessToken).then(function (data) {
            var allocations = data.allocations.map(function (x) {
                return toAllocation(x, data.site);
            });
            resolve({ site: data.site, licenseAllowances: allocations });
        }).catch(function (err) {
            reject(err);
        });
    });
}
exports.requestAllocationGet = requestAllocationGet;
function requestNewAllocationGet(siteId, accessToken) {
    return new Promise(function (resolve, reject) {
        var req = client.getNewAllocation(siteId, accessToken);
        req.then(function (data) {
            resolve(data);
        }).catch(function (err) {
            reject(err);
        });
    });
}
exports.requestNewAllocationGet = requestNewAllocationGet;
function requestAllocationPost(allocation, accessToken) {
    allocation.id = 0;
    return new Promise(function (resolve, reject) {
        var req = client.addAllocation(allocation, accessToken);
        req.then(constants_1.handleErrors).then(function (data) {
            resolve(toAllocationResponse(data));
        }).catch(function (err) { return reject(err); });
    });
}
exports.requestAllocationPost = requestAllocationPost;
function requestAllocationPut(allocation, accessToken) {
    return new Promise(function (resolve, reject) {
        var req = client.updateAllocation(allocation, accessToken).then(function (data) { return resolve(data); }).catch(function (err) {
            reject(err);
        });
    });
}
exports.requestAllocationPut = requestAllocationPut;
function requestAllocationDelete(allocation, accessToken) {
    return new Promise(function (resolve, reject) {
        var req = client.deleteAllocation(allocation, accessToken).then(function (r) {
            resolve(allocation);
        }).catch(function (err) {
            reject(err);
        });
    });
}
exports.requestAllocationDelete = requestAllocationDelete;
function toAllocation(data, site) {
    return {
        id: data.id,
        siteId: site.id,
        site: site,
        expirationDateUtc: { value: data.expirationDateUtc, valid: true },
        licensableService: data.licensableService,
        productOrderNumber: { value: data.poNumber, valid: true },
        totalAssetAllocation: { value: data.totalAssetAllocation, valid: true },
        isBeingEdited: false,
    };
}
function toAllocationResponse(data) {
    var allocationResponse = {
        id: data.id,
        siteId: data.siteId,
        site: data.site,
        expirationDateUtc: { value: data.expirationDateUtc, valid: true },
        licensableService: data.licensableService,
        productOrderNumber: { value: data.poNumber, valid: true },
        totalAssetAllocation: { value: data.totalAssetAllocation, valid: true },
        isBeingEdited: false,
        discriminator: ''
    };
    return allocationResponse;
}


/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__(25);
var siteApiClient_1 = __webpack_require__(88);
var file_saver_1 = __webpack_require__(920);
var moment = __webpack_require__(0);
var client = new siteApiClient_1.default(constants_1.SITE_API_URI);
function requestLicenseFile(siteName, siteId, accessToken) {
    return new Promise(function (resolve, reject) {
        client.getLicenseFile(siteId, accessToken).then(function (r) { return r.blob(); }).then(function (data) {
            file_saver_1.saveAs(data, getFileName(siteName));
        }).catch(function (err) {
            reject(err);
        });
    });
}
exports.requestLicenseFile = requestLicenseFile;
function getFileName(siteName) {
    return siteName + '_Licenses_' + moment().format('YYYY_MM_DD_HH_mm') + '.zip';
}


/***/ }),

/***/ 646:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var UserDataServiceClass = (function () {
    function UserDataServiceClass() {
        this.basePath = environmentSettings.apiUrl + "Users";
    }
    UserDataServiceClass.prototype.getUsers = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            var response, json;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendRequest(user, '', 'GET')];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        return [2 /*return*/, json];
                    case 3: return [2 /*return*/, Promise.reject("System error: " + response.status + " " + response.statusText)];
                }
            });
        });
    };
    UserDataServiceClass.prototype.getUserById = function (userId, user) {
        return __awaiter(this, void 0, void 0, function () {
            var response, json;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendRequest(user, "/" + userId, 'GET')];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        return [2 /*return*/, json];
                    case 3: return [2 /*return*/, Promise.reject("System error: " + response.status + " " + response.statusText)];
                }
            });
        });
    };
    UserDataServiceClass.prototype.createUser = function (newUser, user) {
        return __awaiter(this, void 0, void 0, function () {
            var response, json;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendRequestBody(user, '', 'POST', newUser)];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        return [2 /*return*/, json];
                    case 3: return [2 /*return*/, Promise.reject("System error: " + response.status + " " + response.statusText)];
                }
            });
        });
    };
    UserDataServiceClass.prototype.updateUser = function (updatedUser, user) {
        return __awaiter(this, void 0, void 0, function () {
            var response, json;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendRequestBody(user, '', 'PUT', updatedUser)];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        return [2 /*return*/, json];
                    case 3: return [2 /*return*/, Promise.reject("System error: " + response.status + " " + response.statusText)];
                }
            });
        });
    };
    UserDataServiceClass.prototype.deleteUser = function (userId, user) {
        return __awaiter(this, void 0, void 0, function () {
            var response, json;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendRequest(user, "/" + userId, 'DELETE')];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        return [2 /*return*/, json];
                    case 3: return [2 /*return*/, Promise.reject("System error: " + response.status + " " + response.statusText)];
                }
            });
        });
    };
    UserDataServiceClass.prototype.sendRequest = function (user, url, httpMethod) {
        var headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user.access_token);
        headers.append('pragma', 'no-cache');
        headers.append('cache-control', 'no-cache');
        headers.append('access-control-allow-methods', 'GET, HEAD, POST, PUT, PATCH, DELETE, OPTIONS');
        return fetch("" + this.basePath + url, { headers: headers, method: httpMethod, cache: 'no-store' });
    };
    UserDataServiceClass.prototype.sendRequestBody = function (user, url, httpMethod, body) {
        var headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user.access_token);
        headers.append('pragma', 'no-cache');
        headers.append('cache-control', 'no-cache');
        headers.append('Content-Type', 'application/json');
        headers.append('access-control-allow-methods', 'GET, HEAD, POST, PUT, PATCH, DELETE, OPTIONS');
        return fetch("" + this.basePath + url, { headers: headers, method: httpMethod, cache: 'no-store', body: JSON.stringify(body) });
    };
    return UserDataServiceClass;
}());
exports.UserDataService = new UserDataServiceClass();
exports.default = exports.UserDataService;


/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__(25);
var moment = __webpack_require__(0);
function getCommonHeaders(accessToken) {
    return [
        ['Authorization', "Bearer " + accessToken],
        ['Accept', 'application/json'],
        ['Content-Type', 'application/json']
    ];
}
function get(uri, accessToken) {
    var init = {
        method: 'GET',
        headers: getCommonHeaders(accessToken)
    };
    return fetch(uri, init)
        .then(function (data) { return data.json(); });
}
function getStream(uri, accessToken) {
    var init = {
        method: 'GET',
        headers: [
            ['Authorization', "Bearer " + accessToken],
            ['Accept', 'application/json'],
            ['Content-Type', 'application/octet-stream']
        ]
    };
    return fetch(uri, init)
        .then(function (data) { return data; });
}
function post(uri, body, accessToken) {
    var postBody = {
        method: 'POST',
        headers: getCommonHeaders(accessToken),
        body: body
    };
    var response = fetch(uri, postBody);
    return response;
}
function put(uri, body, accessToken) {
    var putBody = {
        method: 'PUT',
        headers: getCommonHeaders(accessToken),
        body: body
    };
    var response = fetch(uri, putBody);
    return response;
}
function remove(uri, accessToken) {
    var body = {
        method: 'DELETE',
        headers: getCommonHeaders(accessToken)
    };
    var response = fetch(uri, body);
    return response;
}
function toServerBody(server) {
    return JSON.stringify({
        id: server.id,
        serverName: server.description.value,
        siteId: server.siteId,
        selectedOperationalUsage: server.operationalUseType,
        availableOperationalUsages: constants_1.AVAILABLE_OPERATIONAL_USAGES,
        hardwareId: server.serverId.value,
        discriminator: 'ConfigurableServer'
    });
}
// TODO: Modify this to pass all relevant data when getting the info from servis
function toSiteBody(site) {
    return JSON.stringify({
        servIsId: site.servIsId,
        siteName: site.name,
        owner: site.customer,
        regionName: site.region,
    });
}
function toServiceInstanceBody(serviceInstance) {
    return JSON.stringify({
        allocatedAssets: serviceInstance.allocatedAssets.value,
        siteId: serviceInstance.siteId,
        serverId: serviceInstance.serverId,
        id: serviceInstance.id,
        selectedService: serviceInstance.selectedServiceType,
        discriminator: 'ConfigurableService'
    });
}
function toAllocationBody(allocation) {
    return JSON.stringify({
        id: allocation.id,
        siteId: allocation.siteId,
        licensableService: allocation.licensableService,
        site: allocation.site,
        poNumber: allocation.productOrderNumber.value,
        totalAssetAllocation: allocation.totalAssetAllocation.value,
        expirationDateUtc: moment(allocation.expirationDateUtc.value),
        discriminator: 'ConfigurableAllocation'
    });
}
var SiteApiClient = (function () {
    function SiteApiClient(baseUri) {
        this.baseUri = baseUri;
    }
    SiteApiClient.prototype.getOperationalUsages = function (accessToken) {
        return get(this.baseUri + "Servers/OperationalUsages", accessToken);
    };
    SiteApiClient.prototype.getAllServers = function (siteId, accessToken) {
        return get(this.baseUri + "Sites/" + siteId + "/Servers/Allowances", accessToken);
    };
    SiteApiClient.prototype.getServIsSite = function (servIsId, accessToken) {
        return get(this.baseUri + "Sites/GetSite?servIsId=" + servIsId, accessToken);
    };
    SiteApiClient.prototype.registerSite = function (site, accessToken) {
        return post(this.baseUri + "Sites", toSiteBody(site), accessToken);
    };
    SiteApiClient.prototype.updateSite = function (siteId, servIsId, accessToken) {
        return put(this.baseUri + "Sites?id=" + siteId + "&servIsId=" + servIsId, '', accessToken);
    };
    SiteApiClient.prototype.addServer = function (server, accessToken) {
        return post(this.baseUri + "Sites/" + server.siteId + "/Servers", toServerBody(server), accessToken);
    };
    SiteApiClient.prototype.updateServer = function (server, accessToken) {
        return put(this.baseUri + "Sites/" + server.siteId + "/Servers/" + server.id, toServerBody(server), accessToken);
    };
    SiteApiClient.prototype.deleteServer = function (server, accessToken) {
        return remove(this.baseUri + "Sites/" + server.siteId + "/Servers/" + server.id, accessToken);
    };
    SiteApiClient.prototype.deleteService = function (serviceInstance, accessToken) {
        return remove(this.baseUri + "Sites/" + serviceInstance.siteId + "/Servers/" + serviceInstance.serverId + "/Services/" + serviceInstance.id, accessToken);
    };
    SiteApiClient.prototype.addService = function (serviceInstance, accessToken) {
        return post(this.baseUri + "Sites/" + serviceInstance.siteId + "/Servers/" + serviceInstance.serverId + "/Services", toServiceInstanceBody(serviceInstance), accessToken);
    };
    SiteApiClient.prototype.updateService = function (serviceInstance, accessToken) {
        return put(this.baseUri + "Sites/" + serviceInstance.siteId + "/Servers/" + serviceInstance.serverId + "/Services/" + serviceInstance.id, toServiceInstanceBody(serviceInstance), accessToken);
    };
    SiteApiClient.prototype.getAllServices = function (siteId, accessToken) {
        return get(this.baseUri + "Sites/" + siteId + "/SiteAllocations", accessToken);
    };
    SiteApiClient.prototype.addAllocation = function (allocation, accessToken) {
        return post(this.baseUri + "Sites/" + allocation.siteId + "/SiteAllocations", toAllocationBody(allocation), accessToken);
    };
    SiteApiClient.prototype.updateAllocation = function (allocation, accessToken) {
        return put(this.baseUri + "Sites/" + allocation.siteId + "/SiteAllocations/" + allocation.id, toAllocationBody(allocation), accessToken);
    };
    SiteApiClient.prototype.deleteAllocation = function (allocation, accessToken) {
        return remove(this.baseUri + "Sites/" + allocation.siteId + "/SiteAllocations/" + allocation.id, accessToken);
    };
    SiteApiClient.prototype.getNewAllocation = function (siteId, accessToken) {
        return get(this.baseUri + "Sites/" + siteId + "/SiteAllocations/New", accessToken);
    };
    SiteApiClient.prototype.getLicenseFile = function (siteId, accessToken) {
        return getStream(this.baseUri + "Sites/" + siteId + "/SiteLicenses", accessToken);
    };
    return SiteApiClient;
}());
exports.SiteApiClient = SiteApiClient;
exports.default = SiteApiClient;


/***/ }),

/***/ 910:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 911:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 912:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[1033]);


// WEBPACK FOOTER //
// bundle.7930af39e7f0713c2d05.js